// Thunks extracted from ClassRoomModule.js

import _ from "lodash";
import update from "immutability-helper";
import React from "react";
import {
  createAssignmentMutation,
  deleteAssignmentMutation,
  updateAssignmentMutation,
  updateStateForAssignmentMutation,
  editStudentAssignmentSubmissionMutation,
  updateElementRemarkMutation,
  editStudentAssignmentMutation,
  assignmentBulkActionMutation,
  createEntityEventTrackingMutation,
  createMicrosoftAnonymousAccessLinkMutation,
  createAssignmentBulkAlertMessageMutation,
  addAssignmentActivityMutation,
  createAiEvaluationMutation,
  retryAssignmentStudentTemplateMutation,
  changeAssessmentTypeMutation,
  deleteAssessmentToolResponseMutation,
  createAiAssessmentEvaluationMutation,
  updateLockedStateMutation,
  createShortUrlMutation,
  createIbPypElementRatingsWithoutValueMutation,
  bulkUpdateToddleDocMessagesMutation,
} from "../ClassRoomMutation";
import { bulkAssignmentGradeRatingsMutation } from "Gradebook/modules/GradebookMutations";
import {
  getCourseAssignmentStateWiseCountQuery,
  getStudentTodosQuery,
  getStudentAssignmentDetailsQuery,
  downloadInsightsDataQuery,
  getAssignmentDetailsQuery,
  getCourseAssignmentStateWiseCountV2Query,
  getOrganizationAssignmentStateWiseCountV2Query,
  getAssignedStudentsQuery,
  getStudentAssignmentQuery,
  getTeacherTasksQuery,
  getCourseAssignmentFeedWithoutAssignedStudentQuery,
  getAssignmentSummaryCountQuery,
  getLearningCourseDetailsQuery,
  getUserCoursesV2BasicDetailsQuery,
  getStudentAiEvaluationJobStatusQuery,
  getToddleDocAttachmentQueryV2,
  getToddleDocValueQuery,
} from "../ClassRoomQuery";
import {
  getCourseAssignmentFeedFromCache,
  getCourseAssignmentStateWiseCountFromCache,
  writeCourseAssignmentFeedFromCache,
  writeCourseAssignmentStateWiseCountInCache,
  writeStudentAssigmentSubmissionInCache,
  getStudentAssignmentDetailsFromCache,
  writeStudentAssignmentDetailsInCache,
  getAssignedStudentsForAIEvaluation,
  getStudentAssignmentFromCache,
  writeStudentAssignmentInCache,
  writeAssignmentFeedWithoutAssignedStudentsItemToCache,
  getCourseAssignmentFeedWithoutAssignedStudentFromCache,
  writeCourseAssignmentFeedWithoutAssignedStudentInCache,
  getTeacherTasksQueryFromCache,
  writeTeacherTasksQueryInCache,
} from "../ClassRoomGraphqlHelpers";
import { getCourseGenericFoldersQuery } from "Course/modules/CourseQuery";
import { getOrganizationAssignmentsProgressSummaryQuery } from "ProgressSummary/modules/ProgressSummaryQuery";
import { getOrgProgressSummaryVariables } from "ProgressSummary/modules/Utils";
import {
  getGradebookAllAssessmentsVariables,
  getCoursePrimaryGradeIdFromCache,
  getGradebookAssignmentsVariables,
  getGradebookAssignmentsFromCache,
  writeGradebookAssignmentsToCache,
} from "Gradebook/modules/GradebookGraphqlHelpers";
import {
  getCourseGenericFoldersFromCache,
  writeCourseGenericFoldersInCache,
  getCourseDetailsFromCache,
} from "Course/modules/CourseGraphqlHelpers";
import { getPlannerTemplateFromCache } from "modules/CommonGraphqlHelpers";
import client from "lib/apolloClient/client";
import { recordEvent } from "lib/eventTracker";
import {
  goToRelativeRoute,
  downloadFromUrl,
  checkTermsExistsForCurrentCurriculumProgram,
  setProgress,
  updateAIConversation,
  removeProgressElement,
} from "modules/Services";
import {
  updateField,
  flushPendingFieldUpdates,
} from "modules/FieldUpdateThunks";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  goToPlatformHomeFeatureRoute,
  goToBack,
} from "modules/NavigationModule";
import {
  getStringFromArray,
  generateRandomId,
  dispatchError,
  getQueryUpdatedQueryString,
  isUserTypeStaff,
} from "Utils";
import { getConversationsQuery } from "AppComponents/ChatContainer/modules/ChatContainerQuery";
import { getStudentTasksFilterCountQuery } from "Todos/modules/TodosQueries";
import {
  getStudentWiseRatingsQuery,
  getOrganizationAssignmentsGradebookQuery,
  getGradebookAssignmentsQuery,
  getGradebookSingleAssignmentQuery,
} from "Gradebook/modules/GradebookQueries";
import {
  getIBGradeScaleRatingFromScore,
  getAssignmentDetailsQueryVariables,
  getIsAITutorEnabled,
  getIsStudentAssignmentRevampEnabled,
  getStaffCourseDetailsQueryVariables,
  getFilteredCoursesBasedOnViewOrManagePermission,
  getAssignmentConsumingParentModulesPermission,
  getStandardRubricCalculatedScore,
  getAssignmentFeedDisplaySettings,
  getScoreValueElementRatings,
} from "../utils";
import {
  getTimeTrackingEventsFromLocalStorage,
  removeTimeTrackingEventsFromLocalStorage,
} from "./ClassRoomUtils";
import { INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT } from "./ClassRoomConstants";
import ACLStore from "lib/aclStore";
import {
  writeOrganizationAssignmentsInCache,
  getOrganizationAssignmentsProgressSummaryFromCache,
} from "ProgressSummary/modules/ProgressSummaryGraphqlHelpers";
import { evaluateAITutorConversation } from "AppComponents/AITutorChatWrapper/modules/AITutorChatModule";
import { ASSESSMENT_TOOLS } from "@toddle-edu/common-utils";
import { DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX } from "Constants";
import moment from "moment";
import { EXCLUDED_ASSESSMENT_TYPES } from "store/static";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  ASSESSMENT_GRADE_BOUNDARY,
  GROUP_TYPE_WORKSHEET,
  CUSTOM_WEIGHTS,
  TODDLE_LIBRARY,
  ASSESSMENT_TYPE_AI_TUTOR,
  CREATE_AI_TUTOR,
  AI_TUTOR_CREATION,
  AI_TUTOR,
  ASSESSMENT,
  LEARNING_ENGAGEMENT,
  SCORE,
  STANDARD_BASED_RUBRIC,
  SCORE_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
  MYP_OBJECTIVE_RUBRIC,
  RUBRIC,
  COMMENT,
  CHECKLIST,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
  SINGLE_POINT_RUBRIC,
  DP_ASSESSMENT_RUBRIC,
  ELEMENT_TYPE_PYP_BENCHMARK,
  CREATE_WORKSHEET,
} from "Constants/stringConstants";
import {
  THEATRE_VIEW_NAVIGATION_EVENT,
  THEATRE_VIEW_KEYBOARD_NAVIGATION,
  THEATRE_VIEW_UI_BUTTON_NAVIGATION,
} from "Course/Constants/StringConstants";
import {
  getCurriculumProgramFreeStatus,
  getCurrentAssessmentTypes,
} from "Platform/modules/PlatformModule";
import {
  createAssessment,
  updateAssessment,
} from "Assessments/modules/AssessmentModule";
import {
  deletePypElementRating,
  createIbPypElementRating,
  createIbPypElementRatingV2,
  handleAssessmentToolResponseInCache,
} from "AssessmentEvaluation/modules/AssessmentEvaluationModule";
import { ASSIGNMENTS_ACCESS_PERMISSION } from "Constants/permissionConstants";
import { getFieldValue } from "Assessments/modules/Utils";
import { getInitialStep } from "Assessments/modules/AssessmentModule/AssessmentUtils";
import { ASSESSMENT_TYPE_WORKSHEET } from "Worksheet/modules/WorksheetConstants";
import {
  getCurrentCurriculumProgramType,
  getSelectedCurriculumId,
  getSelectedAcademicYearId,
  getOrganizationId,
  getUserId,
  getUserType,
  getUserEntityType,
  getSelectedCourseId,
  getAcademicYearId,
  getChildId,
  getIsParent,
  getIsStudent,
} from "modules/CommonSelectors";
import { getCleanDefaultStudentNameOrderPreference } from "Utils/GetFormattedStudentName";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getGradeCalculationMethodSetting } from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentSetup/modules/utils";
import { getSettingValue } from "modules/PermissionModule";
import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";
import { checkIsDateSame } from "Utils/DateTimeHelpers";
import { getUserCoursesVars } from "Course/modules/CourseModule";
import { updateRecentWorksheetId } from "ToddleLibrary/modules/ToddleLibraryModule";
import { updateScoreToolData } from "modules/AssessmentTool/AssessmentToolModule";
import { createClassMaterialsResources } from "ClassMaterials/modules/ClassMaterialsModule";
import { getClassMaterialsFeedReadAndWriteHelpers } from "ClassMaterials/modules/ClassMaterialsGraphqlHelpers";
import { getClassMaterialsFeedVariablesMemoized } from "ClassMaterials/modules/utils";
import { updateAssignmentMutation as updateAssignmentV2Mutation } from "ClassMaterials/modules/ClassMaterialsMutations";
import { Sentry } from "services/sentry";
import {
  getUnitPlanResourceLibraryFromCache,
  writeUnitPlanResourceLibraryInCache,
} from "UnitPlans/modules/UnitPlanGraphqlHelpers";
import {
  updateLatestWorkbookCreationTimestamp,
  updateLatestWorksheetCreationTimestamp,
} from "lib/intercom";
import {
  getClassMaterialsFeedQuery,
  getOrganizationResourceMultiNodeQuery,
} from "ClassMaterials/modules/ClassMaterialsQuery";
import ACLStorage from "lib/aclService";
import { isAITutorMarketingEnabled } from "Platform/modules/PlatformUtils";
import { getIsGroupByCategoryView } from "AssessmentsGradebookV2/components/ConfigureViews/components/DisplaySettings/DisplaySettingsUtils";
import {
  TOOL_TYPE_TO_ELEMENT_TYPE_MAPPING,
  RATED_LEARNING_GOALS_ELEMENT_TYPE,
} from "../Constants";
import { getCommonFilterCountVariablesMemoize } from "Todos/modules/Utils";
import {
  getIsCourseBasedGradingEnabled,
  getIsLearningCoursesEnabled,
  getIsSubjectBasedGradingEnabled,
} from "Teacher/routes/LearningCourses/modules/Utils";
import { getStaffCoursesV2BasicDetailsQuery } from "Teacher/modules/TeacherQuery";
import { getCourseFlowMultiNodeQuery } from "CourseFlow/modules/CourseFlowQueries";
import { getEntityFlowResourceMultiNodeQuery } from "UnitFlowV3/modules/LearningCourseFlow/Query";
import { getUnitFlowFeedVariablesMemoized } from "UnitFlowV3/modules/LearningCourseFlow/utils";
import {
  getSelectedLearningCourseId,
  checkIfTermExistsForCurrentLearningCourse,
} from "LearningCourse/modules/Utils";
import { getIsBlueprintSyncHistoryV2Enabled } from "LearningCourse/modules/LearningCourseUtils";
import { shouldShowImportFromToddleLibrary } from "ToddleLibrary/modules/ToddleLibraryUtils";
import {
  getAssignmentAndDeadlineQuery,
  getAssignmentAndDeadlineStatusWiseCountQuery,
} from "AppComponents/AssignmentAndDeadlines/modules/AssignmentAndDeadlineQuery";
import {
  getADMQueryVariables,
  getADMStatusWiseCountQueryVariables,
} from "AppComponents/AssignmentAndDeadlines/modules/Utils";
import {
  getAssignmentAndDeadlineQueryFromCache,
  writeAssignmentAndDeadlineQueryInCache,
} from "AppComponents/AssignmentAndDeadlines/modules/AssignmentAndDeadlineGraphqlHelpers";
import {
  getAssessmentCourseDetailsFromCache,
  getAssessmentLearningCourseDetailsFromCache,
  getAssessmentLinkedAssignmentsFromCache,
  writeAssessmentLinkedAssignmentsInCache,
} from "Assessments/modules/AssessmentGraphqlHelpers";
import {
  getAssessmentToolItem,
  getGradeScaleValuesFromGradeScaleTool,
  calculateGradeScaleRatingFromOtherTool,
} from "Utils/AssessmentToolHelpers";
import { getIsAssessmentTypeConfigurationEnabled } from "Utils/ACLStoreUtils";
import { checkAssignmentContributionMethodValue } from "GradingSetupV2/modules/Utils";
import WalkMeManager, { WALKME_PAGE_NAMES } from "lib/walkMe";
import {
  updateHighlightTaskId,
  setElementRatingMutationInProgress,
  setAIConversationAnalysingStatus,
} from "./ClassRoomActions";
import {
  getIsMediaManagerRoute,
  getCourseFlowFeedQueryVariables,
  getMutationParams,
  getDynamicAssignmentTypeMapping,
  getAssignmentBulkActionToastMessage,
  getAssignmentResponseWarningsMemoized,
  getRefetchQueriesForGradebook,
  getRefetchQueryForPracticalActivities,
  updateTeacherRemarkInCache,
  updateScoreElementRatingInCache,
  removeElementRatingFromCache,
  getQueryFilters,
  getTeacherTasksQueryFiltersMemoize,
  getFamilyStudentFeedQueryFilters,
  getCourseAssignmentStateWiseCountV2Filters,
  getOrganizationAssignmentStateWiseCountV2Filters,
  getCourseGenericFoldersAssignmentFilters,
  importFromUnitOption,
  handleLocalToolResponseUpdate,
  processAIRemarkApproval,
  validateAssessmentLink,
  removeAssignmentFromCache,
  addAssignmentToCache,
} from "./ClassRoomUtils";
import {
  ASSIGNMENT_TYPE_MAPPING,
  PYP_ASSIGNMENT_TYPE_MAPPING,
  MYP_ASSIGNMENT_TYPE_MAPPING,
  UBD_ASSIGNMENT_TYPE_MAPPING,
} from "./ClassRoomConstants";
import {
  updateWeeklyPlannerSectionItems,
  setAssignmentModalData,
} from "LearningCourseClassPlanners/modules/ClassPlannersModule";

// Thunks
export const getStudentAssignmentMicrosoftLink = ({
  submissionId,
  attachmentId,
  showProgress = true,
}) => {
  return async (dispatch, getState) => {
    try {
      if (showProgress) {
        const progressObject = {
          id: attachmentId,
          attachment: {
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            type: "FILE",
          },
          status: "DOWNLOAD",
          startTime: new Date(),
          hideToastProgress: false,
        };
        dispatch(setProgress(progressObject));
      }
      const res = await client.mutate({
        mutation: createMicrosoftAnonymousAccessLinkMutation,
        variables: {
          input: {
            submissionId,
            attachmentId,
          },
        },
      });
      return _.get(res, [
        "data",
        "platform",
        "createMicrosoftAnonymousAccessLink",
        "url",
      ]);
    } catch (e) {
      if (!e.networkError) {
        Sentry.captureMessage(`MICROSOFT_DOCUMENT_LINK`, {
          level: "info",
          extra: {
            submissionId,
            attachmentId,
            ...e,
          },
        });
      }
    } finally {
      if (showProgress) {
        dispatch(removeProgressElement({ id: attachmentId }));
      }
    }
  };
};

export const evaluateSubmissionsForAITutor = params => {
  return async (dispatch, getState) => {
    try {
      const {
        assignedStudents,
        course,
        assessmentDetails,
        assignmentId,
      } = params;

      const state = getState();

      // check for ai tutor assessment type
      const assessmentType = assessmentDetails?.allFields
        ? getFieldValue({
            fields: assessmentDetails?.allFields,
            uid: "assessmentType",
          })
        : _.get(assessmentDetails, "assessmentType.value");

      if (assessmentType !== ASSESSMENT_TYPE_AI_TUTOR) return;

      // fetch assigned students if it has not ai conversations
      let assignedStudentsDataForEvaluation = assignedStudents;

      const isStudentWithoutAIConversation = _.some(
        assignedStudents,
        student => !_.has(student, "aiConversation")
      );

      if (isStudentWithoutAIConversation && assignmentId) {
        const {
          assignedStudents: assignedStudentsData,
        } = await getAssignedStudentsForAIEvaluation({
          id: assignmentId,
        });
        assignedStudentsDataForEvaluation = assignedStudentsData;
      }

      // fetch course id from cache if not passed from props
      const courseId = _.get(state, "teacher.selected_class.selected_course");
      const academicYearId = getSelectedAcademicYearId(state);
      const courseGradeFilters = {
        academicYearId,
      };

      const courseData =
        course ||
        getCourseDetailsFromCache({
          id: courseId,
          courseGradeFilters,
        });

      // create ai conversation input for evaluation
      const createAIConversationInput = _.reduce(
        _.castArray(assignedStudentsDataForEvaluation),
        (result, student) => {
          const aiConversation = _.get(student, "aiConversation") || {};
          const isSubmitted = _.get(student, "isSubmitted", false);

          if (_.isEmpty(aiConversation) || isSubmitted) return result;

          return [
            ...result,
            { ...aiConversation, studentAssignmentId: student?.id },
          ];
        },
        []
      );

      // Generating AI Evaluation
      if (!_.isEmpty(createAIConversationInput)) {
        const evaluateAITutorConversationPromises = _.reduce(
          createAIConversationInput,
          (acc, aiConversation) => {
            const toolResponses = _.get(
              aiConversation,
              "analysisToolEvaluation.0.toolResponses",
              []
            );

            const totalMessageCount = aiConversation?.messages?.totalCount;

            if (_.isEmpty(toolResponses) && totalMessageCount > 1) {
              dispatch(
                setAIConversationAnalysingStatus({
                  [aiConversation?.id]: true,
                })
              );
              acc.push(
                dispatch(
                  evaluateAITutorConversation({
                    course: courseData,
                    entityId: aiConversation?.studentAssignmentId,
                    aiConversationId: aiConversation?.id,
                    assessmentDetails,
                  })
                )
              );
            }

            return acc;
          },
          []
        );

        if (!_.isEmpty(evaluateAITutorConversationPromises)) {
          await Promise.all(evaluateAITutorConversationPromises);
          dispatch(setAIConversationAnalysingStatus({}));
        }
      }

      // update aiConversation metadata for all the submissions
      if (!_.isEmpty(createAIConversationInput)) {
        const aiConversationPromises = _.map(
          createAIConversationInput,
          aiConversation => {
            return dispatch(
              updateAIConversation({
                input: {
                  id: aiConversation?.id,
                  metadata: {
                    ...aiConversation?.metadata,
                    isSubmissionClosed: true,
                  },
                },
              })
            );
          }
        );

        Promise.all(aiConversationPromises);
      }
    } catch (e) {
      console.error(e);
    }
  };
};

export const assignmentBulkAction = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    try {
      const {
        creationSource = "CLASSROOM",
        studentWiseRatingsVariables = {},
        assignedStudents,
        course,
        assessmentDetails,
        ...restParams
      } = params;

      const refetchQueries = [];

      if (!_.isEmpty(courseId)) {
        switch (creationSource) {
          case "CLASSROOM": {
            refetchQueries.push(
              {
                query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
                variables: { courseId, ...getQueryFilters({ filters }) },
              },
              {
                query: getCourseGenericFoldersQuery,
                variables: {
                  courseId,
                  folderType: "CLASSROOM",
                  assignmentFilters: {
                    academicTermIds: _.sortBy(
                      _.get(filters, "academicTermIds", [])
                    ),
                    createdBy:
                      _.get(filters, "createdBy", "ALL") !== "ALL"
                        ? userId
                        : undefined,
                  },
                },
              }
            );

            refetchQueries.push({
              query: getCourseAssignmentStateWiseCountV2Query,
              variables: {
                courseId,
                filters: getCourseAssignmentStateWiseCountV2Filters({
                  filters,
                }),
              },
            });

            break;
          }
          case "GRADEBOOK": {
            if (!_.isEmpty(studentWiseRatingsVariables)) {
              refetchQueries.push({
                query: getStudentWiseRatingsQuery,
                variables: studentWiseRatingsVariables,
              });
            }
          }
        }
      }

      const response = await client.mutate({
        mutation: assignmentBulkActionMutation,
        variables: restParams,
        refetchQueries,
      });

      // generate evaluation for ai tutor conversation
      if (!_.isEmpty(assignedStudents)) {
        dispatch(
          evaluateSubmissionsForAITutor({
            assignedStudents,
            course,
            assessmentDetails,
            assignmentId: restParams?.id,
          })
        );
      }

      const actionResponse = _.get(
        response,
        "data.platform.assignmentBulkAction",
        []
      );
      if (!_.isEmpty(_.get(actionResponse, "warning"))) {
        const errorCode = _.get(actionResponse, "warning.errorCode");
        dispatch(
          setToastMsg({
            msg: errorCode,
          })
        );
        return false;
      }
      return true;
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      throw e;
    }
  };
};

export const assignmentBulkActionV2 = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const organizationId = _.get(userInfo, "org_id");
    const courseIds = _.get(filters, "courseIds", []);
    const userType = getUserType();
    const curriculumProgramType = getCurrentCurriculumProgramType(state);

    try {
      const {
        creationSource = "CLASSROOM",
        studentWiseRatingsVariables = {},
        action,
        isTeacherEvaluationEnabled,
        course,
        assignedStudents,
        assessmentDetails,
        organizationResourceId,
        ...restParams
      } = params;

      const refetchQueries = [];

      if (!_.isEmpty(courseId) || !_.isEmpty(courseIds)) {
        switch (creationSource) {
          case "CLASSROOM":
          case "CLASSROOM_DETAILS": {
            if (!_.isEmpty(courseId)) {
              refetchQueries.push(
                {
                  query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
                  variables: { courseId, ...getQueryFilters({ filters }) },
                },
                {
                  query: getCourseGenericFoldersQuery,
                  variables: {
                    courseId,
                    folderType: "CLASSROOM",
                    assignmentFilters: {
                      academicTermIds: _.sortBy(
                        _.get(filters, "academicTermIds", [])
                      ),
                      createdBy:
                        _.get(filters, "createdBy", "ALL") !== "ALL"
                          ? userId
                          : undefined,
                    },
                  },
                },
                {
                  query: getCourseAssignmentStateWiseCountV2Query,
                  variables: {
                    courseId,
                    filters: getCourseAssignmentStateWiseCountV2Filters({
                      filters,
                    }),
                  },
                }
              );
            }
            break;
          }
          case "CLASS_STREAM_REVIEW_DETAILS":
          case "CLASS_STREAM_REVIEW": {
            refetchQueries.push(
              {
                query: getTeacherTasksQuery,
                variables: getTeacherTasksQueryFiltersMemoize({
                  filters,
                  academicYearId: getSelectedAcademicYearId(state),
                  userId: getUserId(state),
                  userType: getUserType(state),
                }),
              },
              {
                query: getOrganizationAssignmentStateWiseCountV2Query,
                variables: {
                  organizationId,
                  filters: getOrganizationAssignmentStateWiseCountV2Filters({
                    filters,
                  }),
                },
              }
            );
            break;
          }
          case "GRADEBOOK": {
            if (!_.isEmpty(studentWiseRatingsVariables)) {
              refetchQueries.push({
                query: getStudentWiseRatingsQuery,
                variables: studentWiseRatingsVariables,
              });
            }
            break;
          }
          case "CLASS_MATERIALS": {
            const classMaterialsFilters = _.get(
              state,
              "classMaterials.filters",
              {}
            );

            const feedQueryVariables = getClassMaterialsFeedVariablesMemoized({
              courseId,
              filters: classMaterialsFilters,
              userInfo,
              userType,
              curriculumType: curriculumProgramType,
            });

            refetchQueries.push({
              query: getOrganizationResourceMultiNodeQuery,
              variables: {
                ...feedQueryVariables,
                ids: [organizationResourceId],
              },
            });
            break;
          }
        }
      }

      const awaitRefetchQueries = _.includes(
        ["CLASS_MATERIALS"],
        creationSource
      );

      const response = await client.mutate({
        mutation: assignmentBulkActionMutation,
        variables: restParams,
        refetchQueries,
        awaitRefetchQueries,
      });

      if (creationSource === "GRADEBOOK") {
        const id = _.get(params, "id");
        await dispatch(refetchGradebookAssignmentAndUpdateCache({ id }));
      }

      // generate evaluation for ai tutor conversation
      if (!_.isEmpty(assignedStudents)) {
        dispatch(
          evaluateSubmissionsForAITutor({
            assignedStudents,
            assessmentDetails,
            course,
            assignmentId: restParams?.id,
          })
        );
      }

      const actionResponse = _.get(
        response,
        "data.platform.assignmentBulkAction",
        []
      );
      if (!_.isEmpty(_.get(actionResponse, "warning"))) {
        const errorCode = _.get(actionResponse, "warning.errorCode");
        dispatch(
          setToastMsg({
            msg: errorCode,
          })
        );
        return false;
      }
      dispatch(
        setToastMsg({
          msg: getAssignmentBulkActionToastMessage({ action }),
          locale_params: [
            {
              key: "label",
              value: isTeacherEvaluationEnabled
                ? "classRoom:evaluated"
                : "classRoom:completed",
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
      return true;
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      throw e;
    }
  };
};

export const getCourseFlowQueryToRefetch = () => {
  return (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo({ portalType: "PLANNER" });
    const courseFlowResourceData = _.get(
      state,
      "classRoom.courseFlowResourceData",
      {}
    );

    if (_.isEmpty(courseFlowResourceData)) {
      return {};
    }

    const resourceId = _.get(courseFlowResourceData, "resourceId");
    const source = _.get(courseFlowResourceData, "source");

    switch (source) {
      case "COURSE_FLOW": {
        const feedQueryVariables = getCourseFlowFeedQueryVariables({
          state,
        });
        return {
          query: getCourseFlowMultiNodeQuery,
          variables: {
            ...feedQueryVariables,
            ids: [resourceId],
          },
        };
      }
      case "TIMETABLE_PLANNER":
        return;
      default: {
        const unitPlanId = _.get(state, "planner.unitPlanData.unitPlanId", "");
        const filters = _.get(state, "unitFlow.filters", {});
        const learningCourseId = _.get(
          state,
          "planner.unitPlanData.learningCourseId",
          null
        );
        const curriculumType = _.get(
          state,
          "platform.currentCurriculumProgram.type",
          null
        );
        const feedQueryVariables = getUnitFlowFeedVariablesMemoized({
          unitPlanId,
          filters,
          userInfo,
          curriculumType,
          learningCourseId,
        });
        return {
          query: getEntityFlowResourceMultiNodeQuery,
          variables: {
            ...feedQueryVariables,
            ids: [resourceId],
          },
        };
      }
    }
  };
};

export const createAssignment = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const courseId = state.teacher.selected_class.selected_course;
    const filters = state.classRoom.filters;
    const courseFlowData = _.get(state, "assessment.courseFlowData", {});
    const {
      importedLeId,
      portalType,
      creationMode,
      courses,
      leId,
      setNewDataIds,
      isScheduledAssignment,
      creationSource,
      pageName,
      isUnitDelinked,
      isDuplicateAssignment,
      assessmentContainsWorkbook,
    } = params || {};

    const userType = userInfo.user_type;
    const userId = userInfo.id;

    const isToddleLibraryPortal = state.login.activeTab === TODDLE_LIBRARY;
    const isWorksheet = _.includes(
      ["CREATE_WORKSHEET", "CREATE_WORKSHEET_FROM_TODDLE_LIBRARY"],
      creationMode
    );

    const isPracticalActivity = creationSource === "PRACTICAL_ACTIVITIES";
    const isROEP = _.isEqual(
      creationSource,
      "RECORD_OF_EXPERIMENTAL_PROGRAMMES"
    );
    const isGradebook = _.includes(
      ["GRADEBOOK", "CLASS_PROGRESS_SUMMARY"],
      creationSource
    );

    const isLeFromToddleLibrary = _.includes(
      [
        "IMPORT_IN_CLASS",
        "IMPORT_LE_FROM_TODDLE_LIBRARY",
        "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS",
      ],
      creationMode
    );

    const isFromClassMaterials = creationSource === "CLASS_MATERIALS";

    const isLeImport =
      isLeFromToddleLibrary ||
      _.includes(
        ["IMPORT_LE", "IMPORT_LE_FROM_LE_LIBRARY", "ASSIGN_TO_CLASS"],
        creationMode
      );

    const refetchQueries = [];

    if (!_.isEmpty(courseId)) {
      const refetchFeed =
        !_.includes(["GRADEBOOK", "CLASS_PROGRESS_SUMMARY"], creationSource) &&
        (!_.includes(
          [
            "IMPORT_IN_CLASS",
            "IMPORT_LE_FROM_LE_LIBRARY",
            "ASSIGN_TO_CLASS",
            "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS",
          ],
          creationMode
        ) ||
          creationSource === "CLASSROOM");

      if (refetchFeed) {
        refetchQueries.push(
          {
            query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
            variables: {
              courseId,
              ...getQueryFilters({ filters }),
              portalType,
            },
          },
          {
            query: getCourseGenericFoldersQuery,
            variables: {
              courseId,
              folderType: "CLASSROOM",
              portalType,
              assignmentFilters: {
                academicTermIds: _.sortBy(
                  _.get(filters, "academicTermIds", [])
                ),
                createdBy:
                  _.get(filters, "createdBy", "ALL") !== "ALL"
                    ? userId
                    : undefined,
              },
            },
          }
        );

        refetchQueries.push({
          query: getCourseAssignmentStateWiseCountV2Query,
          variables: {
            courseId,
            filters: getCourseAssignmentStateWiseCountV2Filters({
              filters,
            }),
            portalType,
          },
        });
      }

      if (creationSource === "CLASS_PROGRESS_SUMMARY") {
        const curriculumType = _.get(
          state,
          "platform.currentCurriculumProgram.type"
        );

        const filters = _.get(state, "classProgressSummaryV2.filters", {});

        const variables = getOrgProgressSummaryVariables({
          filters,
          organizationId: userInfo.org_id,
          courseId,
          curriculumType,
        });

        refetchQueries.push({
          query: getOrganizationAssignmentsProgressSummaryQuery,
          variables,
        });
      }

      if (creationSource === "GRADEBOOK") {
        refetchQueries.push(
          ...getRefetchQueriesForGradebook({ courseId, getState })
        );
      }
      if (isPracticalActivity || isROEP) {
        refetchQueries.push(
          getRefetchQueryForPracticalActivities({
            courseId,
            getState,
            isROEP: isROEP,
          })
        );
      }
    }

    if (getIsLearningCoursesEnabled()) {
      const queryToRefetch = dispatch(getCourseFlowQueryToRefetch());
      if (!_.isEmpty(queryToRefetch)) {
        refetchQueries.push(queryToRefetch);
      }
    }

    try {
      const response = await client.mutate({
        mutation: createAssignmentMutation,
        variables: {
          ...getMutationParams({
            params,
            creationMode,
            isUnitDelinked,
            isDuplicateAssignment,
            isFromClassMaterials,
          }),
          courses: _.map(courses, item => _.omit(item, ["title"])),
          studentIds: userType == "student" ? userId : null,
          source: _.join(
            _.filter([creationSource, pageName], item => item),
            "_"
          ),
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });

      const assignmentsResponse = _.get(
        response,
        "data.platform.createAssignmentV2",
        []
      );

      if (!_.isEmpty(_.get(assignmentsResponse, ["0", "warning"]))) {
        const {
          errorText,
          locale_params,
        } = getAssignmentResponseWarningsMemoized({ assignmentsResponse });
        dispatch(
          setToastMsg({
            msg: errorText,
            timeOut: 5000,
            locale_params,
          })
        );
        return false;
      }
      const assignments = _.map(assignmentsResponse, item => item.response);
      const assignmentLength = _.get(assignments, "length", 0);
      const assessmentName = _.get(assignments, "0.content.title.value", "");

      if (isToddleLibraryPortal && isWorksheet) {
        dispatch(updateRecentWorksheetId(params.leId));
      }

      const courseNames = getStringFromArray({
        nameArray: _.map(courses, item => item.title),
      });
      if (isLeImport) {
        let showToastWithLink =
          _.includes(
            [
              "IMPORT_IN_CLASS",
              "IMPORT_LE_FROM_LE_LIBRARY",
              "ASSIGN_TO_CLASS",
              "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS",
            ],
            creationMode
          ) && ACLStorage.getModuleSettingsValue(ASSIGNMENTS_ACCESS_PERMISSION);

        const showToastWithLinkForLibrary =
          isToddleLibraryPortal &&
          creationMode === "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS";

        showToastWithLink = showToastWithLink || showToastWithLinkForLibrary;

        const onToastClick = showToastWithLink
          ? () => {
              dispatch(
                goToPlatformHomeFeatureRoute({
                  courseId: _.get(courses[0], "courseId", ""),
                  mode: "view",
                  isOpenInNewTab: true,
                  route:
                    assignmentLength == 1
                      ? `classroom/classroom-details/${_.get(
                          assignments[0],
                          "id",
                          ""
                        )}`
                      : `classroom`,
                })
              );
            }
          : null;
        if (isFromClassMaterials) {
          dispatch(
            setToastMsg({
              msg: "classMaterials:toast_msg_for_assignment_import",
              type: "success",
            })
          );
        } else {
          dispatch(
            setToastMsg({
              msg: showToastWithLink
                ? "toastMsgs:copy_le_successfully_imported_classroom_with_link"
                : "toastMsgs:copy_le_successfully_imported_classroom",
              type: "success",
              locale_params: [
                {
                  key: "entityName",
                  value: assessmentName,
                  isPlainText: true,
                },
                {
                  key: "courseLabel",
                  value:
                    _.get(courses, "length", 0) == 1 ? `class` : "class_plural",
                  isPlainText: false,
                },
                {
                  key: "courseNames",
                  value: courseNames,
                  isPlainText: true,
                },
              ],
              onClick: onToastClick,
              variant: "inline",
              primaryAction: showToastWithLink && {
                label: "toastMsgs:view",
                onClick: onToastClick,
              },
              isClosable: _.includes(
                [
                  "IMPORT_IN_CLASS",
                  "IMPORT_LE_FROM_LE_LIBRARY",
                  "ASSIGN_TO_CLASS",
                  "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS",
                ],
                creationMode
              ),
            })
          );
        }
      } else {
        const labelKey = isPracticalActivity
          ? "project:practical_activity"
          : isGradebook
          ? "common:task"
          : isToddleLibraryPortal && isWorksheet
          ? "common:worksheet"
          : "common:assignment";
        const actionType = isScheduledAssignment ? "scheduled" : "created";
        const actionKey = `toastMsgs:${actionType}`;

        const isWorksheetCreationFromToddleLibrary =
          isToddleLibraryPortal &&
          creationMode === "CREATE_WORKSHEET_FROM_TODDLE_LIBRARY";

        const onToastClick = () => {
          if (isWorksheetCreationFromToddleLibrary) {
            dispatch(
              goToPlatformHomeFeatureRoute({
                courseId: _.get(courses, "0.courseId", ""),
                isOpenInNewTab: true,
                route:
                  assignmentLength == 1
                    ? `classroom/classroom-details/${_.get(
                        assignments,
                        "0.id",
                        ""
                      )}`
                    : `classroom`,
              })
            );
          }
        };

        if (!_.get(params, "hideSuccessToast", false)) {
          dispatch(
            setToastMsg({
              msg: isWorksheetCreationFromToddleLibrary
                ? "toastMsgs:worksheet_added_successfully"
                : "toastMsgs:action_successfully",
              locale_params: [
                {
                  key: "label",
                  value: labelKey,
                  isPlainText: false,
                },
                {
                  key: "action",
                  value: actionKey,
                  isPlainText: false,
                },
              ],
              type: "success",
              onClick: onToastClick,
              variant: "inline",
              primaryAction: isWorksheetCreationFromToddleLibrary && {
                label: "toastMsgs:edit_worksheet",
                onClick: onToastClick,
              },
              isClosable: isWorksheetCreationFromToddleLibrary,
            })
          );
        } else if (_.get(params, "showDraftToast", false)) {
          dispatch(
            setToastMsg({
              type: "success",
              msg: "toastMsgs:assessment_successfully_saved_as_draft",
              locale_params: [
                { key: "label", value: assessmentName, isPlainText: true },
              ],
            })
          );
        }
      }

      if (
        isFromClassMaterials &&
        _.get(params, "isSharedWithClassMaterial", false)
      ) {
        _.forEach(assignmentsResponse, ({ response }) => {
          const assignmentCourseId = _.get(response, "course.id");
          const assignedStudents = _.get(response, "assignedStudents", []);

          const studentIds = _.map(assignedStudents, "student.id");
          const assignmentId = _.get(response, "id");

          const sharingState = _.get(response, "state.state", "DRAFT");

          if (assignmentId) {
            dispatch(
              createClassMaterialsResources({
                resources: [
                  { itemId: assignmentId, resourceType: "ASSIGNMENT" },
                ],
                setNewDataIds,
                courseId: assignmentCourseId,
                sharingState,
                studentIds,
              })
            );
          }
        });
      }

      if (creationSource == "CLASS_PLANNER") {
        const added = _.map(assignmentsResponse, ({ response }) => {
          return { id: _.get(response, "id"), itemType: "ASSIGNMENT" };
        });

        const assignmentModalData = _.get(
          state,
          "classPlanner.assignmentModalData",
          null
        );

        const sectionId = _.get(assignmentModalData, "sectionId");
        const classPlannerId = _.get(assignmentModalData, "classPlannerId");

        if (!_.isEmpty(added) && sectionId && classPlannerId) {
          dispatch(
            updateWeeklyPlannerSectionItems({
              sectionId,
              classPlannerId,
              editItems: {
                added,
              },
            })
          );
        }
        dispatch(setAssignmentModalData(null));
      }

      const timestamp = moment().unix();
      if (isWorksheet) {
        //send latest worksheet creation timstamp update to intercom
        updateLatestWorksheetCreationTimestamp(timestamp);
      }
      if (assessmentContainsWorkbook) {
        //send latest workbook creation in submission templates timstamp update to intercom
        updateLatestWorkbookCreationTimestamp(timestamp);
      }

      return true;
    } catch (e) {
      console.error(e);
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      throw e;
    }
  };
};

export const updateAssignment = params => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const state = getState();
    const courseId = getState().teacher.selected_class.selected_course;
    const filters = getState().classRoom.filters;
    const userId = _.get(userInfo, "id");
    const userType = _.get(userInfo, "user_type");
    const organizationId = _.get(userInfo, "org_id");
    const academicYearId = getSelectedAcademicYearId(state);

    const { creationSource, showToast = true, creationSubSource } =
      params || {};
    const isPracticalActivity = creationSource === "PRACTICAL_ACTIVITIES";
    const isROEP = _.isEqual(
      creationSource,
      "RECORD_OF_EXPERIMENTAL_PROGRAMMES"
    );
    const isFromClassMaterials = creationSource === "CLASS_MATERIALS";
    const isFromLearingCourseFlow = creationSource === "COURSE_FLOW";
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
    const isSourceClassRoomDetails =
      location.href.search("classroom-details") > -1;
    const removedCourseIds = _.get(params, "courses.removedCourseIds", []);
    const isClassesRemoved = !_.isEmpty(removedCourseIds);
    const redirectToPreviousScreen =
      isLearningCoursesEnabled && isClassesRemoved && isSourceClassRoomDetails;

    const refetchQueries = [];
    let awaitRefetchQueries = false;
    if (creationSource === "CLASSROOM") {
      // update assignment case from clasroom or classroom details inside class
      const isClassRoomRoute = location.href.search("classroom") > -1;
      if (!_.isEmpty(courseId) && isClassRoomRoute) {
        // refetch assignment details when updated the assignment from all-submissions or media-manager route
        if (
          _.includes(
            ["CLASS_STREAM_REVIEW_DETAILS", "CLASSROOM_DETAILS"],
            creationSubSource
          ) &&
          !redirectToPreviousScreen
        ) {
          const academicYearId = getAcademicYearId(getState());

          refetchQueries.push({
            query: getAssignmentDetailsQuery,
            variables: getAssignmentDetailsQueryVariables({
              assignmentId: params?.id,
              curriculumProgramType: getCurrentCurriculumProgramType(
                getState()
              ),
              userType,
              userId,
              academicYearId,
            }),
          });
        }

        refetchQueries.push(
          {
            query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
            variables: { courseId, ...getQueryFilters({ filters }) },
          },
          {
            query: getCourseGenericFoldersQuery,
            variables: {
              courseId,
              folderType: "CLASSROOM",
              assignmentFilters: {
                academicTermIds: _.sortBy(
                  _.get(filters, "academicTermIds", [])
                ),
                createdBy:
                  _.get(filters, "createdBy", "ALL") !== "ALL"
                    ? userId
                    : undefined,
              },
            },
          }
        );

        refetchQueries.push({
          query: getCourseAssignmentStateWiseCountV2Query,
          variables: {
            courseId,
            filters: getCourseAssignmentStateWiseCountV2Filters({
              filters,
            }),
          },
        });
      } else {
        // update assignment case from classroom todo and classroom details outside class
        refetchQueries.push(
          {
            query: getTeacherTasksQuery,
            variables: getTeacherTasksQueryFiltersMemoize({
              filters,
              academicYearId: getSelectedAcademicYearId(state),
              userId: getUserId(state),
              userType: getUserType(state),
            }),
          },
          {
            query: getOrganizationAssignmentStateWiseCountV2Query,
            variables: {
              organizationId,
              filters: getOrganizationAssignmentStateWiseCountV2Filters({
                filters,
              }),
            },
          }
        );
      }
    } else if (!_.isEmpty(courseId)) {
      switch (creationSource) {
        case "CLASS_PROGRESS_SUMMARY": {
          const curriculumType = _.get(
            getState(),
            "platform.currentCurriculumProgram.type"
          );

          const filters = _.get(
            getState(),
            "classProgressSummaryV2.filters",
            {}
          );

          const variables = getOrgProgressSummaryVariables({
            filters,
            organizationId: userInfo.org_id,
            courseId,
            curriculumType,
          });

          refetchQueries.push({
            query: getOrganizationAssignmentsProgressSummaryQuery,
            variables,
          });
          break;
        }
        case "GRADEBOOK": {
          if (creationSubSource !== "GRADEBOOK_ASSIGNMENT_POPOVER") {
            refetchQueries.push(
              ...getRefetchQueriesForGradebook({ courseId, getState })
            );
          }
          break;
        }
        case "PRACTICAL_ACTIVITIES":
        case "RECORD_OF_EXPERIMENTAL_PROGRAMMES": {
          refetchQueries.push(
            getRefetchQueryForPracticalActivities({
              courseId,
              getState,
              isROEP: isROEP,
            })
          );
          break;
        }
      }
    }

    if (getIsLearningCoursesEnabled()) {
      const queryToRefetch = dispatch(getCourseFlowQueryToRefetch());
      if (!_.isEmpty(queryToRefetch)) {
        refetchQueries.push(queryToRefetch);
        awaitRefetchQueries = true;
      }
    }

    const curriculumType = getCurrentCurriculumProgramType(state);
    const isDP = _.isEqual(CURRICULUM_TYPE_DP, curriculumType);

    const assignmentContent = _.get(params, "assignmentContent", {});
    const assignmentSubjectLevelField = _.find(
      _.get(assignmentContent, "fields", []),
      { uid: "subjectLevel" }
    );

    try {
      if (
        isDP &&
        isFromClassMaterials &&
        !_.isEmpty(assignmentSubjectLevelField) &&
        !_.isEmpty(assignmentContent)
      ) {
        const assignmentSubjectLevels =
          _.get(assignmentSubjectLevelField, "value", []) ?? [];

        // If subject level is not selected then select all subject levels
        if (assignmentSubjectLevels?.length === 0) {
          const courseGradeFilters = {
            academicYearId,
          };
          const course = getCourseDetailsFromCache({
            id: courseId,
            courseGradeFilters,
          });

          const genericTags = _.get(course, "genericTags", []);
          const courseSubjectLevels = _.filter(genericTags, {
            type: "SUBJECT_LEVEL",
          });
          const subjectLevels = _.map(courseSubjectLevels, "id");

          await dispatch(
            updateAssessment({
              assessmentId: _.get(assignmentContent, "id", ""),
              hasAddRemoveValues: true,
              fieldUID: "subjectLevel",
              id: _.get(assignmentSubjectLevelField, "id", ""),
              value: subjectLevels,
              valuesToAdd: subjectLevels,
              valuesToRemove: [],
            })
          );
        }
      }
      let variables = {
        ..._.omit(params, [
          "creationSource",
          "pageName",
          "showToast",
          "isBackdateAssignment",
        ]),
        userArchivedFilters: {
          academicYearId: getSelectedAcademicYearId(state),
        },
      };

      if (isFromClassMaterials) {
        variables = {
          input: {
            ..._.omit(variables, [
              "contentType",
              "isScheduledAssignment",
              "creationSubSource",
              "assignmentContent",
              "userArchivedFilters",
            ]),
          },
          unreadMessageCountFilters: {
            includeItemTypesV2: INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT,
          },
        };
      }
      const response = await client.mutate({
        mutation: isFromClassMaterials
          ? updateAssignmentV2Mutation
          : updateAssignmentMutation,
        variables,
        refetchQueries,
        awaitRefetchQueries,
      });

      const assignmentsResponse = _.get(
        response,
        "data.platform.updateAssignmentV2",
        []
      );

      const isRemovedFromClassMaterials = !_.get(
        assignmentsResponse,
        "response.isSharedWithClassMaterial"
      );

      if (isFromClassMaterials) {
        if (isRemovedFromClassMaterials) {
          const curriculumType = _.get(
            getState(),
            "platform.currentCurriculumProgram.type"
          );

          // if the assignment has been removed from class material, remove it from cache
          const filters = _.get(state, "classMaterials.filters");
          const feedQueryVariables = getClassMaterialsFeedVariablesMemoized({
            courseId,
            filters,
            userInfo,
            userType,
            curriculumType,
          });

          const {
            getClassMaterialsFeed,
            writeClassMaterialsFeed,
          } = getClassMaterialsFeedReadAndWriteHelpers();

          const classMaterialsFeed = getClassMaterialsFeed(feedQueryVariables)
            ?.organizationResourcesFlatFeed;

          if (!_.isEmpty(classMaterialsFeed)) {
            const updatedClassMaterialsFeed = {
              ...classMaterialsFeed,
              edges: _.filter(
                _.get(classMaterialsFeed, "edges", []),
                item => _.get(item, "node.item.id") !== params.id
              ),
            };

            writeClassMaterialsFeed({
              courseId,
              data: updatedClassMaterialsFeed,
              variables: feedQueryVariables,
            });
          }
        } else {
          // Update assignment data in cache to show updated data in class flow
          writeAssignmentFeedWithoutAssignedStudentsItemToCache({
            id: params.id,
            data: { ..._.get(assignmentsResponse, "response", {}) },
          });
        }
      }

      if (
        !_.isEmpty(_.get(assignmentsResponse, ["0", "warning"])) ||
        !_.isEmpty(_.get(assignmentsResponse, "warning"))
      ) {
        const {
          errorText,
          locale_params,
        } = getAssignmentResponseWarningsMemoized({ assignmentsResponse });
        dispatch(
          setToastMsg({
            msg: errorText,
            timeOut: 5000,
            locale_params,
          })
        );
        return false;
      }
      if (showToast) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:action_successfully",
            locale_params: [
              {
                key: "label",
                value: isPracticalActivity
                  ? "project:practical_activity"
                  : isFromClassMaterials
                  ? "common:assignment"
                  : "common:post",
                isPlainText: false,
              },
              {
                key: "action",
                value: `toastMsgs:updated`,
                isPlainText: false,
              },
            ],
            type: "success",
          })
        );
      }

      if (redirectToPreviousScreen) {
        const isLinksRoute = location.href.search("links") > -1;
        if (isLinksRoute) {
          //if it is a links route, it will be coming from notifications/emails so go back to homepage
          dispatch(
            goToRelativeRoute({ route: "../../../../..", type: "replace" })
          );
        } else {
          dispatch(goToRelativeRoute({ route: "../../..", type: "replace" }));
        }
      }

      return true;
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      throw e;
    }
  };
};

export const deleteAssignment = (id, creationSource = "CLASSROOM") => {
  return async (dispatch, getState) => {
    const state = getState();
    const academicYearId = getSelectedAcademicYearId(state);
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    const itemDetails = getCourseAssignmentFeedFromCache({
      courseId,
      ...getQueryFilters({ filters, academicYearId }),
    });
    const excludedAssessmentTypes = EXCLUDED_ASSESSMENT_TYPES;
    const stateWiseCountDetails = getCourseAssignmentStateWiseCountFromCache({
      courseId,
      excludedAssessmentTypes,
    });

    await client.mutate({
      mutation: deleteAssignmentMutation,
      variables: {
        id,
      },

      update: (
        cache,
        {
          data: {
            platform: { deleteAssignment },
          },
        }
      ) => {
        if (
          deleteAssignment &&
          !_.isEmpty(itemDetails) &&
          !_.isEmpty(stateWiseCountDetails)
        ) {
          const { assignmentStateTab, folderTopic } = filters;

          //calculate and update updated assignments
          const items = _.get(itemDetails, "assignments", {});
          const itemEdges = _.filter(
            _.get(items, "edges", []),
            item => item.node.id != id
          );
          const updatedItemDetails = {
            ...itemDetails,
            assignments: {
              ...items,
              edges: itemEdges,
              totalCount: _.get(items, "totalCount", 1) - 1,
            },
          };
          writeCourseAssignmentFeedFromCache({
            courseId,
            ...getQueryFilters({ filters }),
            data: updatedItemDetails,
            userArchivedFilters: { academicYearId },
          });

          //calculate and update updated stateWiseCount
          const stateWiseCount = _.map(
            _.get(stateWiseCountDetails, "assignments.stateWiseCount", []),
            countDetails => {
              if (countDetails.state == assignmentStateTab)
                return {
                  ...countDetails,
                  count: _.get(countDetails, "count", 1) - 1,
                };
              else return countDetails;
            }
          );
          const updatedStateWiseCountDetails = {
            ...stateWiseCountDetails,
            assignments: {
              stateWiseCount: stateWiseCount,
            },
          };

          writeCourseAssignmentStateWiseCountInCache({
            courseId,
            data: updatedStateWiseCountDetails,
            excludedAssessmentTypes,
          });

          //if folder is not ALL, update generic folder count as well
          if (folderTopic !== "ALL") {
            const courseGenericFolderDetails = getCourseGenericFoldersFromCache(
              {
                courseId,
                folderType: "CLASSROOM",
                assignmentFilters: getCourseGenericFoldersAssignmentFilters({
                  filters,
                }),
              }
            );

            const updatedGenericFolders = _.map(
              _.get(courseGenericFolderDetails, "genericFolders", []),
              genericFolder => {
                if (genericFolder.id == folderTopic) {
                  const updatedStateWiseCountOfFolder = _.map(
                    _.get(genericFolder, "typeDetails.stateWiseCount", []),
                    countDetails => {
                      if (countDetails.state == assignmentStateTab)
                        return update(countDetails, {
                          count: { $set: _.get(countDetails, "count", 1) - 1 },
                        });
                      else return countDetails;
                    }
                  );
                  return update(genericFolder, {
                    typeDetails: {
                      stateWiseCount: { $set: updatedStateWiseCountOfFolder },
                    },
                  });
                } else return genericFolder;
              }
            );

            const updatedCourseGenericFolderDetails = update(
              courseGenericFolderDetails,
              { genericFolders: { $set: updatedGenericFolders } }
            );
            writeCourseGenericFoldersInCache({
              courseId,
              folderType: "CLASSROOM",
              data: updatedCourseGenericFolderDetails,
            });
          }
        }
      },
    });
  };
};

export const deleteAssignmentV2 = ({
  id,
  creationSource = "CLASSROOM",
  organizationAssignmentVariables,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const organizationId = _.get(userInfo, "org_id");

    const refetchQueries = [];
    switch (creationSource) {
      case "GRADEBOOK": {
        if (!_.isEmpty(courseId)) {
          refetchQueries.push(
            ...getRefetchQueriesForGradebook({ courseId, getState })
          );
        }
        break;
      }
      case "CLASS_STREAM_REVIEW":
      case "CLASS_STREAM_REVIEW_DETAILS": {
        refetchQueries.push(
          {
            query: getTeacherTasksQuery,
            variables: getTeacherTasksQueryFiltersMemoize({
              filters,
              academicYearId: getSelectedAcademicYearId(state),
              userId: getUserId(state),
              userType: getUserType(state),
            }),
          },
          {
            query: getOrganizationAssignmentStateWiseCountV2Query,
            variables: {
              organizationId,
              filters: getOrganizationAssignmentStateWiseCountV2Filters({
                filters,
              }),
            },
          }
        );
        break;
      }
      case "CLASSROOM":
      case "CLASSROOM_DETAILS": {
        if (!_.isEmpty(courseId)) {
          refetchQueries.push(
            {
              query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
              variables: { courseId, ...getQueryFilters({ filters }) },
            },
            {
              query: getCourseGenericFoldersQuery,
              variables: {
                courseId,
                folderType: "CLASSROOM",
                assignmentFilters: {
                  academicTermIds: _.sortBy(
                    _.get(filters, "academicTermIds", [])
                  ),
                  createdBy:
                    _.get(filters, "createdBy", "ALL") !== "ALL"
                      ? getUserId(state)
                      : undefined,
                },
              },
            },
            {
              query: getCourseAssignmentStateWiseCountV2Query,
              variables: {
                courseId,
                filters: getCourseAssignmentStateWiseCountV2Filters({
                  filters,
                }),
              },
            }
          );
        }
      }
    }

    try {
      await client.mutate({
        mutation: deleteAssignmentMutation,
        variables: { id },
        refetchQueries,
        awaitRefetchQueries: creationSource === "GRADEBOOK",
        update: (cache, { data: { platform: deleteAssignment } }) => {
          if (deleteAssignment && creationSource === "CLASS_PROGRESS_SUMMARY") {
            const orgAssignments = getOrganizationAssignmentsProgressSummaryFromCache(
              organizationAssignmentVariables
            );

            const assignmentEdges = _.get(
              orgAssignments,
              "assignments.edges",
              []
            );

            const filteredAssignments = _.filter(
              assignmentEdges,
              ({ node }) => {
                return node?.id !== id;
              }
            );

            writeOrganizationAssignmentsInCache({
              variables: organizationAssignmentVariables,
              data: {
                id: _.get(getState(), "login.userInfo.org_id", ""),
                assignments: {
                  edges: filteredAssignments,
                  __typename: "AssignmentConnection",
                },
                __typename: "Organization",
              },
            });
          }
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:action_successfully",
          locale_params: [
            {
              key: "label",
              value: "common:task",
              isPlainText: false,
            },
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
          type: "success",
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateStateForAssignment = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const userType = _.get(userInfo, "user_type");
    const userId = _.get(userInfo, "id");
    const isUserStaff = isUserTypeStaff({ userType });

    const refetchQueries = [];

    if (courseId) {
      if (isUserStaff) {
        refetchQueries.push({
          query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
          variables: {
            courseId,
            ...getQueryFilters({ filters }),
          },
        });
      } else {
        refetchQueries.push({
          query: getStudentTodosQuery,
          variables: {
            courseIds: courseId,
            ...getFamilyStudentFeedQueryFilters({
              filters,
              userId,
              userType,
            }),
          },
        });
      }
      refetchQueries.push(
        {
          query: getCourseAssignmentStateWiseCountQuery,
          variables: { courseId },
        },
        {
          query: getCourseGenericFoldersQuery,
          variables: {
            courseId,
            folderType: "CLASSROOM",
            assignmentFilters: {
              academicTermIds: _.sortBy(_.get(filters, "academicTermIds", [])),
              createdBy:
                _.get(filters, "createdBy", "ALL") !== "ALL"
                  ? userId
                  : undefined,
            },
          },
        }
      );
    }

    await client.mutate({
      mutation: updateStateForAssignmentMutation,
      variables: {
        ...params,
        studentIds: userType == "student" ? userId : null,
      },
      awaitRefetchQueries: true,
      refetchQueries,
    });
  };
};

export const updateStateForAssignmentV2 = params => {
  return dispatch => {
    const { shouldUseCacheUpdateFlow = false, ...restParams } = params;

    if (shouldUseCacheUpdateFlow) {
      return dispatch(updateStateForAssignmentWithCacheUpdate(restParams));
    } else {
      return dispatch(updateStateForAssignmentWithRefetch(restParams));
    }
  };
};

// Uses refetch for all queries
const updateStateForAssignmentWithRefetch = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const userType = _.get(userInfo, "user_type");
    const userId = _.get(userInfo, "id");
    const organizationId = _.get(userInfo, "org_id");
    const courseIds = _.get(filters, "courseIds", []);

    const {
      creationSource = "CLASSROOM",
      state: stateToSend,
      ...restParams
    } = params;

    const refetchQueries = [];
    if (!_.isEmpty(courseId) || !_.isEmpty(courseIds)) {
      switch (creationSource) {
        case "CLASS_STREAM_REVIEW_DETAILS":
        case "CLASS_STREAM_REVIEW": {
          refetchQueries.push({
            query: getTeacherTasksQuery,
            variables: getTeacherTasksQueryFiltersMemoize({
              filters,
              academicYearId: getSelectedAcademicYearId(state),
              userId: getUserId(state),
              userType: getUserType(state),
            }),
          });
          refetchQueries.push({
            query: getOrganizationAssignmentStateWiseCountV2Query,
            variables: {
              organizationId,
              filters: getOrganizationAssignmentStateWiseCountV2Filters({
                filters,
              }),
            },
          });
          break;
        }
        case "CLASSROOM":
        case "CLASSROOM_DETAILS": {
          if (!_.isEmpty(courseId)) {
            refetchQueries.push(
              {
                query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
                variables: {
                  courseId,
                  ...getQueryFilters({ filters }),
                },
              },
              {
                query: getCourseAssignmentStateWiseCountV2Query,
                variables: {
                  courseId,
                  filters: getCourseAssignmentStateWiseCountV2Filters({
                    filters,
                  }),
                },
              },
              {
                query: getCourseGenericFoldersQuery,
                variables: {
                  courseId,
                  folderType: "CLASSROOM",
                  assignmentFilters: {
                    academicTermIds: _.sortBy(
                      _.get(filters, "academicTermIds", [])
                    ),
                    createdBy:
                      _.get(filters, "createdBy", "ALL") !== "ALL"
                        ? userId
                        : undefined,
                  },
                },
              }
            );
          }
        }
      }
    }

    try {
      await client.mutate({
        mutation: updateStateForAssignmentMutation,
        variables: {
          ...restParams,
          state: stateToSend,
          studentIds: userType == "student" ? userId : null,
        },
        refetchQueries,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:assignment_moved_to_status",
          locale_params: [
            {
              key: "label",
              value:
                stateToSend === "ARCHIVED"
                  ? "classRoom:reviewed"
                  : "classRoom:to_review_with_hypen",
              isPlainText: false,
            },
          ],
          variant: "inline",
          type: "success",
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

// Uses cache updates with optimistic response and only refetches statewise count queries
const updateStateForAssignmentWithCacheUpdate = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const userEntityType = getUserEntityType();
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const filters = _.get(state, "classRoom.filters");
    const userType = _.get(userInfo, "user_type");
    const userId = _.get(userInfo, "id");
    const organizationId = _.get(userInfo, "org_id");
    const courseIds = _.get(filters, "courseIds", []);
    const orderByDirectionFilter = _.get(filters, "orderByDirection", "DESC");
    const orderByFilter = _.get(filters, "orderBy", "CREATED_AT");
    const selectedTab = _.get(
      state,
      "assignmentAndProject.selectedTab",
      "TO_REVIEW"
    );

    const {
      creationSource = "CLASSROOM",
      state: stateToSend,
      oldState = "",
      assignmentName = "",
      setIsAnimating = () => {},
      shouldSkipCacheUpdate = false,
      id: assignmentId,
      ...restParams
    } = params;

    let readCacheQueryFn = null;
    let writeCacheQueryFn = null;
    let queryVariables = null;
    let pathString = "";

    const refetchQueries = [];
    let undoRefetchQueries = [];
    if (!_.isEmpty(courseId) || !_.isEmpty(courseIds)) {
      switch (creationSource) {
        case "CLASS_STREAM_REVIEW_DETAILS":
        case "CLASS_STREAM_REVIEW": {
          readCacheQueryFn = getTeacherTasksQueryFromCache;
          writeCacheQueryFn = writeTeacherTasksQueryInCache;
          queryVariables = getTeacherTasksQueryFiltersMemoize({
            filters,
            academicYearId: getSelectedAcademicYearId(state),
            userId: getUserId(state),
            userType: getUserType(state),
          });
          pathString = "tasks";

          refetchQueries.push({
            query: getOrganizationAssignmentStateWiseCountV2Query,
            variables: {
              organizationId,
              filters: getOrganizationAssignmentStateWiseCountV2Filters({
                filters,
              }),
            },
          });

          undoRefetchQueries = [...refetchQueries];
          undoRefetchQueries.push({
            query: getTeacherTasksQuery,
            variables: queryVariables,
          });

          break;
        }
        case "CLASSROOM":
        case "CLASSROOM_DETAILS":
        case "GRADEBOOK": {
          readCacheQueryFn = getCourseAssignmentFeedWithoutAssignedStudentFromCache;
          writeCacheQueryFn = writeCourseAssignmentFeedWithoutAssignedStudentInCache;
          queryVariables = {
            courseId,
            ...getQueryFilters({ filters }),
          };
          pathString = "assignments";

          if (!_.isEmpty(courseId)) {
            refetchQueries.push(
              {
                query: getCourseAssignmentStateWiseCountV2Query,
                variables: {
                  courseId,
                  filters: getCourseAssignmentStateWiseCountV2Filters({
                    filters,
                  }),
                },
              },
              {
                query: getCourseGenericFoldersQuery,
                variables: {
                  courseId,
                  folderType: "CLASSROOM",
                  assignmentFilters: {
                    academicTermIds: _.sortBy(
                      _.get(filters, "academicTermIds", [])
                    ),
                    createdBy:
                      _.get(filters, "createdBy", "ALL") !== "ALL"
                        ? userId
                        : undefined,
                  },
                },
              }
            );
            undoRefetchQueries = [...refetchQueries];
            undoRefetchQueries.push({
              query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
              variables: queryVariables,
            });
          }
          break;
        }
        case "ASSIGNMENT_HOME_WIDGET": {
          readCacheQueryFn = getAssignmentAndDeadlineQueryFromCache;
          writeCacheQueryFn = writeAssignmentAndDeadlineQueryInCache;
          const displaySettingsValue = getAssignmentFeedDisplaySettings();
          const orderBy = _.get(
            displaySettingsValue,
            `PUBLISHED.orderByPreference`,
            orderByFilter
          );
          const orderByDirection = _.get(
            displaySettingsValue,
            `PUBLISHED.orderByDirectionPreference`,
            orderByDirectionFilter
          );

          queryVariables = getADMQueryVariables({
            userId,
            userEntityType,
            selectedTab,
            orderBy,
            orderByDirection,
            filters,
            INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT,
          });

          pathString = "tasks";

          refetchQueries.push({
            query: getAssignmentAndDeadlineStatusWiseCountQuery,
            variables: getADMStatusWiseCountQueryVariables({
              userId,
              userEntityType,
              selectedTab,
              academicYearId: getSelectedAcademicYearId(state),
              filters,
            }),
          });

          undoRefetchQueries = [...refetchQueries];
          undoRefetchQueries.push({
            query: getAssignmentAndDeadlineQuery,
            variables: queryVariables,
          });
          break;
        }
      }
    }

    let isUndoDone = false;

    const onUndoClick = async () => {
      try {
        if (isUndoDone) return;
        setIsAnimating(false);
        isUndoDone = true;
        client.mutate({
          mutation: updateStateForAssignmentMutation,
          variables: {
            ...restParams,
            id: assignmentId,
            state: oldState,
          },
          refetchQueries: undoRefetchQueries,
        });
      } catch (e) {
        if (e.networkError) {
          dispatch(setToastMsg("toastMsgs:no_internet_connection"));
        } else {
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        }
      }
    };

    let removedAssignmentData = null;

    if (!shouldSkipCacheUpdate) {
      removedAssignmentData = removeAssignmentFromCache({
        readCacheQueryFn,
        queryVariables,
        pathString,
        assignmentId,
        writeCacheQueryFn,
        courseId,
        userId,
      });
    }

    try {
      client.mutate({
        mutation: updateStateForAssignmentMutation,
        variables: {
          ...restParams,
          state: stateToSend,
          id: assignmentId,
          studentIds: userType == "student" ? userId : null,
        },
        refetchQueries,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:assignment_with_name_moved_to_status",
          locale_params: [
            {
              key: "assignmentName",
              value: assignmentName,
            },
            {
              key: "label",
              value:
                stateToSend === "ARCHIVED"
                  ? "classRoom:reviewed"
                  : "classRoom:to_review_with_hypen",
              isPlainText: false,
            },
          ],
          variant: "inline",
          primaryAction: {
            label: "toastMsgs:undo",
            onClick: onUndoClick,
          },
          type: "success",
        })
      );
    } catch (e) {
      if (!shouldSkipCacheUpdate && removedAssignmentData?.removedAssignment) {
        addAssignmentToCache({
          readCacheQueryFn,
          queryVariables,
          pathString,
          assignment: removedAssignmentData.removedAssignment,
          index: removedAssignmentData.removedIndex,
          prevAssignmentId: removedAssignmentData.prevAssignmentId,
          nextAssignmentId: removedAssignmentData.nextAssignmentId,
          writeCacheQueryFn,
          courseId,
          userId,
        });
      }
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const editStudentAssignmentSubmissionWithDebounce = params => {
  return async (dispatch, getState) => {
    dispatch(
      updateField({
        key: params.id,
        params,
        type: "STUDENT_ASSIGNMENT_SUBMISSION",
        isDebounce: true,
      })
    );
  };
};

export const editStudentAssignmentSubmission = ({
  mutationParams,
  refetchQueryParams,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const courseId = getSelectedCourseId(state);
    const filters = _.get(state, "todos.filters", {});
    const { activeDropdownCourseIdsArr, activeDropdownItemTypesArr } = filters;

    const filterCountVariables = {
      ...getCommonFilterCountVariablesMemoize({
        orgId: getOrganizationId(state),
      }),
      userId: getUserId(state),
      type: getUserEntityType(state),
      academicYearId: getSelectedAcademicYearId(state),
      courseIds: activeDropdownCourseIdsArr,
      entityTypes: activeDropdownItemTypesArr,
      studentIds: getIsParent(state) ? getChildId(state) : undefined,
    };

    const refetchQueries = [];
    if (refetchQueryParams) {
      refetchQueries.push(
        getIsStudentAssignmentRevampEnabled() &&
          getUserType(state) === "student"
          ? {
              query: getStudentAssignmentQuery,
              variables: refetchQueryParams,
            }
          : {
              query: getStudentAssignmentDetailsQuery,
              variables: refetchQueryParams,
            },
        {
          query: getStudentTasksFilterCountQuery,
          variables: filterCountVariables,
        }
      );
    }

    try {
      const response = await client.mutate({
        mutation: editStudentAssignmentSubmissionMutation,
        variables: mutationParams,
        awaitRefetchQueries: true,
        refetchQueries,
      });

      return { ...response, successful: true };
    } catch (e) {
      if (e.networkError) {
        return {
          successful: false,
          errors: ["toastMsgs:no_internet_connection"],
        };
      } else {
        return {
          successful: false,
          errors: ["toastMsgs:something_went_wrong"],
        };
      }
    }
  };
};

export const updateElementRemark = params => {
  return async (dispatch, getState) => {
    try {
      const { mutationVariables, refetchQueries } = params;
      await client.mutate({
        mutation: updateElementRemarkMutation,
        variables: {
          input: {
            ...mutationVariables,
          },
        },
        refetchQueries,
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const editStudentAssignment = params => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: editStudentAssignmentMutation,
        variables: params,
      });
      return { ...response, successful: true };
    } catch (e) {
      if (e.networkError) {
        return {
          successful: false,
          errors: ["toastMsgs:no_internet_connection"],
        };
      } else {
        return {
          successful: false,
          errors: ["toastMsgs:something_went_wrong"],
        };
      }
    }
  };
};

export const unHandStudentAssignmentSubmission = params => {
  return async (dispatch, getState) => {
    const { assignmentDetailsVariables } = params;

    const refetchQueries = [];

    if (!_.isEmpty(assignmentDetailsVariables)) {
      refetchQueries.push({
        query: getStudentAssignmentDetailsQuery,
        variables: assignmentDetailsVariables,
      });
    }

    try {
      const paramsToSend = { id: params.id, status: params.status };
      if (!_.isEmpty(_.get(params, "statusMessage.label", null))) {
        paramsToSend["statusMessage"] = params.statusMessage;
      }
      const response = await client.mutate({
        mutation: editStudentAssignmentSubmissionMutation,
        variables: paramsToSend,
        refetchQueries: [
          {
            query: getConversationsQuery,
            variables: { id: _.get(params, "statusMessage.parentId", "") },
          },
          ...refetchQueries,
        ],
      });
      return { ...response, successful: true };
    } catch (e) {
      if (e.networkError) {
        return {
          successful: false,
          errors: ["toastMsgs:no_internet_connection"],
        };
      } else {
        return {
          successful: false,
          errors: ["toastMsgs:something_went_wrong"],
        };
      }
    }
  };
};

export const updateAssignmentSubmissionState = ({
  changeIsLoading,
  submission,
  status,
  statusOnResponseUnsuccessful,
}) => {
  return async (dispatch, getState) => {
    try {
      const submissionId = _.get(submission, "id", "");
      changeIsLoading(true);
      const res = await dispatch(
        editStudentAssignmentSubmission({
          mutationParams: {
            id: submissionId,
            status,
          },
        })
      );
      changeIsLoading(false);

      if (!res.successful) {
        writeStudentAssigmentSubmissionInCache({
          id: submissionId,
          data: { ...submission, status: statusOnResponseUnsuccessful },
        });
        dispatch(setToastMsg(res.errors[0]));
      }
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const createEntityEventTracking = ({
  entityId,
  entityType,
  eventTime,
  eventType,
  duration = null,
  reason = null,
  debugMetadata = {},
  queryParams,
  callbackOnError,
  metadata = {},
}) => {
  return async (dispatch, getState) => {
    const isStudentAssignmentRevampEnabled = getIsStudentAssignmentRevampEnabled();
    const getStudentAssignmentDetails = isStudentAssignmentRevampEnabled
      ? getStudentAssignmentFromCache
      : getStudentAssignmentDetailsFromCache;
    const writeStudentAssignmentDetails = isStudentAssignmentRevampEnabled
      ? writeStudentAssignmentInCache
      : writeStudentAssignmentDetailsInCache;

    const oldStudentAssignmentDetails = getStudentAssignmentDetails(
      queryParams
    );
    const academicYearId = getSelectedAcademicYearId(getState());
    const eventsFromLocalStorage =
      eventType !== "PAUSE"
        ? getTimeTrackingEventsFromLocalStorage(entityId)
        : [];

    let currentEventInput = {
      entityId,
      entityType,
      eventTime,
      eventType,
      debugMetadata,
    };

    if (!_.isEmpty(metadata)) {
      _.set(currentEventInput, "metadata", metadata);
    }

    if (eventType === "RESUME") {
      currentEventInput = { ...currentEventInput, duration, reason };
    }

    let eventsToSend = [currentEventInput];
    let mutationResponse = [
      {
        id: generateRandomId(),
        eventType,
        eventTime,
        duration,
        reason,
        __typename: "EntityEventTrack",
      },
    ];

    if (!_.isEmpty(eventsFromLocalStorage)) {
      const filteredLocalEvents = _.filter(
        eventsFromLocalStorage,
        ({ eventTime: currentEventTime }) =>
          !checkIsDateSame({
            date1: currentEventTime,
            date2: eventTime,
            check: "seconds",
          })
      );

      eventsToSend = [...filteredLocalEvents, ...eventsToSend];
      mutationResponse = [
        ..._.map(
          filteredLocalEvents,
          ({ eventType, eventTime, duration = null, reason = null }) => {
            return {
              id: generateRandomId(),
              eventType,
              eventTime,
              duration,
              reason,
              __typename: "EntityEventTrack",
            };
          }
        ),
        ...mutationResponse,
      ];
    }

    if (getIsStudent()) {
      const allowedEventTypes = ["START", "RESUME", "PAUSE", "END"];
      eventsToSend = _.filter(eventsToSend, ({ eventType }) =>
        _.includes(allowedEventTypes, eventType)
      );
      mutationResponse = _.filter(mutationResponse, ({ eventType }) =>
        _.includes(allowedEventTypes, eventType)
      );
    }

    if (_.isEmpty(eventsToSend)) return;

    const refetchQueries = [];
    if (eventType === "END") {
      refetchQueries.push(
        isStudentAssignmentRevampEnabled
          ? { query: getStudentAssignmentQuery, variables: queryParams }
          : {
              query: getStudentAssignmentDetailsQuery,
              variables: queryParams,
            }
      );
    }

    try {
      const response = await client.mutate({
        mutation: createEntityEventTrackingMutation,
        variables: { input: eventsToSend },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            createEntityEventTracking: {
              response: mutationResponse,
              warning: null,
              __typename: "GenericCreateEntityEventTrackingResponse",
            },
          },
        },
        refetchQueries,
        awaitRefetchQueries: true,
        update: (
          cache,
          {
            data: {
              platform: {
                createEntityEventTracking: { response },
              },
            },
          }
        ) => {
          if (eventType !== "END") {
            const oldEvents = _.get(oldStudentAssignmentDetails, "events", []);
            const newEvents = [...oldEvents, ...response];

            setTimeout(() => {
              const studentAssignmentDetails = getStudentAssignmentDetails(
                queryParams
              );
              const newStudentAssignmentDetails = {
                ...studentAssignmentDetails,
                events: newEvents,
              };
              writeStudentAssignmentDetails({
                ...queryParams,
                data: newStudentAssignmentDetails,
                userArchivedFilters: { academicYearId },
              });
            });
          }
        },
      });

      if (eventType === "PAUSE" || !_.isEmpty(eventsFromLocalStorage)) {
        removeTimeTrackingEventsFromLocalStorage(entityId);
      }

      if (eventType === "END") {
        // * for `END` eventType, marking isSubmitted as `True` for syncing UI on submit action
        const updatedStudentAssignmentDetails = getStudentAssignmentDetails(
          queryParams
        );
        if (_.isObject(updatedStudentAssignmentDetails)) {
          writeStudentAssignmentDetails({
            ...queryParams,
            data: {
              ...updatedStudentAssignmentDetails,
              isSubmitted: true,
            },
            userArchivedFilters: { academicYearId },
          });
        }
      }

      return { ...response, successful: true };
    } catch (e) {
      callbackOnError?.();

      if (eventType !== "END") {
        setTimeout(() => {
          writeStudentAssignmentDetails({
            ...queryParams,
            data: oldStudentAssignmentDetails,
            userArchivedFilters: { academicYearId },
          });
        });
      }
      if (e.networkError) {
        return {
          successful: false,
          errors: ["toastMsgs:no_internet_connection"],
        };
      } else {
        return {
          successful: false,
          errors: ["toastMsgs:something_went_wrong"],
        };
      }
    }
  };
};

export const createAssignmentBulkAlertMessage = ({
  variables,
  sendAlertTo,
  modalType,
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createAssignmentBulkAlertMessageMutation,
        variables,
      });
      let msg = "";
      let locale_params = [];
      if (_.size(sendAlertTo) > 1) {
        msg =
          modalType === "reminder"
            ? "toastMsgs:reminder_successfully_send_to_count_students"
            : "toastMsgs:message_successfully_sent_to_students_count";
        locale_params = [
          {
            key: "count",
            value: _.size(sendAlertTo),
            isPlainText: true,
          },
        ];
      } else {
        const label = _.get(sendAlertTo, "[0].label", "");
        msg =
          modalType === "reminder"
            ? "toastMsgs:reminder_successfully_send_to_student"
            : "message_successfully_sent_to_student";
        locale_params = [
          {
            key: "studentName",
            value: label,
            isPlainText: true,
          },
        ];
      }
      const isSuccess = _.get(
        response,
        "data.platform.createAssignmentBulkAlertMessages.isSuccess",
        false
      );
      if (isSuccess) {
        dispatch(setToastMsg({ msg, locale_params, type: "success" }));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

export const addAssignmentActivity = ({
  assignmentId,
  studentIds,
  activities,
}) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: addAssignmentActivityMutation,
        variables: {
          input: {
            assignmentId,
            studentIds,
            activities,
          },
        },
      });
    } catch (error) {
      dispatchError({ dispatch, error });
    }
  };
};

// does not fetch value field when the mutation is called
export const createIbPypElementRatingsWithoutValue = ({
  elementRatings,
  getIsMediaManagerRoute = () => false,
  setElementRatingMutationInProgress,
}) => {
  return async dispatch => {
    const isMediaManagerRoute = getIsMediaManagerRoute() || false;
    try {
      if (isMediaManagerRoute && setElementRatingMutationInProgress) {
        dispatch(setElementRatingMutationInProgress(true));
      }
      return await client.mutate({
        mutation: createIbPypElementRatingsWithoutValueMutation,
        variables: { elementRatings },
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } finally {
      if (isMediaManagerRoute && setElementRatingMutationInProgress) {
        dispatch(setElementRatingMutationInProgress(false));
      }
    }
  };
};

export const updateScoreAssessmentTool = params => {
  const {
    score,
    maxScore,
    studentDetails,
    studentAssignmentId,
    studentCourseTags,
    assessmentTools,
    ibPYPElementRatings,
    scoreFieldId,
    academicTermId = null,
    sourceFrom = "CLASSROOM",
    updateScoreLocal,
    isAutoSaveDisabled,
    ibPYPElementRatingsLocal,
    setIBPYPElementRatingsLocal,
    isDeleteAiRatings,
    isEvaluated,
  } = params || {};

  const isMediaManagerRoute = getIsMediaManagerRoute();

  let { assignmentDetailsVariables } = params || {};

  const shouldAttachTermIdWithRating = ACLStore.can(
    "FeatureFlag:AttachTermIdWithRating"
  );

  return async (dispatch, getState) => {
    try {
      const state = getState();

      const userInfo = getUserInfo();
      const userId = userInfo.id;
      const userType = userInfo.user_type;

      // const score = _.get(e, "target.value");
      const scoreFloat = parseFloat(score);

      // allow only numbers and upto 2 decimals
      if (!DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(score) && score) return;

      // Do not update if the entered value is more than max score
      if (scoreFloat > parseFloat(maxScore)) return;

      if (isAutoSaveDisabled && _.isFunction(updateScoreLocal)) {
        updateScoreLocal(score);
        return;
      }

      if (isMediaManagerRoute && !isAutoSaveDisabled) {
        dispatch(setElementRatingMutationInProgress(true));
      }
      const academicYearId = getSelectedAcademicYearId(state);

      // if not provided then calculate it
      if (!assignmentDetailsVariables) {
        const academicYearId = getSelectedAcademicYearId(state);
        const userArchivedFilters = { academicYearId };

        assignmentDetailsVariables = {
          id: studentAssignmentId,
          showOnlySubmitted: false,
          userFilter: userType === "staff" ? "ALL" : "SELF",
          entityEventsFilter: { orderBy: "EVENT_TIME", orderByDir: "ASC" },
          userArchivedFilters,
        };
      }

      updateScoreElementRatingInCache({
        assignmentDetailsVariables,
        scoreValue: score,
        setIBPYPElementRatingsLocal,
        isDeleteAiRatings,
      });

      const studentId = _.get(studentDetails, "id");

      const scoreValue = score ? _.toString(scoreFloat) : "";

      const elementRatings = [
        {
          studentId,
          parentId: studentAssignmentId,
          parentType: "STUDENT_ASSIGNMENT",
          value: scoreValue,
          ibPYPElementType: "SCORE",
          createdBy: userId,
          academicCriteriaValueId: "-9999",
          academicCriteriaSetId: "-9999",
          source: sourceFrom,
          academicTermId: shouldAttachTermIdWithRating
            ? academicTermId
            : undefined,
        },
      ];

      const gradeScaleTool = getAssessmentToolItem(
        assessmentTools,
        GRADE_SCALE_TOOL
      );

      if (!_.isEmpty(gradeScaleTool) && !_.isNil(scoreValue)) {
        let _ibPYPElementRatings = ibPYPElementRatings;

        if (isAutoSaveDisabled && _.isFunction(setIBPYPElementRatingsLocal)) {
          _ibPYPElementRatings =
            ibPYPElementRatingsLocal?.[studentAssignmentId];
        }
        const rating = calculateGradeScaleRatingFromOtherTool({
          ibPYPElementRatings: _ibPYPElementRatings,
          assessmentTools,
          score: scoreValue,
        });

        const previousCalculatedRating = calculateGradeScaleRatingFromOtherTool(
          {
            ibPYPElementRatings: _ibPYPElementRatings,
            assessmentTools,
            score: _.find(_ibPYPElementRatings, {
              ibPYPElementType: SCORE,
              creatorType: "STAFF",
            })?.value,
          }
        );

        const previousGradeScaleRating = _.find(_ibPYPElementRatings, {
          ibPYPElementType: GRADE_SCALE_TOOL,
          creatorType: "STAFF",
        });

        const isGradeScaleOverridden =
          previousCalculatedRating?.id !==
          previousGradeScaleRating?.academicCriteriaValue?.id;

        if (!isGradeScaleOverridden && rating) {
          elementRatings.push({
            studentId,
            parentId: studentAssignmentId,
            parentType: "STUDENT_ASSIGNMENT",
            createdBy: userId,
            isPublished: isEvaluated,
            ibPYPElementId: gradeScaleTool?.id,
            ibPYPElementType: GRADE_SCALE_TOOL,
            academicCriteriaSetId: gradeScaleTool?.gradeScale?.id,
            academicCriteriaValueId: rating?.id,
            academicTermId,
            source: sourceFrom,
            value: rating?.abbreviation || null,
          });

          const gradeScaleValues = getGradeScaleValuesFromGradeScaleTool(
            assessmentTools
          );
          const gradeScaleValueForCache = _.find(gradeScaleValues, {
            id: rating?.id,
          });

          updateScoreElementRatingInCache({
            assignmentDetailsVariables,
            scoreValue: rating?.abbreviation || null,
            type: GRADE_SCALE_TOOL,
            academicCriteriaSet: {
              id: gradeScaleTool?.gradeScale?.id || null,
              criteriaType: "GRADE_SCALE",
              isArchived: false,
              label: null,
              subType: null,
              __typename: "AcademicCriteriaSet",
            },
            academicCriteriaValue: {
              id: rating?.id || null,
              label: gradeScaleValueForCache?.label || null,
              abbreviation: gradeScaleValueForCache?.abbreviation || "",
              description: null,
              color: null,
              __typename: "AcademicCriteriaValue",
            },
            ibPYPElementId: gradeScaleTool?.id,
            academicYearId,
            setIBPYPElementRatingsLocal,
            isDeleteAiRatings,
            isAIResponse: false,
          });
        }
      }

      if (!score) {
        if (!_.isEmpty(gradeScaleTool)) {
          dispatch(
            deletePypElementRating({
              studentIds: [studentDetails?.id],
              studentId: studentDetails?.id,
              parentId: studentAssignmentId,
              parentType: "STUDENT_ASSIGNMENT",
              sourceFrom,
              academicTermId,
              isAutoSaveDisabled,
              ibPYPElementRatingsLocal,
              setIBPYPElementRatingsLocal,
              id: gradeScaleTool.id,
              type: GRADE_SCALE_TOOL,
              setId: gradeScaleTool?.gradeScale?.id,
              skipCacheWrite: true,
            })
          );

          removeElementRatingFromCache({
            assignmentDetailsVariables,
            type: GRADE_SCALE_TOOL,
            ibPYPElementId: gradeScaleTool?.id,
            academicYearId,
            setIBPYPElementRatingsLocal,
          });
        }
      }

      const {
        gradeScaleRating,
        valueId = null,
        assessmentTool,
        assessmentToolType,
      } =
        getIBGradeScaleRatingFromScore({
          studentId,
          maxScore,
          studentCourseTags,
          assessmentTools,
          ibPYPElementRatings,
          scoreValue,
        }) || {};

      if (!_.isNil(gradeScaleRating)) {
        elementRatings.push({
          studentId,
          parentId: studentAssignmentId,
          parentType: "STUDENT_ASSIGNMENT",
          value: gradeScaleRating,
          ibPYPElementId: assessmentTool?.id,
          ibPYPElementType: assessmentToolType,
          createdBy: userId,
          academicCriteriaValueId: valueId,
          academicCriteriaSetId: assessmentTool?.id,
          source: sourceFrom,
          academicTermId: shouldAttachTermIdWithRating
            ? academicTermId
            : undefined,
        });

        const academicCriteriaValues = _.get(
          assessmentTool,
          "academicCriteriaValues",
          []
        );

        const academicCriteriaValue = _.find(
          academicCriteriaValues,
          value => value?.id === valueId
        );

        updateScoreElementRatingInCache({
          assignmentDetailsVariables,
          scoreValue: gradeScaleRating,
          type: assessmentToolType,
          academicCriteriaValue: {
            ...(academicCriteriaValue
              ? _.pick(academicCriteriaValue, ["id", "label"])
              : { id: generateRandomId(), label: null }),
            abbreviation: "",
            description: null,
            color: null,
            __typename: "AcademicCriteriaValue",
          },
          ibPYPElementId: assessmentTool?.id,
        });
      }

      if (studentId) {
        if (!_.isEmpty(gradeScaleTool)) {
          debouncedCreateIbPypElementRatingsWithoutValue(dispatch, {
            elementRatings,
            getIsMediaManagerRoute,
            setElementRatingMutationInProgress,
          });
        } else {
          dispatch(
            updateField({
              key: scoreFieldId,
              params: {
                elementRatings,
                getIsMediaManagerRoute,
                setElementRatingMutationInProgress,
              },
              type: "CREATE_ELEMENT_RATINGS_V2",
              isDebounce: true,
            })
          );
        }
      } else if (isMediaManagerRoute && !isAutoSaveDisabled) {
        // No mutation will fire — release the flag we set above so the
        // evaluation wait check doesn't see stale state.
        dispatch(setElementRatingMutationInProgress(false));
      }
    } catch (error) {
      if (isMediaManagerRoute && !isAutoSaveDisabled) {
        // The actual mutation owns clearing the flag. If we threw before
        // scheduling it, no one else will, so clear it here.
        dispatch(setElementRatingMutationInProgress(false));
      }
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const handleAssessmentIBScaleCriteriaClick = params => {
  const {
    criteriaId,
    academicCriteriaValues,
    studentIds,
    studentId,
    parentId,
    parentType,
    selectedCriteria,
    isEvaluated,
    assessmentTool,
    academicTermId = null,
    sourceFrom,
    ibPYPElementRatingsLocal,
    setIBPYPElementRatingsLocal,
    isAutoSaveDisabled,
    isDeleteAiRatings,
  } = params || {};

  const shouldAttachTermIdWithRating = ACLStore.can(
    "FeatureFlag:AttachTermIdWithRating"
  );

  const assessmentToolId = _.get(assessmentTool, "id");

  return async (dispatch, getState) => {
    const { label: score = "" } =
      _.find(academicCriteriaValues, value => {
        return _.get(value, "id") === criteriaId;
      }) || {};

    const academicCriteriaValuesLocal = _.map(academicCriteriaValues, value => {
      return {
        ...value,
        abbreviation: "",
        description: null,
        color: null,
      };
    });

    if (
      selectedCriteria &&
      _.get(selectedCriteria, "academicCriteriaValue.id", "") === criteriaId &&
      !isDeleteAiRatings
    ) {
      dispatch(
        deletePypElementRating({
          studentIds,
          studentId,
          parentId,
          parentType,
          type: ASSESSMENT_GRADE_BOUNDARY,
          id: assessmentToolId,
          setId: assessmentToolId,
          ibPYPElementRatingsLocal,
          setIBPYPElementRatingsLocal,
          isAutoSaveDisabled,
          academicTermId: shouldAttachTermIdWithRating
            ? academicTermId
            : undefined,
        })
      );
    } else {
      dispatch(
        createIbPypElementRating({
          parentId,
          parentType,
          studentId,
          studentIds,
          isDeleteAiRatings,
          criteriaValue: criteriaId,
          type: ASSESSMENT_GRADE_BOUNDARY,
          id: assessmentToolId,
          setId: assessmentToolId,
          isPublished: isEvaluated,
          criteriaSet: {
            ...assessmentTool,
            label: ASSESSMENT_GRADE_BOUNDARY,
            isArchived: false,
            subType: null,
          },
          academicCriteriaValue: _.find(academicCriteriaValuesLocal, {
            id: criteriaId,
          }),
          score,
          academicTermId: shouldAttachTermIdWithRating
            ? academicTermId
            : undefined,
          sourceFrom,
          ibPYPElementRatingsLocal,
          setIBPYPElementRatingsLocal,
          isAutoSaveDisabled,
          getIsMediaManagerRoute,
          setElementRatingMutationInProgress,
        })
      );
    }
  };
};

export const getStudentAssignmentDetails = ({ variables }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.query({
        query: getStudentAssignmentDetailsQuery,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const getAssignmentDetails = ({ variables }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.query({
        query: getAssignmentDetailsQuery,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const downloadEvaluationInsights = ({
  assignmentId,
  assessmentTitle,
  courseTitle,
}) => {
  return async (dispatch, getState) => {
    try {
      const queryData = await client.query({
        query: downloadInsightsDataQuery,
        variables: { id: assignmentId },
        fetchPolicy: "network-only",
      });

      const url = _.get(queryData, "data.node.toolInsightsDownload.url", "");

      if (_.isEmpty(url)) {
        throw Error("classRoom:not_applicable_for_this_assignment");
      }
      await dispatch(
        downloadFromUrl({
          attachment: {
            url: url,
            name: `${courseTitle}-${assessmentTitle}-Evaluation Insights`,
            mimeType: "application/xlsx",
          },
          shouldAskForSave: true,
        })
      );
    } catch (error) {
      dispatchError({
        dispatch,
        e: error,
        customMessage: !error.networkError ? _.get(error, "message") : null,
      });
    }
  };
};

//This function returns options array for the dropdown integrated from design library
export const getDropdownOptions = ({
  options,
  t,
  optionsToExcludeInCalendar = [],
  skipTermsCheckForLearningCourse = false,
  curriculumType: curriculumTypeParam,
  curriculumProgramId: curriculumProgramIdParam,
}) => {
  return (dispatch, getState) => {
    const state = getState();

    const curriculumType =
      curriculumTypeParam || getCurrentCurriculumProgramType(state);

    const showImportFromToddleLibrary = shouldShowImportFromToddleLibrary({
      curriculumType,
    });

    const clonedOptions = [];

    _.forEach(options, option => {
      const { label, key, perm, isItemGroup } = option;
      if (isItemGroup) {
        const childOptions = _.get(option, "options", []);
        const clonedChildOptions = _.reduce(
          childOptions,
          (result, childOption) => {
            const { perm, key, moduleSettingControlParam } = childOption;
            const isEnabled = moduleSettingControlParam
              ? _.isEqual(key, "IMPORT_FROM_TODDLE_LIBRARY")
                ? showImportFromToddleLibrary
                : ACLStorage.getModuleSettingsValue(moduleSettingControlParam)
              : ACLStore.can(perm);
            if (
              ((!perm && !moduleSettingControlParam) || isEnabled) &&
              !_.includes(
                optionsToExcludeInCalendar,
                _.get(childOption, "key", "")
              )
            ) {
              result.push({
                ...childOption,
                label: t(childOption.label),
                taskTypeId: childOption.taskTypeId || null,
              });
              if (
                key === CREATE_AI_TUTOR &&
                !isAITutorMarketingEnabled() &&
                !getIsAITutorEnabled()
              ) {
                return result;
              }
            }
            return result;
          },
          []
        );
        const clonedChildOptionsSize = _.size(clonedChildOptions);
        // if(clonedChildOptionsSize === 1) {
        //   clonedOptions.push(clonedChildOptions[0])
        // }
        // else
        if (
          clonedChildOptionsSize === 1 &&
          label === "common:import_from" &&
          !getIsLearningCoursesEnabled()
        ) {
          // Edge case: When the subGroup is "Import from" and if it only has one option, then we consider it as an individual item
          clonedOptions.push({
            ...importFromUnitOption,
            label: t(importFromUnitOption.label),
          });
        } else if (clonedChildOptionsSize > 0) {
          clonedOptions.push({
            ...option,
            label: t(label),
            options: clonedChildOptions,
          });
        }
      } else {
        // an item itself
        if (
          (!perm || ACLStore.can(perm)) &&
          (!_.includes(optionsToExcludeInCalendar), key)
        ) {
          clonedOptions.push({
            ...option,
            label: t(label),
            isDisable: false,
          });
        }
      }
    });

    // disable options which have dependency on terms if terms doesn't exist for current curriculum program
    const academicYearId = getSelectedAcademicYearId(state);
    const learningCourseId =
      getSelectedLearningCourseId(state) ||
      _.get(state, "planner.unitPlanData.learningCourseId", null);

    const isTermsExists =
      getIsLearningCoursesEnabled() && !skipTermsCheckForLearningCourse
        ? checkIfTermExistsForCurrentLearningCourse({
            learningCourseId,
            academicYearId,
          })
        : dispatch(
            checkTermsExistsForCurrentCurriculumProgram({
              curriculumProgramId: curriculumProgramIdParam,
            })
          );

    if (!isTermsExists) {
      _.forEach(clonedOptions, option => {
        const {
          options,
          label,
          labelText,
          hasTermDependency,
          noTermsDisabledTooltip,
        } = option;
        if (hasTermDependency) {
          option.disabled = true;
          option.disabledTooltip = t(noTermsDisabledTooltip, {
            label: labelText ? labelText : label,
          });
          option.tooltipPlacement = "left";
        }
        if (options) {
          _.forEach(options, childOption => {
            const {
              label,
              hasTermDependency,
              noTermsDisabledTooltip,
              labelText,
            } = childOption;
            if (hasTermDependency) {
              childOption.disabled = true;
              childOption.disabledTooltip = t(noTermsDisabledTooltip, {
                label: labelText ? labelText : label,
              });
              childOption.tooltipPlacement = "left";
            }
          });
        }
      });
    }

    return clonedOptions;
  };
};

export const updateTeacherAndStudentEval = params => {
  return async (dispatch, getState) => {
    try {
      const {
        assessmentTools = [],
        mode,
        assignmentId,
        updateSelectedItems,
        isLearningGoalsEvaluationEnabled = false,
      } = params;

      if (!_.isEmpty(assessmentTools)) {
        const assessmentToolsWithEval = _.filter(
          assessmentTools?.edges,
          ({ node }) => {
            const assessmentToolType = _.get(node, "assessmentToolType", "");
            return _.get(
              _.find(
                ASSESSMENT_TOOLS,
                ({ type }) => type === assessmentToolType
              ),
              "hasEvaluation",
              false
            );
          }
        );

        const someToolsHaveTeacherEval =
          _.some(assessmentToolsWithEval, ({ node }) =>
            _.get(node, "isTeacherEvaluationEnable", false)
          ) || isLearningGoalsEvaluationEnabled;

        const someToolsHaveStudentEval = _.some(
          assessmentToolsWithEval,
          ({ node }) => _.get(node, "isStudentEvaluationEnable", false)
        );

        if (mode === "edit" && assignmentId) {
          await dispatch(
            updateAssignment({
              id: assignmentId,
              isTeacherEvaluationEnabled: someToolsHaveTeacherEval ?? false,
              isStudentEvaluationEnabled: someToolsHaveStudentEval ?? false,
              showToast: false,
            })
          );
        }

        if (updateSelectedItems) {
          updateSelectedItems({
            isTeacherEvaluationEnabled: someToolsHaveTeacherEval ?? false,
            isStudentEvaluationEnabled: someToolsHaveStudentEval ?? false,
          });
        }
      }
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const onAddAssignmentItemClick = params => {
  return async (dispatch, getState) => {
    const {
      t,
      key,
      curriculumProgramType,
      toggleLoading,
      course,
      eventTarget,
      courseId,
      shouldCreateAssessment = true,
      learningCourseId,
      isMultipleCoursesSelectedInCalendar,
      isFromCalendar,
      templateId,
      label,
      icon,
      taskTypeId,
      taskType,
    } = params || {};

    const ubdAssessmentTypes = _.get(
      getState(),
      "platform.ubdAssessmentTypes",
      {}
    );

    const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

    const assignmentModalData = {};
    assignmentModalData["mode"] = "create";
    assignmentModalData["creationMode"] = isAssessmentTypeConfigurationEnabled
      ? taskType
      : key;
    assignmentModalData["initialStep"] = !isMultipleCoursesSelectedInCalendar
      ? getInitialStep({
          creationMode: isAssessmentTypeConfigurationEnabled ? taskType : key,
          shouldCreateAssessment,
        })
      : undefined;

    const LEARNING_COURSE_SELECTION_STEP = {
      label: t("toddleLibrary:select_course"),
      value: "LEARNING_COURSE_SELECTION",
      heading: t("toddleLibrary:select_course"),
    };

    const UNIT_FROM_GRADE_SELECTION_STEP = {
      label: t("common:select_with_label", {
        label: t("common:class"),
      }),
      value: "UNIT_FROM_GRADE_SELECTION",
      heading: t("common:select_with_label", {
        label: t("common:class"),
      }),
    };

    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

    const CREATION_FLOW_FIRST_STEP = isLearningCoursesEnabled
      ? LEARNING_COURSE_SELECTION_STEP
      : UNIT_FROM_GRADE_SELECTION_STEP;

    const toggleLoadingAndCreateAssessment = async ({
      toggleLoading,
      dispatch,
      course,
      assessmentType,
      groupType,
      templateId,
      taskTypeId,
    }) => {
      if (
        shouldCreateAssessment &&
        (key === "CREATE_QUICK_TASK" || !isMultipleCoursesSelectedInCalendar)
      ) {
        toggleLoading?.();

        const clonedAssessmentId = await dispatch(
          createAssessment({
            unitPlanObj: {
              unitPlanId: -1,
            },
            academicYears: _.map(_.get(course, "academicYears", []), item =>
              _.get(item, "id")
            ),
            assessmentType,
            groupType,
            learningCourseId,
            templateId,
            icon,
            label,
            taskTypeId,
          })
        );

        toggleLoading?.();

        return clonedAssessmentId;
      }
    };

    // Handle dynamic assessment type creation when templateId is provided
    if (isAssessmentTypeConfigurationEnabled && !_.isEmpty(templateId)) {
      const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
        toggleLoading,
        dispatch,
        course,
        assessmentType: key,
        groupType: taskType,
        templateId,
        icon,
        label,
        taskTypeId,
      });

      // Handle AI_TUTOR task type
      if (taskType === AI_TUTOR) {
        assignmentModalData["steps"] = [
          {
            label: t("classRoom:assessment_details", {
              label: t("common:ai_tutor"),
            }),
            value: AI_TUTOR_CREATION,
            heading: t("classRoom:assessment_details", {
              label: t("common:ai_tutor"),
            }),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] =
          label || t("classRoom:create_an_ai_tutor");
        assignmentModalData["assessmentType"] = key;
        assignmentModalData["taskTypeGroup"] = taskType;
        assignmentModalData["icon"] = icon;
        assignmentModalData["templateId"] = templateId;
        assignmentModalData["taskTypeId"] = taskTypeId;
        assignmentModalData["creationMode"] = CREATE_AI_TUTOR;

        return { clonedAssessmentId, assignmentModalData };
      }

      // Handle WORKSHEET task type
      if (taskType === GROUP_TYPE_WORKSHEET) {
        assignmentModalData["steps"] = [
          {
            label: t("common:details"),
            value: "WORKSHEET_QUESTION_CREATION",
            heading: t("classRoom:share_resources"),
            subHeading: t("classRoom:placeholder_for_subtext"),
          },
          {
            label: t("worksheet:questions"),
            value: "QUESTION_CREATION",
            heading: t("worksheet:questions"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
          {
            label: t("classRoom:assign_settings"),
            value: "SETTINGS",
            heading: t("classRoom:assign_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = label || t("common:worksheet");
        assignmentModalData["assessmentType"] = key;
        assignmentModalData["taskTypeGroup"] = taskType;
        assignmentModalData["icon"] = icon;
        assignmentModalData["templateId"] = templateId;
        assignmentModalData["taskTypeId"] = taskTypeId;
        assignmentModalData["creationMode"] = CREATE_WORKSHEET;

        return { clonedAssessmentId, assignmentModalData };
      }

      // Default case for other dynamic assessment types
      assignmentModalData["steps"] = [
        {
          label: t("classRoom:assessment_details", {
            label: t("common:assessment"),
          }),
          value: "ASSESSMENT_CREATION",
          heading: t("classRoom:assessment_details", {
            label: t("common:assessment"),
          }),
        },
        {
          label: t("classRoom:post_settings"),
          value: "SETTINGS",
          heading: t("classRoom:post_settings"),
          subHeading: t("classRoom:classes_discussion_shared_with"),
        },
      ];

      if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
        assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
      }

      assignmentModalData["contentType"] = "ASSESSMENT";
      assignmentModalData["createHeader"] = label;
      assignmentModalData["assessmentType"] = key;
      assignmentModalData["taskTypeGroup"] = taskType;
      assignmentModalData["icon"] = icon;
      assignmentModalData["templateId"] = templateId;
      assignmentModalData["taskTypeId"] = taskTypeId;

      return { clonedAssessmentId, assignmentModalData };
    }

    switch (key) {
      case "CREATE_LE": {
        // Set the current page name for WalkMe
        WalkMeManager.setCurrentPageName({
          pageName: WALKME_PAGE_NAMES.CREATE_LEARNING_EXPERIENCE,
          routeId: WALKME_PAGE_NAMES.CREATE_LEARNING_EXPERIENCE,
        });
        assignmentModalData["steps"] = [
          {
            label: t("classRoom:assessment_details", {
              label: t("common:le_label"),
            }),
            value: "LE_CREATION",
            heading: t("classRoom:assessment_details", {
              label: t("common:le_label"),
            }),
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("classRoom:create_le");
        assignmentModalData["assessmentType"] = "le";
        assignmentModalData["taskTypeGroup"] = "LEARNING_ENGAGEMENT";

        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: "le",
          groupType: "LEARNING_ENGAGEMENT",
        });

        return { clonedAssessmentId, assignmentModalData };
      }
      case "IMPORT_LE":
        assignmentModalData["steps"] = [
          {
            label: t("common:select_with_label", {
              label: t("common:unit"),
            }),
            value:
              isFromCalendar && isMultipleCoursesSelectedInCalendar
                ? "UNIT_FROM_GRADE_SELECTION"
                : "UNIT_SELECTION",
            heading: t("common:select_with_label", {
              label: t("common:unit"),
            }),
          },
          {
            label: t("common:select_with_label", {
              label: t("common:lowercase", {
                text: t("common:le_label"),
              }),
            }),
            value: "LE_SELECTION",
            heading: t("common:select_with_label", {
              label: t("common:lowercase", {
                text: t("common:le_label"),
              }),
            }),
          },
          {
            label: t("common:edit_with_label", {
              label: t("community:learning_experience"),
            }),
            value: "ASSESSMENT_DETAILS",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("classRoom:assign_from_unit");

        return { assignmentModalData };
      case "IMPORT_LE_FROM_LE_LIBRARY": {
        assignmentModalData["steps"] = [
          {
            label: t("common:select_with_label", {
              label: t("common:lowercase", {
                text: t("common:post"),
              }),
            }),
            value: "LE_LIBRARY_LE_SELECTION",
            heading: t("common:select_with_label", {
              label: t("common:lowercase", {
                text: t("common:post"),
              }),
            }),
          },
        ];
        if (isFromCalendar && isLearningCoursesEnabled) {
          assignmentModalData["steps"].push(LEARNING_COURSE_SELECTION_STEP);
        }
        assignmentModalData["steps"].push(
          {
            label: t("common:edit_with_label", {
              label: t("common:post"),
            }),
            value: "ASSESSMENT_DETAILS",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          }
        );

        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = _.isEqual(
          curriculumProgramType,
          CURRICULUM_TYPE_PYP
        )
          ? t("common:assign_from_learning_experience_library")
          : t("common:assign_from_learning_experience_&_assessment_library");

        return { assignmentModalData };
      }
      case "CREATE_WORKSHEET": {
        assignmentModalData["steps"] = [
          {
            label: t("common:details"),
            value: "WORKSHEET_QUESTION_CREATION",
            heading: t("classRoom:share_resources"),
            subHeading: t("classRoom:placeholder_for_subtext"),
          },
          {
            label: t("worksheet:questions"),
            value: "QUESTION_CREATION",
            heading: t("worksheet:questions"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
          {
            label: t("classRoom:assign_settings"),
            value: "SETTINGS",
            heading: t("classRoom:assign_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("common:worksheet");
        assignmentModalData["assessmentType"] = ASSESSMENT_TYPE_WORKSHEET;
        assignmentModalData["taskTypeGroup"] = GROUP_TYPE_WORKSHEET;

        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: ASSESSMENT_TYPE_WORKSHEET,
          groupType: GROUP_TYPE_WORKSHEET,
        });

        return { clonedAssessmentId, assignmentModalData };
      }
      case "CREATE_QUICK_TASK": {
        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: "qt",
          groupType: "QUICK_TASK",
        });
        assignmentModalData["steps"] = [
          {
            label: t("common:description"),
            value: "QT_CREATION",
            heading: t("classRoom:share_resources"),
            subHeading: t("classRoom:placeholder_for_subtext"),
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t(
          "classRoom:create_a_quick_task"
        );
        assignmentModalData["assessmentType"] = "qt";
        assignmentModalData["taskTypeGroup"] = "QUICK_TASK";

        return { clonedAssessmentId, assignmentModalData };
      }
      case "CREATE_DISCUSSION":
        assignmentModalData["steps"] = [
          {
            label: t("common:details"),
            value: "DISCUSSION_CREATION",
            heading: t("classRoom:initiate_a_classroom_discussion"),
            subHeading: t("classRoom:student_response_to_discussion_prompts"),
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        assignmentModalData["contentType"] = "ASSIGNMENT_DISCUSSION";
        assignmentModalData["createHeader"] = t(
          "classRoom:intiate_a_new_discussion"
        );

        return { assignmentModalData };
      case "CREATE_SA": {
        assignmentModalData["steps"] = [
          {
            label: t("classRoom:assessment_details", {
              label: t("common:summative_assessment"),
            }),
            value: "SMT_CREATION",
            heading: t("classRoom:assessment_details", {
              label: t("common:summative_assessment"),
            }),
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("classRoom:create_sa");
        assignmentModalData["assessmentType"] = "smt";
        assignmentModalData["taskTypeGroup"] = "ASSESSMENT";

        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: "smt",
          groupType: "ASSESSMENT",
        });

        return { clonedAssessmentId, assignmentModalData };
      }
      case "CREATE_FA": {
        assignmentModalData["steps"] = [
          {
            label: t("classRoom:assessment_details", {
              label: t("common:formative_assessment"),
            }),
            value: "FMT_CREATION",
            heading: t("classRoom:assessment_details", {
              label: t("common:formative_assessment"),
            }),
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("classRoom:create_fa");
        assignmentModalData["assessmentType"] = "fmt";
        assignmentModalData["taskTypeGroup"] = "ASSESSMENT";

        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: "fmt",
          groupType: "ASSESSMENT",
        });

        return { clonedAssessmentId, assignmentModalData };
      }
      case "CREATE_ASSESSMENT": {
        assignmentModalData["steps"] = [
          {
            label: t("common:create_with_label", {
              label: t("common:lowercase", {
                text: t("common:assessment"),
              }),
            }),
            value: "ASSESSMENT_CREATION",
            heading:
              ("common:create_with_label",
              {
                label: t("common:lowercase", {
                  text: t("common:assessment"),
                }),
              }),
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t(
          "classRoom:create_assessment_classroom"
        );
        assignmentModalData["assessmentType"] = _.get(
          _.keys(ubdAssessmentTypes),
          "[0]",
          "pt"
        );
        assignmentModalData["taskTypeGroup"] = "ASSESSMENT";

        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: _.get(_.keys(ubdAssessmentTypes), "[0]", "pt"),
          groupType: "ASSESSMENT",
        });

        return { clonedAssessmentId, assignmentModalData };
      }
      case "UNIT":
        // Set the current page name for WalkMe
        WalkMeManager.setCurrentPageName({
          pageName: WALKME_PAGE_NAMES.ASSIGN_FROM_UNIT,
          routeId: WALKME_PAGE_NAMES.ASSIGN_FROM_UNIT,
        });
        assignmentModalData["steps"] = [
          {
            label: t("common:select_with_label", {
              label: t("common:unit"),
            }),
            value:
              isFromCalendar && isMultipleCoursesSelectedInCalendar
                ? "UNIT_FROM_GRADE_SELECTION"
                : "UNIT_SELECTION",
            heading: t("common:select_with_label", {
              label: t("common:unit"),
            }),
          },
          {
            label: t("common:select_post"),
            value: "SELECT_POST",
            heading: "common:select_post",
          },
          {
            label: t("common:edit_post"),
            value: "ASSESSMENT_DETAILS",
            heading: "common:edit_post",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("classRoom:assign_from_unit");

        return { assignmentModalData };

      case "IMPORT_LE_FROM_TODDLE_LIBRARY": {
        assignmentModalData["steps"] = [
          {
            label: t("common:edit_with_label", {
              label: t("community:learning_experience"),
            }),
            value: "ASSESSMENT_DETAILS",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isLearningCoursesEnabled) {
          assignmentModalData["steps"].unshift(LEARNING_COURSE_SELECTION_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("common:edit_with_label", {
          label: t("common:le_label"),
        });

        return { assignmentModalData };
      }
      case "IMPORT_WORKSHEET_FROM_TODDLE_LIBRARY": {
        assignmentModalData["steps"] = [
          {
            label: t("common:edit_with_label", {
              label: t("common:details"),
            }),
            value: "ASSESSMENT_DETAILS",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
            heading: t("classRoom:post_settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        if (isFromCalendar && isLearningCoursesEnabled) {
          assignmentModalData["steps"].unshift(LEARNING_COURSE_SELECTION_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("common:edit_with_label", {
          label: t("common:worksheet"),
        });

        return { assignmentModalData };
      }
      case "CREATE_DP_PA":
      case "CREATE_DP_EP": {
        const assessmentType = key === "CREATE_DP_PA" ? "dp_pa" : "dp_ep";
        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType,
          groupType: "QUICK_TASK",
        });

        assignmentModalData["steps"] = [
          {
            label: t("common:details"),
            value: "QT_CREATION",
            heading: t("common:details"),
            subHeading: t("classRoom:placeholder_for_subtext"),
          },
          {
            label: t("common:settings"),
            value: "SETTINGS",
            heading: t("common:settings"),
            subHeading: t("classRoom:classes_discussion_shared_with"),
          },
        ];
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("common:add_new_with_label", {
          label: t("common:practical"),
        });
        assignmentModalData["doneBtnText"] = t("common:save_changes");
        assignmentModalData["cancelBtnText"] = t("common:discard");
        assignmentModalData["assessmentType"] = assessmentType;

        return { assignmentModalData, clonedAssessmentId };
      }
      case CREATE_AI_TUTOR: {
        assignmentModalData["steps"] = [
          {
            label: t("classRoom:assessment_details", {
              label: t("common:ai_tutor"),
            }),
            value: AI_TUTOR_CREATION,
            heading: t("classRoom:assessment_details", {
              label: t("common:ai_tutor"),
            }),
          },
        ];
        if (isFromCalendar && isMultipleCoursesSelectedInCalendar) {
          assignmentModalData["steps"].unshift(CREATION_FLOW_FIRST_STEP);
        }
        assignmentModalData["contentType"] = "ASSESSMENT";
        assignmentModalData["createHeader"] = t("classRoom:create_an_ai_tutor");
        assignmentModalData["assessmentType"] = ASSESSMENT_TYPE_AI_TUTOR;
        assignmentModalData["taskTypeGroup"] = AI_TUTOR;

        const clonedAssessmentId = await toggleLoadingAndCreateAssessment({
          toggleLoading,
          dispatch,
          course,
          assessmentType: ASSESSMENT_TYPE_AI_TUTOR,
          groupType: AI_TUTOR,
        });

        return { clonedAssessmentId, assignmentModalData };
      }
    }
  };
};

/** This function is for for switching between student assignments */
export const navigateToStudentAssignment = params => {
  return async (dispatch, getState) => {
    const { location, studentAssignmentId } = params;
    /*
     * We need to preserve all the query parameters except current media while switching
     * while switching assigments append current media if present
     */
    const updatedQueryString = getQueryUpdatedQueryString({
      params: _.omit(location?.query, "currentMedia"),
    });

    dispatch(
      goToRelativeRoute({
        route: `../${studentAssignmentId}/?${updatedQueryString}`,
        type: "replace",
      })
    );
  };
};

export const navigateToNextStudent = params => {
  const {
    isShortcut = false,
    selectedStatusStudents,
    studentAssignmentId,
    location,
  } = params;

  return async (dispatch, getState) => {
    const currentIndex = _.findIndex(
      selectedStatusStudents,
      item => _.get(item, "id") == studentAssignmentId
    );

    let idToRedirect = "";

    if (currentIndex == _.size(selectedStatusStudents) - 1) {
      idToRedirect = _.get(_.first(selectedStatusStudents), "id", "");
    } else {
      idToRedirect = _.get(selectedStatusStudents[currentIndex + 1], "id", "");
    }

    dispatch(
      navigateToStudentAssignment({
        studentAssignmentId: idToRedirect,
        location,
      })
    );

    recordEvent({
      eventName: THEATRE_VIEW_NAVIGATION_EVENT,
      eventData: {
        entity_type: isShortcut
          ? THEATRE_VIEW_KEYBOARD_NAVIGATION
          : THEATRE_VIEW_UI_BUTTON_NAVIGATION,
      },
    });
  };
};

export const navigateToPreviousStudent = params => {
  const {
    isShortcut = false,
    selectedStatusStudents,
    studentAssignmentId,
    location,
  } = params;

  return async (dispatch, getState) => {
    const currentIndex = _.findIndex(
      selectedStatusStudents,
      item => item?.id == studentAssignmentId
    );
    let idToRedirect = "";

    if (currentIndex == 0) {
      idToRedirect = _.get(_.last(selectedStatusStudents), "id", "");
    } else {
      idToRedirect = _.get(selectedStatusStudents[currentIndex - 1], "id", "");
    }

    dispatch(
      navigateToStudentAssignment({
        studentAssignmentId: idToRedirect,
        location,
      })
    );

    recordEvent({
      eventName: THEATRE_VIEW_NAVIGATION_EVENT,
      eventData: {
        entity_type: isShortcut
          ? THEATRE_VIEW_KEYBOARD_NAVIGATION
          : THEATRE_VIEW_UI_BUTTON_NAVIGATION,
      },
    });
  };
};

export const isMaxScoreValid = ({
  assessmentDetails = {},
  isUsingNewGradingSetupInCourses = false,
  courseId,
}) => {
  const { isScoreEnabled, maxScore } = getScoreDetailsMemoize({
    assessmentTools: _.get(assessmentDetails, "assessmentTools", []),
  });

  const weightage = _.get(assessmentDetails, "weightage");

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  return (dispatch, getState) => {
    const state = getState();

    // score validation not required for worksheet, as score tool is created at the backend
    // also 0 is a valid max score in worksheet
    const isWorksheet = isAssessmentTypeConfigurationEnabled
      ? _.get(assessmentDetails, "type") === "ASSESSMENT"
      : _.get(assessmentDetails, "type") === GROUP_TYPE_WORKSHEET;

    if (isWorksheet) return true;

    const curriculumProgramType = getCurrentCurriculumProgramType(state);
    const curriculumProgramId = getSelectedCurriculumId(state);

    const gradeCalculationMethodSettingName = getGradeCalculationMethodSetting({
      curriculumType: curriculumProgramType,
    });

    const gradeCalculationMethod = getSettingValue({
      name: gradeCalculationMethodSettingName,
      currentCurriculumProgramId: curriculumProgramId,
    });

    let isCustomWeights;
    if (isUsingNewGradingSetupInCourses) {
      let assessmentSubjectIds, primaryGradeId;
      const learningCourseId = _.get(assessmentDetails, "learningCourse.id");
      const isSubjectBasedGrading = getIsSubjectBasedGradingEnabled();

      if (isSubjectBasedGrading) {
        assessmentSubjectIds =
          _.find(assessmentDetails?.allFields, { uid: "subjects" })?.value ||
          [];

        if (learningCourseId) {
          const learningCourseDetails = getAssessmentLearningCourseDetailsFromCache(
            {
              id: learningCourseId,
            }
          );
          primaryGradeId = _.get(learningCourseDetails, "primaryGrade.id");
        } else {
          const courseDetails = getAssessmentCourseDetailsFromCache({
            id: courseId,
          });
          primaryGradeId = _.get(courseDetails, "primaryGrade.id");
        }
      }

      isCustomWeights = checkAssignmentContributionMethodValue({
        curriculumProgramType,
        learningCourseId,
        subjectIds: assessmentSubjectIds,
        primaryGradeId,
        academicYearId: getSelectedAcademicYearId(state),
      });
    } else {
      isCustomWeights = _.isEqual(gradeCalculationMethod, CUSTOM_WEIGHTS);
    }

    if (isScoreEnabled) {
      if (!maxScore) {
        dispatch(setToastMsg("toastMsgs:please_enter_max_score_error"));
        return false;
      } else if (parseInt(maxScore) === 0) {
        dispatch(setToastMsg("toastMsgs:max_score_greater_than_zero"));
        return false;
      } else if (
        curriculumProgramType !== CURRICULUM_TYPE_DP &&
        isCustomWeights &&
        !_.isEmpty(maxScore) &&
        _.isEmpty(_.toString(weightage))
      ) {
        dispatch(setToastMsg("toastMsgs:please_enter_task_weight"));
        return false;
      }
    }
    return true;
  };
};

export const getSimilarityIndexDefaultValue = () => {
  return (dispatch, getState) => {
    const state = getState();
    const orgId = getOrganizationId();

    const selectedGrades = _.get(
      state,
      "teacher.selected_class.selected_grades",
      []
    );

    const turnitinEnabledGrades = getSettingValue({
      name: "TurnitinEnabledGrades",
      organizationId: orgId,
      readFromUserAndOrgLevel: true,
    });

    const isTurnitinEnabledForGrade = !_.isEmpty(
      _.intersection(turnitinEnabledGrades, selectedGrades)
    );

    return (
      isTurnitinEnabledForGrade &&
      ACLStore.can("Common:IsEnableTurnitinGlobalForAssignment")
    );
  };
};

export const updateScoreAndEvaluation = params => {
  const { mode, assignmentId, assessmentDetails } = params;

  return async (dispatch, getState) => {
    const maxScoreLocal = _.get(getState(), "teacher.maxScore", null);

    const {
      id: assessmentId,
      assessmentTools = [],
      isLearningGoalsEvaluationEnabled = false,
    } = assessmentDetails || {};

    const { maxScore, isScoreEnabled } = getScoreDetailsMemoize({
      assessmentTools,
    });

    if (
      isScoreEnabled &&
      ((maxScoreLocal && maxScoreLocal !== maxScore) ||
        parseInt(maxScore) === 0)
    ) {
      const scoreTool = _.find(assessmentTools?.edges, ({ node }) => {
        return _.get(node, "assessmentToolType") === "SCORE";
      });

      const scoreToolData = _.get(
        scoreTool,
        "node.assessmentToolItem.scoreToolData",
        {}
      );

      const id = _.get(scoreToolData, "id");

      if (id && assessmentId) {
        await dispatch(
          updateScoreToolData({
            id,
            maxScore: maxScoreLocal,
            parentId: assessmentId,
            parentType: "ASSESSMENT",
            assessmentId,
          })
        );
      }
    }

    if (assignmentId) {
      await dispatch(
        updateTeacherAndStudentEval({
          assessmentTools,
          assignmentId,
          mode,
          isLearningGoalsEvaluationEnabled,
        })
      );
    }
  };
};

export const getConversationReadRefetchQueries = () => {
  return (dispatch, getState) => {
    const state = getState();
    const filters = _.get(state, "classRoom.filters", {});
    const userId = getUserId();
    const userType = getUserType(state);
    const courseId = getSelectedCourseId(state);
    const organizationId = getOrganizationId(state);
    const refetchQueries = [];
    const isClassStreamManagerRoute =
      location.href.search("class-stream-manager") > -1;

    switch (userType) {
      case "student":
        if (!_.isEmpty(courseId)) {
          refetchQueries.push({
            query: getStudentTodosQuery,
            variables: {
              courseIds: courseId,
              ...getFamilyStudentFeedQueryFilters({
                filters,
                userId,
                userType,
              }),
            },
          });
        }
        break;
      case "staff":
        if (isClassStreamManagerRoute) {
          refetchQueries.push(
            {
              query: getTeacherTasksQuery,
              variables: getTeacherTasksQueryFiltersMemoize({
                filters,
                academicYearId: getSelectedAcademicYearId(state),
                userId: getUserId(state),
                userType: getUserType(state),
              }),
            },
            {
              query: getOrganizationAssignmentStateWiseCountV2Query,
              variables: {
                organizationId,
                filters: getOrganizationAssignmentStateWiseCountV2Filters({
                  filters,
                }),
              },
            }
          );
        } else if (!_.isEmpty(courseId)) {
          refetchQueries.push(
            {
              query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
              variables: { courseId, ...getQueryFilters({ filters }) },
            },
            {
              query: getCourseAssignmentStateWiseCountV2Query,
              variables: {
                courseId,
                filters: getCourseAssignmentStateWiseCountV2Filters({
                  filters,
                }),
              },
            }
          );
        }
    }

    return refetchQueries;
  };
};

export const createAiEvaluation = params => {
  const { input } = params;

  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createAiEvaluationMutation,
        variables: { input },
      });

      const data = _.get(response, "data.ai.createAiTutorEvaluation");

      if (!_.get(data, "isSuccess", false)) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return {};
      }

      return _.get(data, "response", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const createAiAssessmentEvaluation = params => {
  const { input } = params;
  const { studentAssignmentId } = input;

  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createAiAssessmentEvaluationMutation,
        variables: { input },
        refetchQueries: mutationResult => {
          const isSuccess = _.get(
            mutationResult,
            "data.ai.createAiAssessmentEvaluation.isSuccess",
            false
          );
          return isSuccess
            ? [
                {
                  query: getStudentAiEvaluationJobStatusQuery,
                  variables: { id: studentAssignmentId },
                },
              ]
            : [];
        },
        awaitRefetchQueries: true,
      });

      const data = _.get(response, "data.ai.createAiAssessmentEvaluation");

      if (!_.get(data, "isSuccess", false)) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return {};
      }

      return _.get(data, "response", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const retryAssignmentStudentTemplate = attachmentIds => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: retryAssignmentStudentTemplateMutation,
        variables: { input: { attachmentIds } },
      });

      const data = _.get(
        response,
        "data.platform.retryAssignmentStudentTemplate"
      );

      if (!_.get(data, "isSuccess", false)) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return;
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return;
    }
  };
};

export const deleteAssessmentToolResponse = params => {
  const { input } = params;

  return async dispatch => {
    const userInfo = getUserInfo();
    const userId = _.get(userInfo, "id");

    _.set(input, "deletedBy", userId);

    try {
      await client.mutate({
        mutation: deleteAssessmentToolResponseMutation,
        variables: { input },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const changeAssessmentType = ({
  id,
  type,
  assessmentType,
  templateId,
  currentAssessmentTypeGroup,
  unitPlanId,
  pageType,
  selectedAssessmentTypeLabel,
  handleRightPane,
  assignmentId,
  toastMsg = "",
}) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      let refetchQueries = [];
      const courseId = _.get(state, "teacher.selected_class.selected_course");
      const curriculumType = _.get(
        state,
        "platform.currentCurriculumProgram.type"
      );
      const userInfo = getUserInfo();
      const userId = _.get(userInfo, "id");
      const userType = _.get(userInfo, "user_type");
      const academicYearId = getSelectedAcademicYearId(state);
      const gradebookSelectedTermAcademicYearId = _.get(
        state,
        "gradebook.selectedAcademicYearId"
      );

      switch (pageType) {
        case "classMaterials":
          {
            const filters = _.get(state, "classMaterials.filters");
            const feedQueryVariables = getClassMaterialsFeedVariablesMemoized({
              courseId,
              filters,
              userInfo,
              userType,
              curriculumType,
            });

            refetchQueries = [
              {
                query: getClassMaterialsFeedQuery,
                variables: feedQueryVariables,
              },
            ];
          }
          break;
        case "assignmentManager":
          {
            const filters = _.get(state, "classRoom.filters", {});
            refetchQueries = [
              {
                query: getTeacherTasksQuery,
                variables: getTeacherTasksQueryFiltersMemoize({
                  filters,
                  academicYearId,
                  userId,
                  userType,
                }),
              },
            ];
          }
          break;
        case "classStream":
          {
            const filters = _.get(state, "classRoom.filters", {});
            if (!_.isEmpty(courseId)) {
              refetchQueries = [
                {
                  query: getCourseAssignmentFeedWithoutAssignedStudentQuery,
                  variables: { courseId, ...getQueryFilters({ filters }) },
                },
              ];
            }
          }
          break;
        case "allSubmissions":
        case "instructions":
          {
            refetchQueries = [
              {
                query: getAssignmentDetailsQuery,
                variables: getAssignmentDetailsQueryVariables({
                  assignmentId,
                  curriculumProgramType: curriculumType,
                  userType,
                  userId,
                  academicYearId,
                }),
              },
            ];
          }
          break;
        case "gradebook":
          {
            const learningCourseId = getSelectedLearningCourseId(state);
            const organizationId = _.get(state, "login.userInfo.org_id");
            const categoryIds = _.get(state, "gradebook.categoryIds", []);
            const filters = _.get(state, "gradebook.assessmentsFilters", {});
            const { viewBy } = filters;
            const curriculumProgramId = _.get(
              state,
              "platform.currentCurriculumProgram.id"
            );
            const showSameSubjectGradeTasksInGradebook = ACLStore.can(
              "FeatureFlag:ShowSameSubjectGradeTasksInGradebook"
            );

            const primaryGradeId = getCoursePrimaryGradeIdFromCache({
              courseId,
              gradebookSelectedTermAcademicYearId,
              selectedAcademicYearId: academicYearId,
            });

            const isHideTasksExcludedFromTermTotal = getSettingValue({
              name: "HideTasksExcludedFromTermTotalInGradebook",
              currentCurriculumProgramId: curriculumProgramId,
            });

            const isHideTasksFromOtherClasses = getSettingValue({
              name: "HideTasksFromOtherClassesInGradebook",
              currentCurriculumProgramId: curriculumProgramId,
            });

            const gradebookDisplaySettings = _.get(
              state,
              "gradebook.displaySettings",
              {}
            );

            const isAssessmentGradebookHeaderEnhancements = ACLStore.can(
              "FeatureFlag:AssessmentGradebookHeaderEnhancements"
            );

            const isCategoriesView = isAssessmentGradebookHeaderEnhancements
              ? getIsGroupByCategoryView(gradebookDisplaySettings)
              : viewBy === "CATEGORIES";

            refetchQueries = ACLStore.can(
              "FeatureFlag:EnableAssessmentGradebookDataGrid"
            )
              ? [
                  {
                    query: getGradebookAssignmentsQuery,
                    variables: getGradebookAssignmentsVariables({
                      learningCourseId,
                      courseId,
                      filters,
                      organizationId,
                      curriculumType,
                      primaryGradeId,
                      showSameSubjectGradeTasksInGradebook,
                      isHideTasksFromOtherClasses,
                      isHideTasksExcludedFromTermTotal,
                      shouldGroupByCategories: isCategoriesView,
                      categoryIds,
                      displaySettings: gradebookDisplaySettings,
                      isAssessmentGradebookHeaderEnhancements,
                      curriculumProgramId,
                    }),
                  },
                ]
              : [
                  {
                    query: getOrganizationAssignmentsGradebookQuery,
                    variables: getGradebookAllAssessmentsVariables({
                      courseId,
                      filters,
                      organizationId,
                      curriculumType,
                      primaryGradeId,
                      showSameSubjectGradeTasksInGradebook,
                      isHideTasksFromOtherClasses,
                      isHideTasksExcludedFromTermTotal,
                    }),
                  },
                ];
          }

          break;
      }

      await client.mutate({
        mutation: changeAssessmentTypeMutation,
        variables: {
          input: {
            id,
            type,
            assessmentType,
            templateId,
          },
        },
        refetchQueries,
        awaitRefetchQueries: false,
      });

      if (
        pageType === "UNIT_FLOW_RIGHT_PANE" &&
        type !== currentAssessmentTypeGroup
      ) {
        const filters = _.get(state, "assessment.filters", {});

        const filteredUnitPlanDetails = getUnitPlanResourceLibraryFromCache({
          id: unitPlanId,
          filters,
        });

        const newFilteredUnitPlanDetails = _.cloneDeep(filteredUnitPlanDetails);

        const newFilteredUnitPlanDetailsEdges = _.filter(
          _.get(filteredUnitPlanDetails, "resourceLibrary.edges", []),
          edge => _.get(edge, "node.id") !== id
        );

        _.set(
          newFilteredUnitPlanDetails,
          "resourceLibrary.edges",
          newFilteredUnitPlanDetailsEdges
        );

        writeUnitPlanResourceLibraryInCache({
          id: unitPlanId,
          filters,
          data: newFilteredUnitPlanDetails,
        });
      }

      if (pageType === "UNIT_FLOW_RIGHT_PANE") {
        let rightPaneTab = "";
        if (type === LEARNING_ENGAGEMENT) {
          rightPaneTab = "LE_LIBRARY";
        } else if (type === ASSESSMENT) {
          rightPaneTab = "ASSESSMENT_LIBRARY";
        }

        const handleToastClick = () => {
          if (type !== currentAssessmentTypeGroup) {
            handleRightPane({ rightPane: rightPaneTab });
          }

          dispatch(updateHighlightTaskId(id));
        };

        dispatch(
          setToastMsg({
            msg: "toastMsgs:change_task_type_success_unit_plan",
            type: "success",
            locale_params: [
              {
                key: "taskName",
                value: selectedAssessmentTypeLabel,
                isPlainText: true,
              },
            ],
            variant: "inline",
            onClick: handleToastClick,
            primaryAction: {
              label: "toastMsgs:view",
              onClick: handleToastClick,
            },
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: !_.isEmpty(toastMsg)
              ? toastMsg
              : "toastMsgs:change_task_type_success",
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatchError({ dispatch, error });
    }
  };
};

export const handleIBPYPElementRatingsForStandardRubric = params => {
  return async (dispatch, getState) => {
    const {
      assessmentTool,
      rowId,
      columnId,
      toolResponses,
      isAutoSaveDisabled = false,
      parentId,
      parentType = "STUDENT_ASSIGNMENT",
      academicTermId,
      sourceFrom = "CLASSROOM",
      ibPYPElementRatings,
      ibPYPElementRatingsLocal,
      setIBPYPElementRatingsLocal,
      studentId,
      isEvaluated,
      toolType,
      studentIds = [],
      totalScore,
      creatorType = "STAFF",
      assessmentTools,
      learningCourseId: learningCourseIdParam,
    } = params;

    const state = getState();
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const userType = userInfo.user_type;

    // Only staff members can update ratings
    if (userType !== "staff") return;

    const academicYearId = getSelectedAcademicYearId(state);
    const learningCourseId =
      learningCourseIdParam || getSelectedLearningCourseId(state);
    const isSubjectBasedGradingEnabled =
      !getIsLearningCoursesEnabled() || getIsSubjectBasedGradingEnabled();
    const isCourseBasedGradingEnabled = getIsCourseBasedGradingEnabled();
    const isPYPCurriculum =
      getCurrentCurriculumProgramType(state) === CURRICULUM_TYPE_PYP;

    const actualStudentIds = _.size(studentIds) ? studentIds : [studentId];

    const [scoreElements, otherElements] = _.partition(
      ibPYPElementRatings,
      rating => rating?.ibPYPElementType === SCORE
    );

    const elementRatings = []; // mutation input
    let updatedScoreElements = [...(scoreElements || [])];
    let updatedOtherElements = [...(otherElements || [])];

    const { associateScoreTool, gradeScale, standardRubricCriterias } =
      assessmentTool || {};

    const { gradingType } = gradeScale || {};

    const maxScore = _.get(associateScoreTool, "scoreToolData.maxScore", null);

    const isAlphaScale = gradingType === "ALPHA";

    const gradeScaleTool =
      isAlphaScale || toolType === SCORE_BASED_RUBRIC
        ? getAssessmentToolItem(assessmentTools, GRADE_SCALE_TOOL)
        : null;

    const filteredToolResponses = _.filter(
      toolResponses,
      response =>
        response?.creatorType === "STAFF" ||
        (response?.creatorType === "AI" && !response.isDeleted)
    );

    const updatedResponses = [
      ..._.filter(filteredToolResponses, response => response?.rowId !== rowId),
      ...(columnId ? [{ rowId, columnId }] : []),
    ];

    // 1. if max score is present then update it (score based rubric or standard based rubric with numeric grade scale case)
    if (maxScore) {
      let totalScoreLocal = totalScore;
      let previousTotalScoreLocal = null;
      if (!totalScoreLocal) {
        // Calculate score based on selected criteria

        totalScoreLocal = _.reduce(
          standardRubricCriterias,
          (acc, criteria) => {
            const response = _.find(updatedResponses, { rowId: criteria?.id });

            if (response?.columnId) {
              const descriptor = _.find(criteria.descriptors, {
                id: response.columnId,
              });

              return acc + Number(descriptor?.score || 0);
            }

            return acc;
          },
          0
        );

        totalScoreLocal = _.round(totalScoreLocal, 2);

        previousTotalScoreLocal = _.reduce(
          standardRubricCriterias,
          (acc, criteria) => {
            const response = _.find(filteredToolResponses, {
              rowId: criteria?.id,
            });

            if (response?.columnId) {
              const descriptor = _.find(criteria.descriptors, {
                id: response.columnId,
              });

              return acc + Number(descriptor?.score || 0);
            }

            return acc;
          },
          0
        );

        previousTotalScoreLocal = _.round(previousTotalScoreLocal, 2);
      }

      let calculatedScore = "";
      if (!_.isEmpty(updatedResponses)) {
        calculatedScore = getStandardRubricCalculatedScore({
          assessmentTool,
          calculatedScore: totalScoreLocal,
        });
      }

      const calculatedScoreFloat = parseFloat(calculatedScore);
      const calculatedScoreValue = calculatedScore
        ? _.toString(calculatedScoreFloat)
        : "";

      const previousScoreValue = getScoreValueElementRatings({
        ibPYPElementRatings,
      });

      const isScoreOveridden = !_.isEqual(
        _.toNumber(previousScoreValue),
        _.toNumber(previousTotalScoreLocal)
      );
      const isScoreValid =
        (!calculatedScore ||
          DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(calculatedScore)) &&
        (!calculatedScore || calculatedScoreFloat <= parseFloat(maxScore)) &&
        !isScoreOveridden;

      if (isScoreValid) {
        const commonScoreToolData = {
          ibPYPElementType: SCORE,
          value: calculatedScoreValue,
          academicTermId,
          source: sourceFrom,
          creatorType,
        };

        // In bulk grading (from gradebook), we need to update the score in local state
        if (isAutoSaveDisabled) {
          // Update local state for score
          const newScoreTool = {
            id: generateRandomId(),
            ibPYPElementId: null,
            academicCriteriaSet: { id: "-9999" },
            academicCriteriaValue: { id: "-9999" },
            ...commonScoreToolData,
          };

          const scoreIndex = _.findIndex(scoreElements, {
            ibPYPElementType: SCORE,
          });

          if (scoreIndex >= 0) {
            updatedScoreElements = [...scoreElements];
            updatedScoreElements.splice(scoreIndex, 1, newScoreTool);
          } else {
            updatedScoreElements = [newScoreTool];
          }
        } else {
          // for rest of the cases we need to push item to elementRatings for mutation input
          // as well as we need to update the cache

          elementRatings.push({
            parentId,
            parentType,
            createdBy: userId,
            academicCriteriaValueId: "-9999",
            academicCriteriaSetId: "-9999",
            ...commonScoreToolData,
          });

          updateScoreElementRatingInCache({
            assignmentDetailsVariables: {
              id: parentId,
              showOnlySubmitted: false,
              userFilter: "ALL",
              entityEventsFilter: { orderBy: "EVENT_TIME", orderByDir: "ASC" },
              userArchivedFilters: { academicYearId },
            },
            scoreValue: calculatedScoreValue,
            isAIResponse: creatorType === "AI",
            setIBPYPElementRatingsLocal,
          });
        }
      }
    }

    // 2. save standard from standard based rubric as element rating, also if grade scale is added then auto calculate it
    if (toolType === STANDARD_BASED_RUBRIC || toolType === SCORE_BASED_RUBRIC) {
      const setId = _.get(gradeScale, "id");
      const standard =
        _.find(standardRubricCriterias, { id: rowId })?.standard ||
        _.find(standardRubricCriterias, { id: rowId })?.benchmark;

      // if a cell is selected then columnId will have data, if a cell is unselected then columnId will be null
      if (columnId) {
        // Find the selected grade scale value
        const descriptor = _.find(
          _.find(standardRubricCriterias, { id: rowId })?.descriptors,
          { id: columnId }
        );

        const academicCriteriaValueId = descriptor?.gradeScaleValue?.id;

        if (standard && toolType === STANDARD_BASED_RUBRIC) {
          const { id, type, standardsWrapper } = standard;
          const subjectId = _.get(standardsWrapper, "standardSet.subject.id");

          // Prepare rating data
          const standardsRatingData = {
            ibPYPElementId: id,
            ibPYPElementType: isPYPCurriculum
              ? ELEMENT_TYPE_PYP_BENCHMARK
              : type,
            academicCriteriaSetId: setId,
            academicCriteriaValueId,
            academicTermId,
            source: sourceFrom,
            subjectId: isSubjectBasedGradingEnabled ? subjectId : undefined,
            learningCourseId: isCourseBasedGradingEnabled
              ? learningCourseId
              : undefined,
          };

          // In bulk grading (from gradebook), we need to update the standard learning goal in local state
          if (isAutoSaveDisabled) {
            const filteredElements = _.filter(
              otherElements,
              rating =>
                !(
                  _.get(rating, "ibPYPElementId") == id &&
                  _.get(rating, "ibPYPElementType") == type &&
                  _.get(rating, "academicCriteriaSet.id") == setId
                )
            );

            const newRating = {
              id: generateRandomId(),
              value: null,
              evaluationJustification: null,
              academicCriteriaSet: { id: setId },
              academicCriteriaValue: { id: academicCriteriaValueId },
              __typename: "IBPYPElementRating",
              ...standardsRatingData,
            };

            updatedOtherElements = [...filteredElements, newRating];
          } else {
            // for rest of the cases we need to push item to elementRatings for mutation input
            // we can skip writing to cache here because we do not show standard rating in here
            // it'll be shown in standard's gradebook

            elementRatings.push({
              parentId,
              parentType,
              createdBy: userId,
              isPublished: isEvaluated,
              ...standardsRatingData,
            });
          }
        }
      }

      if (!_.isEmpty(gradeScaleTool) && !_.isEmpty(updatedResponses)) {
        const rating = calculateGradeScaleRatingFromOtherTool({
          toolResponses: updatedResponses,
          assessmentTools,
        });

        const previousCalculatedRating = calculateGradeScaleRatingFromOtherTool(
          {
            toolResponses: filteredToolResponses,
            assessmentTools,
          }
        );

        const previousGradeScaleRating = _.find(ibPYPElementRatings, {
          ibPYPElementType: GRADE_SCALE_TOOL,
        });

        const isGradeScaleOverridden =
          previousGradeScaleRating?.academicCriteriaValue?.id !==
          previousCalculatedRating?.id;

        if (!isGradeScaleOverridden) {
          const gradeScaleRatingData = {
            ibPYPElementId: gradeScaleTool?.id,
            ibPYPElementType: GRADE_SCALE_TOOL,
            academicCriteriaSetId: gradeScaleTool?.gradeScale?.id,
            academicCriteriaValueId: rating?.id,
            academicTermId,
            source: sourceFrom,
            value: rating?.abbreviation || null,
          };

          // In bulk grading (from gradebook), we need to update the grade scale tool value in local state
          if (isAutoSaveDisabled) {
            const gradeScaleToolId = gradeScaleRatingData.ibPYPElementId;
            const gradeScaleAcademicCriteriaValueId =
              gradeScaleRatingData.academicCriteriaValueId;

            const filteredGradeScaleElements = _.filter(
              updatedOtherElements,
              rating =>
                !(
                  _.get(rating, "ibPYPElementId") == gradeScaleToolId &&
                  _.get(rating, "ibPYPElementType") == GRADE_SCALE_TOOL &&
                  _.get(rating, "academicCriteriaSet.id") ==
                    gradeScaleRatingData.academicCriteriaSetId
                )
            );

            const newGradeScaleRating = {
              id: generateRandomId(),
              value: null,
              evaluationJustification: null,
              academicCriteriaSet: {
                id: gradeScaleRatingData.academicCriteriaSetId,
                __typename: "AcademicCriteriaSet",
              },
              academicCriteriaValue: {
                id: gradeScaleAcademicCriteriaValueId,
                __typename: "AcademicCriteriaValue",
              },
              __typename: "IBPYPElementRating",
              ...gradeScaleRatingData,
            };

            updatedOtherElements = [
              ...filteredGradeScaleElements,
              newGradeScaleRating,
            ];
          } else {
            // for rest of the cases we need to push item to elementRatings for mutation input
            // as well as we need to update the cache

            elementRatings.push({
              parentId,
              parentType,
              createdBy: userId,
              isPublished: isEvaluated,
              ...gradeScaleRatingData,
            });

            const gradeScaleValues = getGradeScaleValuesFromGradeScaleTool(
              assessmentTools
            );

            // Find the grade scale value for cache update
            const gradeScaleValueForCache = _.find(gradeScaleValues, {
              id: gradeScaleRatingData.academicCriteriaValueId,
            });

            // Update grade scale rating in cache
            updateScoreElementRatingInCache({
              assignmentDetailsVariables: {
                id: parentId,
                showOnlySubmitted: false,
                userFilter: "ALL",
                entityEventsFilter: {
                  orderBy: "EVENT_TIME",
                  orderByDir: "ASC",
                },
                userArchivedFilters: { academicYearId },
              },
              scoreValue: gradeScaleRatingData.value,
              type: GRADE_SCALE_TOOL,
              academicCriteriaSet: {
                id: gradeScaleRatingData.academicCriteriaSetId || null,
                criteriaType: "GRADE_SCALE",
                isArchived: false,
                label: null,
                subType: null,
                __typename: "AcademicCriteriaSet",
              },
              academicCriteriaValue: {
                id: gradeScaleRatingData.academicCriteriaValueId || null,
                label: gradeScaleValueForCache?.label || null,
                abbreviation: gradeScaleValueForCache?.abbreviation || "",
                description: null,
                color: null,
                __typename: "AcademicCriteriaValue",
              },
              ibPYPElementId: gradeScaleRatingData.ibPYPElementId,
              academicYearId,
              setIBPYPElementRatingsLocal,
              isAIResponse: creatorType === "AI",
            });
          }
        }
      }

      // Handle deletion case (when no column is selected)
      if (!columnId) {
        // Delete the standard rating when no column is selected
        let commonDeleteArgs = {
          studentIds: actualStudentIds,
          studentId,
          parentId,
          parentType,
          sourceFrom,
          academicTermId,
          isAutoSaveDisabled,
        };

        if (isAutoSaveDisabled) {
          commonDeleteArgs = {
            ...commonDeleteArgs,
            ibPYPElementRatingsLocal,
            setIBPYPElementRatingsLocal,
          };
        }

        // Delete the standard rating when no column is selected
        if (standard && toolType === STANDARD_BASED_RUBRIC) {
          const { id, type } = standard;

          dispatch(
            deletePypElementRating({
              ...commonDeleteArgs,
              id,
              type,
              setId,
            })
          );

          // Filter updatedOtherElements to remove deleted standard rating for local state
          if (isAutoSaveDisabled) {
            updatedOtherElements = _.filter(
              updatedOtherElements,
              rating =>
                !(
                  _.get(rating, "ibPYPElementId") == id &&
                  _.get(rating, "ibPYPElementType") == type &&
                  _.get(rating, "academicCriteriaSet.id") == setId
                )
            );
          }
        }

        // when all the evaluation from standard rubric is deleted then delete grade scale tool rating
        if (!_.isEmpty(gradeScaleTool) && _.isEmpty(updatedResponses)) {
          dispatch(
            deletePypElementRating({
              ...commonDeleteArgs,
              id: gradeScaleTool.id,
              type: GRADE_SCALE_TOOL,
              setId: gradeScaleTool?.gradeScale?.id,
            })
          );

          // Filter updatedOtherElements to remove deleted grade scale tool rating for local state
          if (isAutoSaveDisabled) {
            updatedOtherElements = _.filter(
              updatedOtherElements,
              rating =>
                !(
                  _.get(rating, "ibPYPElementId") == gradeScaleTool.id &&
                  _.get(rating, "ibPYPElementType") == GRADE_SCALE_TOOL &&
                  _.get(rating, "academicCriteriaSet.id") ==
                    gradeScaleTool?.gradeScale?.id
                )
            );
          }
        }
      }
    }

    if (isAutoSaveDisabled) {
      updatedScoreElements = _.filter(
        updatedScoreElements,
        ({ value }) => !_.isEmpty(value)
      );

      setIBPYPElementRatingsLocal?.({
        ...ibPYPElementRatingsLocal,
        [parentId]: [...updatedScoreElements, ...updatedOtherElements],
      });
    } else {
      if (studentId && _.size(elementRatings) > 0) {
        const ratingsWithStudentIds = _.flatMap(elementRatings, rating =>
          _.map(actualStudentIds, id => ({ ...rating, studentId: id }))
        );

        // Set the in-progress flag synchronously so the evaluation wait-loop
        // can observe the pending mutation across the 250ms setTimeout gap.
        // The mutation thunk's finally clears it once the network call resolves.
        if (getIsMediaManagerRoute()) {
          dispatch(setElementRatingMutationInProgress(true));
        }

        setTimeout(() => {
          dispatch(
            createIbPypElementRatingsWithoutValue({
              elementRatings: ratingsWithStudentIds,
              getIsMediaManagerRoute,
              setElementRatingMutationInProgress,
            })
          );
        }, 250);
      }
    }
  };
};

export const handleIBPYPElementRatingsForGenericRubric = params => {
  return async (dispatch, getState) => {
    const {
      assessmentTool,
      rowId,
      columnId,
      toolResponses,
      isAutoSaveDisabled = false,
      parentId,
      academicTermId,
      sourceFrom = "CLASSROOM",
      ibPYPElementRatings,
      ibPYPElementRatingsLocal,
      setIBPYPElementRatingsLocal,
      studentId,
      isEvaluated,
      studentIds = [],
      totalScore,
      creatorType = "STAFF",
      assessmentTools,
      learningCourseId: learningCourseIdParam,
    } = params;

    const state = getState();
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const userType = userInfo.user_type;

    // Only staff members can update ratings
    if (userType !== "staff") return;

    const academicYearId = getSelectedAcademicYearId(state);
    const learningCourseId =
      learningCourseIdParam || getSelectedLearningCourseId(state);
    const isSubjectBasedGradingEnabled =
      !getIsLearningCoursesEnabled() || getIsSubjectBasedGradingEnabled();
    const isCourseBasedGradingEnabled = getIsCourseBasedGradingEnabled();
    const isPYPCurriculum =
      getCurrentCurriculumProgramType(state) === CURRICULUM_TYPE_PYP;

    const parentType = "STUDENT_ASSIGNMENT";
    const actualStudentIds = _.size(studentIds) ? studentIds : [studentId];

    const [scoreElements, otherElements] = _.partition(
      ibPYPElementRatings,
      rating => rating?.ibPYPElementType === SCORE
    );

    const elementRatings = []; // mutation input
    let updatedScoreElements = [...(scoreElements || [])];
    let updatedOtherElements = [...(otherElements || [])];

    const { associateScoreTool, gradeScale, standardRubricCriterias } =
      assessmentTool || {};
    const { gradingType } = gradeScale || {};

    const maxScore = _.get(associateScoreTool, "scoreToolData.maxScore", null);

    const isAlphaScale = gradingType === "ALPHA";

    const gradeScaleTool = isAlphaScale
      ? getAssessmentToolItem(assessmentTools, GRADE_SCALE_TOOL)
      : null;

    const filteredToolResponses = _.filter(
      toolResponses,
      response =>
        response?.creatorType === "STAFF" ||
        (response?.creatorType === "AI" && !response.isDeleted)
    );

    const updatedResponses = [
      ..._.filter(filteredToolResponses, response => response?.rowId !== rowId),
      ...(columnId ? [{ rowId, columnId }] : []),
    ];

    // 1. if max score is present then update it
    if (maxScore) {
      let totalScoreLocal = totalScore;
      let previousTotalScoreLocal = null;

      if (!totalScoreLocal) {
        // Calculate score based on selected criteria

        totalScoreLocal = _.reduce(
          standardRubricCriterias,
          (acc, criteria) => {
            const response = _.find(updatedResponses, { rowId: criteria?.id });

            if (response?.columnId) {
              const descriptor = _.find(criteria.descriptors, {
                id: response.columnId,
              });

              return acc + Number(descriptor?.score || 0);
            }

            return acc;
          },
          0
        );

        previousTotalScoreLocal = _.reduce(
          standardRubricCriterias,
          (acc, criteria) => {
            const response = _.find(filteredToolResponses, {
              rowId: criteria?.id,
            });

            if (response?.columnId) {
              const descriptor = _.find(criteria.descriptors, {
                id: response.columnId,
              });

              return acc + Number(descriptor?.score || 0);
            }

            return acc;
          },
          0
        );
      }

      let calculatedScore = "";
      if (!_.isEmpty(updatedResponses)) {
        calculatedScore = getStandardRubricCalculatedScore({
          assessmentTool,
          calculatedScore: totalScoreLocal,
        });
      }

      const calculatedScoreFloat = parseFloat(calculatedScore);
      const calculatedScoreValue = calculatedScore
        ? _.toString(calculatedScoreFloat)
        : "";

      const previousScoreValue = getScoreValueElementRatings({
        ibPYPElementRatings,
      });

      const isScoreOveridden = !_.isEqual(
        _.toNumber(previousScoreValue),
        _.toNumber(previousTotalScoreLocal)
      );

      const isScoreValid =
        (!calculatedScore ||
          DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(calculatedScore)) &&
        (!calculatedScore || calculatedScoreFloat <= parseFloat(maxScore)) &&
        !isScoreOveridden;

      if (isScoreValid) {
        const commonScoreToolData = {
          ibPYPElementType: SCORE,
          value: calculatedScoreValue,
          academicTermId,
          source: sourceFrom,
          creatorType,
        };

        // In bulk grading (from gradebook), we need to update the score in local state
        if (isAutoSaveDisabled) {
          // Update local state for score
          const newScoreTool = {
            id: generateRandomId(),
            ibPYPElementId: null,
            academicCriteriaSet: { id: "-9999" },
            academicCriteriaValue: { id: "-9999" },
            ...commonScoreToolData,
          };

          const scoreIndex = _.findIndex(scoreElements, {
            ibPYPElementType: SCORE,
          });

          if (scoreIndex >= 0) {
            updatedScoreElements = [...scoreElements];
            updatedScoreElements.splice(scoreIndex, 1, newScoreTool);
          } else {
            updatedScoreElements = [newScoreTool];
          }
        } else {
          // for rest of the cases we need to push item to elementRatings for mutation input
          // as well as we need to update the cache

          elementRatings.push({
            parentId,
            parentType,
            createdBy: userId,
            academicCriteriaValueId: "-9999",
            academicCriteriaSetId: "-9999",
            ...commonScoreToolData,
          });

          updateScoreElementRatingInCache({
            assignmentDetailsVariables: {
              id: parentId,
              showOnlySubmitted: false,
              userFilter: "ALL",
              entityEventsFilter: { orderBy: "EVENT_TIME", orderByDir: "ASC" },
              userArchivedFilters: { academicYearId },
            },
            scoreValue: calculatedScoreValue,
            isAIResponse: creatorType === "AI",
            setIBPYPElementRatingsLocal,
          });
        }
      }
    }

    // 2. save standard from rubric as element rating if row is mapped with standard/benchmark, also if grade scale is added then auto calculate it
    const setId = _.get(gradeScale, "id");
    const standard =
      _.find(standardRubricCriterias, { id: rowId })?.standard ||
      _.find(standardRubricCriterias, { id: rowId })?.benchmark;

    if (standard) {
      const { id, type, standardsWrapper } = standard;
      const subjectId = _.get(standardsWrapper, "standardSet.subject.id");

      // if a cell is selected then columnId will have data, if a cell is unselected then columnId will be null
      if (columnId) {
        // Find the selected grade scale value
        const descriptor = _.find(
          _.find(standardRubricCriterias, { id: rowId })?.descriptors,
          { id: columnId }
        );

        const academicCriteriaValueId = descriptor?.gradeScaleValue?.id;

        // Prepare rating data
        const standardsRatingData = {
          ibPYPElementId: id,
          ibPYPElementType: isPYPCurriculum ? ELEMENT_TYPE_PYP_BENCHMARK : type,
          academicCriteriaSetId: setId,
          academicCriteriaValueId,
          academicTermId,
          source: sourceFrom,
          subjectId: isSubjectBasedGradingEnabled ? subjectId : undefined,
          learningCourseId: isCourseBasedGradingEnabled
            ? learningCourseId
            : undefined,
        };

        // In bulk grading (from gradebook), we need to update the standard learning goal in local state
        if (isAutoSaveDisabled) {
          const filteredElements = _.filter(
            otherElements,
            rating =>
              !(
                _.get(rating, "ibPYPElementId") == id &&
                _.get(rating, "ibPYPElementType") == type &&
                _.get(rating, "academicCriteriaSet.id") == setId
              )
          );

          const newRating = {
            id: generateRandomId(),
            value: null,
            evaluationJustification: null,
            academicCriteriaSet: { id: setId },
            academicCriteriaValue: { id: academicCriteriaValueId },
            __typename: "IBPYPElementRating",
            ...standardsRatingData,
          };

          updatedOtherElements = [...filteredElements, newRating];
        } else {
          // for rest of the cases we need to push item to elementRatings for mutation input
          // we can skip writing to cache here because we do not show standard rating in here
          // it'll be shown in standard's gradebook

          elementRatings.push({
            parentId,
            parentType,
            createdBy: userId,
            isPublished: isEvaluated,
            ...standardsRatingData,
          });
        }
      }

      if (!_.isEmpty(gradeScaleTool) && !_.isEmpty(updatedResponses)) {
        const rating = calculateGradeScaleRatingFromOtherTool({
          toolResponses: updatedResponses,
          assessmentTools,
        });

        const previousCalculatedRating = calculateGradeScaleRatingFromOtherTool(
          {
            toolResponses: filteredToolResponses,
            assessmentTools,
          }
        );

        const previousGradeScaleRating = _.find(ibPYPElementRatings, {
          ibPYPElementType: GRADE_SCALE_TOOL,
        });

        const isGradeScaleOverridden =
          previousGradeScaleRating?.academicCriteriaValue?.id !==
          previousCalculatedRating?.id;

        if (!isGradeScaleOverridden) {
          const gradeScaleRatingData = {
            ibPYPElementId: gradeScaleTool?.id,
            ibPYPElementType: GRADE_SCALE_TOOL,
            academicCriteriaSetId: gradeScaleTool?.gradeScale?.id,
            academicCriteriaValueId: rating?.id,
            academicTermId,
            source: sourceFrom,
            value: rating?.abbreviation || null,
          };

          // In bulk grading (from gradebook), we need to update the grade scale tool value in local state
          if (isAutoSaveDisabled) {
            const gradeScaleToolId = gradeScaleRatingData.ibPYPElementId;
            const gradeScaleAcademicCriteriaValueId =
              gradeScaleRatingData.academicCriteriaValueId;

            const filteredGradeScaleElements = _.filter(
              updatedOtherElements,
              rating =>
                !(
                  _.get(rating, "ibPYPElementId") == gradeScaleToolId &&
                  _.get(rating, "ibPYPElementType") == GRADE_SCALE_TOOL &&
                  _.get(rating, "academicCriteriaSet.id") ==
                    gradeScaleRatingData.academicCriteriaSetId
                )
            );

            const newGradeScaleRating = {
              id: generateRandomId(),
              value: null,
              evaluationJustification: null,
              academicCriteriaSet: {
                id: gradeScaleRatingData.academicCriteriaSetId,
                __typename: "AcademicCriteriaSet",
              },
              academicCriteriaValue: {
                id: gradeScaleAcademicCriteriaValueId,
                __typename: "AcademicCriteriaValue",
              },
              __typename: "IBPYPElementRating",
              ...gradeScaleRatingData,
            };

            updatedOtherElements = [
              ...filteredGradeScaleElements,
              newGradeScaleRating,
            ];
          } else {
            // for rest of the cases we need to push item to elementRatings for mutation input
            // as well as we need to update the cache

            elementRatings.push({
              parentId,
              parentType,
              createdBy: userId,
              isPublished: isEvaluated,
              ...gradeScaleRatingData,
            });

            const gradeScaleValues = getGradeScaleValuesFromGradeScaleTool(
              assessmentTools
            );

            // Find the grade scale value for cache update
            const gradeScaleValueForCache = _.find(gradeScaleValues, {
              id: gradeScaleRatingData.academicCriteriaValueId,
            });

            // Update grade scale rating in cache
            updateScoreElementRatingInCache({
              assignmentDetailsVariables: {
                id: parentId,
                showOnlySubmitted: false,
                userFilter: "ALL",
                entityEventsFilter: {
                  orderBy: "EVENT_TIME",
                  orderByDir: "ASC",
                },
                userArchivedFilters: { academicYearId },
              },
              scoreValue: gradeScaleRatingData.value,
              type: GRADE_SCALE_TOOL,
              academicCriteriaSet: {
                id: gradeScaleRatingData.academicCriteriaSetId || null,
                academicCriteriaValues: [],
                criteriaType: "GRADE_SCALE",
                curriculumProgram: null,
                grades: [],
                isArchived: false,
                label: null,
                subType: null,
                __typename: "AcademicCriteriaSet",
              },
              academicCriteriaValue: {
                id: gradeScaleRatingData.academicCriteriaValueId || null,
                label: gradeScaleValueForCache?.label || null,
                abbreviation: gradeScaleValueForCache?.abbreviation || "",
                description: null,
                color: null,
                localGrades: [],
                scoreValues: null,
                __typename: "AcademicCriteriaValue",
              },
              ibPYPElementId: gradeScaleRatingData.ibPYPElementId,
              academicYearId,
              setIBPYPElementRatingsLocal,
              isAIResponse: creatorType === "AI",
            });
          }
        }
      }

      // Handle deletion case (when no column is selected)
      if (!columnId) {
        // Delete the standard rating when no column is selected
        dispatch(
          deletePypElementRating({
            studentIds: actualStudentIds,
            studentId,
            id,
            type,
            setId,
            parentId,
            parentType,
            ibPYPElementRatingsLocal,
            setIBPYPElementRatingsLocal,
            sourceFrom,
            academicTermId,
            isAutoSaveDisabled,
          })
        );

        // when all the evaluation from standard rubric is deleted then delete grade scale tool rating
        if (!_.isEmpty(gradeScaleTool) && _.isEmpty(updatedResponses)) {
          dispatch(
            deletePypElementRating({
              studentIds: actualStudentIds,
              studentId,
              id: gradeScaleTool.id,
              type: GRADE_SCALE_TOOL,
              setId: gradeScaleTool?.gradeScale?.id,
              parentId,
              parentType,
              ibPYPElementRatingsLocal,
              setIBPYPElementRatingsLocal,
              sourceFrom,
              academicTermId,
              isAutoSaveDisabled,
            })
          );
        }
      }
    }

    if (isAutoSaveDisabled) {
      setIBPYPElementRatingsLocal?.({
        ...ibPYPElementRatingsLocal,
        [parentId]: [...updatedScoreElements, ...updatedOtherElements],
      });
    } else {
      if (studentId && _.size(elementRatings) > 0) {
        const ratingsWithStudentIds = _.flatMap(elementRatings, rating =>
          _.map(actualStudentIds, id => ({ ...rating, studentId: id }))
        );

        // Set the in-progress flag synchronously so the evaluation wait-loop
        // can observe the pending mutation across the 250ms setTimeout gap.
        // createIbPypElementRatingV2's finally clears it once the network call resolves.
        if (getIsMediaManagerRoute()) {
          dispatch(setElementRatingMutationInProgress(true));
        }

        setTimeout(() => {
          dispatch(
            createIbPypElementRatingV2({
              elementRatings: ratingsWithStudentIds,
              getIsMediaManagerRoute,
              setElementRatingMutationInProgress,
            })
          );
        }, 250);
      }
    }
  };
};

export const onClickEvalUpdate = ({
  isEvaluated,
  isSharedWithStudent,
  isEvaluationApplicable,
  studentAssignmentId,
  changeIsLoading,
  evalStatus = "EVAL_COMPLETE",
  lockState,
  assessmentDetails,
  assignedStudents,
  assignmentId,
}) => {
  return async (dispatch, getState) => {
    try {
      // evalStatus is used to determine whether it is markEvaluated action
      // or evaluation applicable/not applicable action
      changeIsLoading(true);

      // Force any debounced score mutation (createIBPYPElementRatings) to fire
      // synchronously now. Without this, the in-progress flag below can still
      // read `false` because the mutation is sitting in a 1s debounce queue,
      // and editStudentAssignment would race ahead of it.
      flushPendingFieldUpdates();
      debouncedCreateIbPypElementRatingsWithoutValue.flush();

      // Wait for any ongoing element rating mutations to complete before proceeding
      const waitForElementRatingMutationComplete = () => {
        const MAX_WAIT_TIME = 5000;
        const POLL_INTERVAL = 200;
        const startTime = Date.now();

        return new Promise((resolve, reject) => {
          const interval = setInterval(() => {
            const elapsedTime = Date.now() - startTime;
            const isMutationInProgress = _.get(
              getState(),
              "classRoom.isElementRatingMutationInProgress",
              false
            );

            if (!isMutationInProgress) {
              clearInterval(interval);
              resolve();
              return;
            }

            // Max wait time exceeded - reject to prevent proceeding with stale data
            if (elapsedTime >= MAX_WAIT_TIME) {
              clearInterval(interval);
              reject(
                new Error(
                  "Element rating mutation is still in progress. Please try again."
                )
              );
              return;
            }
          }, POLL_INTERVAL);
        });
      };

      const isElementRatingMutationInProgress = _.get(
        getState(),
        "classRoom.isElementRatingMutationInProgress",
        false
      );

      if (isElementRatingMutationInProgress) {
        await waitForElementRatingMutationComplete();
      }

      const userInfo = getUserInfo();
      const academicYearId = getSelectedAcademicYearId(getState());
      const userType = _.get(userInfo, "user_type");
      const res = await dispatch(
        editStudentAssignment({
          id: studentAssignmentId,
          isEvaluated: isEvaluated,
          isSharedWithStudent,
          isEvaluationApplicable,
          lockState,
        })
      );
      changeIsLoading(false);

      // generate evaluation for ai tutor conversation
      if (!_.isEmpty(assignedStudents)) {
        dispatch(
          evaluateSubmissionsForAITutor({
            assignedStudents,
            assessmentDetails,
          })
        );
      }
      dispatch(getAssignmentSummaryCount(assignmentId));

      const assignmentDetailsVariables = {
        id: studentAssignmentId,
        showOnlySubmitted: false,
        userFilter: userType === "staff" ? "ALL" : "SELF",
        entityEventsFilter: { orderBy: "EVENT_TIME", orderByDir: "ASC" },
        userArchivedFilters: { academicYearId },
      };
      const cachedData =
        getStudentAssignmentDetailsFromCache(assignmentDetailsVariables) || {};

      // if unsuccessful show toast an throw error to avoid data loss and revert optimistic changes in cache
      // Update cache depending on whether it is EVAL_COMPLETE or anything else
      if (!res.successful) {
        writeStudentAssignmentDetailsInCache({
          ...assignmentDetailsVariables,
          data:
            evalStatus === "EVAL_COMPLETE"
              ? {
                  ...cachedData,
                  isEvaluated: !isEvaluated,
                  isSharedWithStudent,
                  isEvaluationApplicable,
                }
              : {
                  ...cachedData,
                  isEvaluated,
                  isSharedWithStudent,
                  isEvaluationApplicable: !isEvaluationApplicable,
                },
        });
        setToastMsg(res.errors[0]);
      } else {
        writeStudentAssignmentDetailsInCache({
          ...assignmentDetailsVariables,
          data: {
            ...cachedData,
            isEvaluated,
            isSharedWithStudent,
            isEvaluationApplicable,
          },
        });
      }
    } catch (e) {
      console.error(e);
      changeIsLoading(false);
    }
  };
};

export const getAssessmentObj = params => {
  const {
    curriculumType,
    assessmentValue,
    contentType,
    curriculumId: curriculumIdParam,
    isVisibleInGlobalSearch = false,
  } = params;
  return (dispatch, getState) => {
    const state = getState();

    const curriculumId = curriculumIdParam || getSelectedCurriculumId(state);
    if (assessmentValue) {
      const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();
      if (isAssessmentTypeConfigurationEnabled) {
        return getDynamicAssignmentTypeMapping({
          assessmentValue,
          curriculumId,
        });
      }

      const currentAssessmentTypes = dispatch(
        getCurrentAssessmentTypes({
          curriculumType,
          curriculumId,
          isVisibleInGlobalSearch,
        })
      );

      const {
        localeLabel,
        label: nonLocalisedLabel,
        avatarIconColor = "neutral",
      } = _.get(currentAssessmentTypes, assessmentValue) || {};

      let assessmentTypeObj = {};
      switch (curriculumType) {
        case CURRICULUM_TYPE_MYP:
        case CURRICULUM_TYPE_DP:
          if (_.includes(EXCLUDED_ASSESSMENT_TYPES, assessmentValue)) {
            return {
              typeLabel: "common:practical_activities",
              nonLocalisedLabel,
              avatarIconColor,
            };
          }
          assessmentTypeObj = _.get(
            MYP_ASSIGNMENT_TYPE_MAPPING,
            `${assessmentValue}`,
            {}
          );
          break;
        case CURRICULUM_TYPE_UBD:
          assessmentTypeObj = _.get(
            UBD_ASSIGNMENT_TYPE_MAPPING,
            `${assessmentValue}`,
            {}
          );
          break;
        default:
          assessmentTypeObj = _.get(
            PYP_ASSIGNMENT_TYPE_MAPPING,
            `${assessmentValue}`,
            {}
          );
          break;
      }

      if (_.isEmpty(assessmentTypeObj)) {
        const assessmentTypeLabel = localeLabel || "common:assessment_label";

        assessmentTypeObj = {
          typeLabel: assessmentTypeLabel,
          avatarIconColor,
          nonLocalisedLabel,
        };
      }
      return { ...assessmentTypeObj, nonLocalisedLabel, avatarIconColor };
    } else {
      return _.get(ASSIGNMENT_TYPE_MAPPING, `${contentType}`, {});
    }
  };
};

export const getSortedStudents = params => {
  return (dispatch, getState) => {
    const { students = [], sortOptions } = params;
    const { order, direction, value, sortEntity } = sortOptions || {};
    const _sortOrder = order || direction || "asc";
    const _sortEntity = value || sortEntity || "FIRST_NAME";

    if (_.isEqual(_sortEntity, "FULL_NAME")) {
      // For FULL_NAME sorting, use getFormattedUserName to get the complete formatted name
      const sortingFunction = student => {
        let userObj = {};
        userObj = student;
        if (student?.student) {
          userObj = student?.student;
        }
        const fullName = getFormattedUserName({
          user: userObj,
          type: "student",
        });

        // removes diacritical marks (accents) from letters
        // e.g. María -> Maria, Æneid smörgåsbord -> Aeneid smorgasbord Frederic
        return _.deburr(_.toLower(fullName));
      };

      return _.orderBy(students, [sortingFunction], [_sortOrder]);
    }

    const defaultStudentNameOrderPreference = getCleanDefaultStudentNameOrderPreference();

    const sortPreference = [
      _sortEntity,
      ..._.filter(
        defaultStudentNameOrderPreference,
        order => order !== _sortEntity
      ),
    ];

    const sortingFunction = _.map(
      sortPreference,
      (preference, index) => student => {
        let name = "";
        name = _.get(student, _.camelCase(preference), "");

        // assignStudents has student object inside it (in case of all submissions)
        if (student?.student) {
          name = _.get(student, `student.${_.camelCase(preference)}`, "");
        }

        // removes diacritical marks (accents) from letters
        // e.g. María -> Maria, Æneid smörgåsbord -> Aeneid smorgasbord Frederic
        return _.deburr(_.toLower(name));
      }
    );

    // ensures all entity (e.g., FIRST_NAME, LAST_NAME, MIDDLE_NAME) are sorted
    // with the same asc or desc order based on the value of _order
    const sortOrders = _.map(sortPreference, () => _sortOrder);
    return _.orderBy(students, sortingFunction, sortOrders);
  };
};

export const getAssignedStudents = id => {
  return async dispatch => {
    try {
      const result = await client.query({
        query: getAssignedStudentsQuery,
        variables: {
          id,
        },
        fetchPolicy: "network-only",
      });

      return _.get(result, "data.node", []);
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const getAssignmentSummaryCount = id => {
  return async dispatch => {
    try {
      const result = await client.query({
        query: getAssignmentSummaryCountQuery,
        variables: {
          id,
        },
        fetchPolicy: "network-only",
      });

      return _.get(result, "data.node", []);
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const getStaffCoursesBasicDetails = params => {
  return async dispatch => {
    try {
      const result = await client.query({
        query: getStaffCoursesV2BasicDetailsQuery,
        variables: getStaffCourseDetailsQueryVariables(params),
        fetchPolicy: "network-only",
      });

      const queryData = _.get(result, "data.node", {});
      const staffCourseEdges = _.get(queryData, "coursesV2.edges", []);
      const staffCourses = _.map(staffCourseEdges, ({ node }) => node);
      const filteredStaffCourses = getFilteredCoursesBasedOnViewOrManagePermission(
        {
          courses: staffCourses,
          permissionsToCheck: getAssignmentConsumingParentModulesPermission(
            "MANAGE"
          ),
        }
      );

      return filteredStaffCourses;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return [];
    }
  };
};

export const getLearningCourseDetails = ({ learningCourseId, portalType }) => {
  return async dispatch => {
    try {
      const result = await client.query({
        query: getLearningCourseDetailsQuery,
        variables: {
          learningCourseId,
          portalType,
        },
        fetchPolicy: "network-only",
      });

      return _.get(result, "data.node", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const checkIsStaffHasClassAccess = ({
  courseIdToCheck,
  userDesignation,
}) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();

      const variables = getUserCoursesVars({
        userInfo: getUserInfo(),
        platform: _.get(state, "platform"),
        isCurriculumProgramFree: getCurriculumProgramFreeStatus({ state }),
      });
      _.set(variables, "filters.fetchOnlyMappedCourses", false);

      const result = await client.query({
        query: getUserCoursesV2BasicDetailsQuery,
        variables,
        fetchPolicy: "network-only",
      });

      const courseData = _.get(result, "data.node", {});
      const courseEdges = _.get(courseData, "coursesV2.edges", []);
      const userCourses = _.map(courseEdges, ({ node }) => node?.id);

      const isNotUserCourse =
        userDesignation !== "Visitor" &&
        !_.includes(userCourses, courseIdToCheck);

      if (isNotUserCourse) {
        dispatch(setToastMsg("toastMsgs:restrict_teacher_access_to_the_class"));
        dispatch(goToBack());
      }
    } catch (err) {}
  };
};

export const updateBulkAssignmentGradeRatings = variables => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: bulkAssignmentGradeRatingsMutation,
        variables,
      });

      const isSuccess = _.get(
        response,
        "data.platform.bulkAssignmentGradeRatings.isSuccess"
      );

      if (!isSuccess) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return false;
      }

      return true;
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }

      return false;
    }
  };
};

const _handleAsessmentToolUpdateInCache = ({
  parentId,
  parentType,
  studentId,
  assignmentId,
  assessmentToolId,
  source,
  rowId,
  columnId,
  creatorType,
  inputText,
  isDeleteAiRatings,
  assessmentToolType,
  toolResponses,
  isAcceptAllForTool,
}) => {
  return dispatch => {
    const assessmentToolResponse = [];
    const assessmentToolResponseIds = [];

    if (isAcceptAllForTool) {
      _.forEach(toolResponses, toolResponse => {
        const {
          id,
          creatorType: creatorTypeLocal,
          rowId: rowIdLocal,
          columnId: columnIdLocal,
          subjectiveResponse,
          isDeleted,
        } = toolResponse;

        if (creatorTypeLocal !== "AI" || isDeleted) return;

        assessmentToolResponse.push({
          rowId: rowIdLocal,
          columnId: columnIdLocal,
          subjectiveResponse,
        });

        assessmentToolResponseIds.push(id);

        dispatch(
          handleAssessmentToolResponseInCache({
            parentId,
            parentType,
            rowId: rowIdLocal,
            columnId: columnIdLocal,
            studentId,
            type: assessmentToolType,
            creatorType,
            assignmentId,
            sourceFrom: source,
            assessmentToolId,
            isDeleteAiRatings,
            subjectiveResponse,
            isToolResponsesV2: true,
          })
        );
      });
    } else {
      assessmentToolResponse.push({
        rowId,
        columnId,
        subjectiveResponse: inputText,
      });

      const assessmentToolResponseId = _.find(
        toolResponses,
        response =>
          response.rowId === rowId &&
          response.columnId === columnId &&
          response.creatorType === "AI"
      )?.id;

      assessmentToolResponseIds.push(assessmentToolResponseId);

      dispatch(
        handleAssessmentToolResponseInCache({
          parentId,
          parentType,
          rowId,
          columnId,
          studentId,
          type: assessmentToolType,
          creatorType,
          assignmentId,
          sourceFrom: source,
          assessmentToolId,
          isDeleteAiRatings,
          subjectiveResponse: inputText,
          isToolResponsesV2: true,
        })
      );
    }

    return {
      assessmentToolResponse,
      assessmentToolResponseIds,
    };
  };
};

// Creates staff ratings for the AI responses
const handleCacheUpdateForPYPElementRatings = ({
  ibPYPElementRatings,
  parentId,
  userFilter,
  academicTermId,
  academicYearId,
  shouldWriteToCache = true,
  pypElementsToConsider = [
    "MYP_OBJECTIVES",
    "DP_CRITERIA",
    SCORE,
    ASSESSMENT_GRADE_BOUNDARY,
    ...RATED_LEARNING_GOALS_ELEMENT_TYPE,
  ],
  source = "CLASSROOM",
  standardBasedRubricParams = {},
  learningCourseId: learningCourseIdParam,
}) => {
  return (dispatch, getState) => {
    const state = getState();

    // mutation variables
    const ibPYPElementRatingIds = [];
    const ibPYPElementRatingsForMutation = [];

    const studentAssignmentDetails = getStudentAssignmentDetailsFromCache({
      id: parentId,
      showOnlySubmitted: false,
      userFilter,
      entityEventsFilter: {
        orderBy: "EVENT_TIME",
        orderByDir: "ASC",
      },
      userArchivedFilters: { academicYearId },
    });

    // variables
    const newStaffRatings = [];
    const staffToUpdateIndexValueMap = {};

    // mark ai responses isDeleted to true,
    // and create staff ratings for that ai selection
    let updatedIBPYPElementRatingsForCache = _.map(
      ibPYPElementRatings,
      element => {
        const {
          id,
          ibPYPElementId,
          ibPYPElementType,
          creatorType,
          isDeleted,
          value,
          academicCriteriaSet,
          academicCriteriaValue,
        } = element;

        const isPYPElementToConsider = _.includes(
          pypElementsToConsider,
          ibPYPElementType
        );

        if (creatorType !== "AI" || isDeleted || !isPYPElementToConsider)
          return element;

        const isMYPObjectives = ibPYPElementType === "MYP_OBJECTIVES";
        const isScore = ibPYPElementType === SCORE;
        const isRatedLearningGoal = _.includes(
          RATED_LEARNING_GOALS_ELEMENT_TYPE,
          ibPYPElementType
        );
        const isAssessmentGradeBoundary =
          ibPYPElementType === ASSESSMENT_GRADE_BOUNDARY;

        let staffRatingIndex;
        if (isScore) {
          staffRatingIndex = _.findIndex(ibPYPElementRatings, {
            ibPYPElementType: SCORE,
            creatorType: "STAFF",
          });
        } else if (isRatedLearningGoal) {
          staffRatingIndex = _.findIndex(
            ibPYPElementRatings,
            rating =>
              rating?.ibPYPElementId === ibPYPElementId &&
              rating?.academicCriteriaSet?.id === academicCriteriaSet?.id &&
              rating?.academicCriteriaValue?.id === academicCriteriaValue?.id &&
              rating?.creatorType === "STAFF"
          );
        } else {
          staffRatingIndex = _.findIndex(ibPYPElementRatings, {
            ibPYPElementId,
            creatorType: "STAFF",
          });
        }

        // if staff rating already exists for that ibPYPElementId,
        // store it in staffToUpdateIndexValueMap
        // else create a new staff rating to update it later
        if (staffRatingIndex !== -1) {
          staffToUpdateIndexValueMap[staffRatingIndex] =
            isMYPObjectives || isAssessmentGradeBoundary || isRatedLearningGoal
              ? academicCriteriaValue
              : value;
        } else {
          const staffRating = {
            ...element,
            id: generateRandomId(),
            evaluationJustification: null,
            source,
            creatorType: "STAFF",
            __typename: "IBPYPElementRating",
          };

          newStaffRatings.push(staffRating);
        }

        // push to mutation variables
        ibPYPElementRatingIds.push(id);
        ibPYPElementRatingsForMutation.push(
          _.pickBy(
            {
              academicTermId,
              ibPYPElementId,
              ibPYPElementType,
              academicCriteriaSetId: academicCriteriaSet?.id,
              academicCriteriaValueId: academicCriteriaValue?.id,
              value,
            },
            value => !_.isEmpty(value)
          )
        );

        return {
          ...element,
          isDeleted: true,
        };
      }
    );

    if (!_.isEmpty(standardBasedRubricParams)) {
      const { assessmentTool, toolResponses } = standardBasedRubricParams;
      const aiSelectedToolResponses = _.filter(toolResponses, {
        creatorType: "AI",
        isDeleted: false,
      });

      const { gradeScale, standardRubricCriterias } = assessmentTool || {};
      const setId = _.get(gradeScale, "id");

      _.forEach(aiSelectedToolResponses, toolResponse => {
        const { rowId, columnId } = toolResponse;

        const standard =
          _.find(standardRubricCriterias, { id: rowId })?.standard ||
          _.find(standardRubricCriterias, { id: rowId })?.benchmark;

        if (!standard) return;

        const { id, type, standardsWrapper } = standard;
        const subjectId = _.get(standardsWrapper, "standardSet.subject.id");

        // Find the selected grade scale value
        const descriptor = _.find(
          _.find(standardRubricCriterias, { id: rowId })?.descriptors,
          { id: columnId }
        );

        const academicCriteriaValueId = descriptor?.gradeScaleValue?.id;

        const learningCourseId =
          learningCourseIdParam || getSelectedLearningCourseId(state);
        const isSubjectBasedGradingEnabled =
          !getIsLearningCoursesEnabled() || getIsSubjectBasedGradingEnabled();
        const isCourseBasedGradingEnabled = getIsCourseBasedGradingEnabled();

        const isPYPCurriculum =
          getCurrentCurriculumProgramType(state) === CURRICULUM_TYPE_PYP;

        ibPYPElementRatingsForMutation.push({
          ibPYPElementId: id,
          ibPYPElementType: isPYPCurriculum ? ELEMENT_TYPE_PYP_BENCHMARK : type,
          academicCriteriaSetId: setId,
          academicCriteriaValueId,
          academicTermId,
          subjectId: isSubjectBasedGradingEnabled ? subjectId : undefined,
          learningCourseId: isCourseBasedGradingEnabled
            ? learningCourseId
            : undefined,
        });
      });
    }

    // update the staff ratings that co-exists with ai response
    _.forEach(staffToUpdateIndexValueMap, (value, staffIndex) => {
      const elementType = _.get(updatedIBPYPElementRatingsForCache, [
        staffIndex,
        "ibPYPElementType",
      ]);

      const isRatedLearningGoal = _.includes(
        RATED_LEARNING_GOALS_ELEMENT_TYPE,
        elementType
      );

      if (
        elementType === "MYP_OBJECTIVES" ||
        elementType === ASSESSMENT_GRADE_BOUNDARY ||
        isRatedLearningGoal
      ) {
        // For other types (like MYP_OBJECTIVES), update academicCriteriaValue
        updatedIBPYPElementRatingsForCache = update(
          updatedIBPYPElementRatingsForCache,
          {
            [staffIndex]: {
              academicCriteriaValue: { $set: value },
            },
          }
        );
      } else {
        // For DP criteria and SCORE, update the value property
        updatedIBPYPElementRatingsForCache = update(
          updatedIBPYPElementRatingsForCache,
          {
            [staffIndex]: {
              value: { $set: value },
            },
          }
        );
      }
    });

    // add the new staff ratings for the ai responses
    updatedIBPYPElementRatingsForCache = [
      ...updatedIBPYPElementRatingsForCache,
      ...newStaffRatings,
    ];

    // write it to the cache
    const updatedData = {
      ...studentAssignmentDetails,
      ibPYPElementRatings: updatedIBPYPElementRatingsForCache,
    };

    if (shouldWriteToCache) {
      writeStudentAssignmentDetailsInCache({
        id: parentId,
        showOnlySubmitted: false,
        userFilter,
        entityEventsFilter: {
          orderBy: "EVENT_TIME",
          orderByDir: "ASC",
        },
        data: updatedData,
        userArchivedFilters: { academicYearId },
      });
    }

    return {
      ibPYPElementRatingIds,
      ibPYPElementRatingsForMutation,
      updatedIBPYPElementRatingsForCache,
    };
  };
};

const showAIEvaluationApprovalToastMsg = ({ assessmentToolText }) => {
  return dispatch => {
    dispatch(
      setToastMsg({
        msg: "ai:ai_evaluation_approved",
        locale_params: [
          { key: "label", value: assessmentToolText, isPlainText: false },
        ],
        type: "success",
      })
    );
  };
};

export const acceptAIResponseForAssessmentTools = ({
  assignmentId,
  isOverride = true,
  source = "CLASSROOM",
  assessmentToolType,
  assessmentToolId,
  creatorType = "STAFF",
  isDeleteAiRatings = true,
  ibPYPElementRatings,
  assessmentToolResponse,
  elementRemarks,
  studentAssignmentIds,
  inputText,
  parentId,
  parentType = "STUDENT_ASSIGNMENT",
  studentId,
  rowId,
  academicYearId,
  columnId,
  isAcceptAllForTool = false,
  toolResponses,
  assignmentDetailsVariables,
  toolResponsesDataLocal,
  setToolResponsesDataLocal,
  ibPypElementId,
  ibPYPElementType,
  assessmentToolText,
  academicTermId,
  academicCriteriaSetId,
  academicCriteriaValueId,
  assessmentTool,
  shouldUpdateScoreInCache = false,
  isEvaluated,
  learningCourseId,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    const createdBy = getUserId(getState());
    const userFilter = userType == "staff" ? "ALL" : "SELF";

    // if not provided then calculate it
    if (!assignmentDetailsVariables) {
      const userArchivedFilters = { academicYearId };

      assignmentDetailsVariables = {
        id: parentId,
        showOnlySubmitted: false,
        userFilter: userType === "staff" ? "ALL" : "SELF",
        entityEventsFilter: { orderBy: "EVENT_TIME", orderByDir: "ASC" },
        userArchivedFilters,
      };
    }

    const commonBulkAssignmentVariable = {
      assignmentId,
      isOverride,
      assessmentToolType,
      source,
      createdBy,
      isPublished: isEvaluated,
      academicTermId,
      assessmentToolId,
      creatorType,
      studentAssignmentIds,
    };

    const deleteRatingsFilter = {
      isDeleteAllAiRatings: false,
    };

    let isSuccess = false;

    switch (assessmentToolType) {
      case COMMENT: {
        updateTeacherRemarkInCache({
          assignmentDetailsVariables,
          message: inputText,
          creatorType,
          isDeleteAiRatings,
        });

        const ibPYPElementRemarkIds = _.compact([
          _.find(elementRemarks, {
            creatorType: "AI",
            ibPYPElementType: "STUDENT_ASSIGNMENT",
          })?.id,
        ]);

        const _elementRemarks = {
          message: inputText,
        };

        isSuccess = await dispatch(
          updateBulkAssignmentGradeRatings({
            ratings: [
              {
                ...commonBulkAssignmentVariable,
                deleteRatingsFilter: {
                  ...deleteRatingsFilter,
                  ibPYPElementRemarkIds,
                },
                elementRemarks: _elementRemarks,
              },
            ],
          })
        );

        break;
      }
      case SINGLE_POINT_RUBRIC: {
        let updatedToolResponseData;
        if (_.isFunction(setToolResponsesDataLocal)) {
          updatedToolResponseData = handleLocalToolResponseUpdate({
            parentId,
            assessmentToolType,
            isDeleteAiRatings,
            assessmentToolId,
            toolResponsesDataLocal,
            setToolResponsesDataLocal,
            isAcceptAllForTool,
            rowId,
            columnId,
            creatorType,
            inputText,
          });
        } else {
          updatedToolResponseData = dispatch(
            _handleAsessmentToolUpdateInCache({
              parentId,
              parentType,
              studentId,
              assignmentId,
              assessmentToolId,
              source,
              rowId,
              columnId,
              creatorType,
              inputText,
              isDeleteAiRatings,
              assessmentToolType,
              toolResponses,
              isAcceptAllForTool,
            })
          );
        }

        const { assessmentToolResponse, assessmentToolResponseIds } =
          updatedToolResponseData || {};

        isSuccess = await dispatch(
          updateBulkAssignmentGradeRatings({
            ratings: [
              {
                ...commonBulkAssignmentVariable,
                deleteRatingsFilter: {
                  ...deleteRatingsFilter,
                  assessmentToolResponseIds: _.compact(
                    assessmentToolResponseIds
                  ),
                },
                assessmentToolResponse,
              },
            ],
          })
        );

        break;
      }
      case RUBRIC:
      case CHECKLIST:
      case SCORE_BASED_RUBRIC:
      case STANDARD_BASED_RUBRIC:
      case MYP_OBJECTIVE_RUBRIC:
      case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
        // mutation variables
        let assessmentToolResponse = [];
        let ibPYPElementRatingIds = [];

        let assessmentToolResponseIds = [];
        let ibPYPElementRatingsForMutation = [];

        const hasOnlyToolResponses = _.includes(
          [RUBRIC, CHECKLIST],
          assessmentToolType
        );

        if (isAcceptAllForTool) {
          // 1. update cache and get mutation variables for tool responses
          const {
            assessmentToolResponse: _assessmentToolResponse,
            assessmentToolResponseIds: _assessmentToolResponseIds,
          } = dispatch(
            _handleAsessmentToolUpdateInCache({
              parentId,
              parentType,
              studentId,
              assignmentId,
              assessmentToolId,
              source,
              rowId,
              columnId,
              creatorType,
              inputText,
              isDeleteAiRatings,
              assessmentToolType,
              toolResponses,
              isAcceptAllForTool,
            })
          );

          assessmentToolResponse = _assessmentToolResponse;
          assessmentToolResponseIds = _assessmentToolResponseIds;

          // 2. Update cache and get mutation variables for pyp element ratings
          if (!hasOnlyToolResponses) {
            const standardBasedRubricParams = {
              assessmentTool,
              toolResponses,
            };
            const {
              ibPYPElementRatingIds: _ibPYPElementRatingIds,
              ibPYPElementRatingsForMutation: _ibPYPElementRatingsForMutation,
            } = dispatch(
              handleCacheUpdateForPYPElementRatings({
                ibPYPElementRatings,
                parentId,
                userFilter,
                academicYearId,
                academicTermId,
                standardBasedRubricParams,
                source,
                learningCourseId,
                pypElementsToConsider: [
                  TOOL_TYPE_TO_ELEMENT_TYPE_MAPPING[assessmentToolType],
                ],
              })
            );

            ibPYPElementRatingIds = _ibPYPElementRatingIds;
            ibPYPElementRatingsForMutation = _ibPYPElementRatingsForMutation;
          }
        } else {
          // cache update is handled for individual updates
          // so, get mutation variables for tool responses and MYP objectives

          // 1. get mutation variables for tool responses
          const toolResponseId = _.find(
            toolResponses,
            response =>
              response.rowId === rowId && response.creatorType === "AI"
          )?.id;

          if (toolResponseId) {
            assessmentToolResponseIds.push(toolResponseId);
          }

          if (rowId && columnId) {
            assessmentToolResponse.push({
              rowId,
              columnId,
            });
          }

          // 2. get mutation variables for MYP objectives
          if (academicCriteriaSetId && academicCriteriaValueId) {
            ibPYPElementRatingsForMutation.push({
              academicTermId,
              ibPYPElementId: ibPypElementId,
              ibPYPElementType: "MYP_OBJECTIVES",
              academicCriteriaSetId,
              academicCriteriaValueId,
            });

            const id = _.find(ibPYPElementRatings, element => {
              return (
                element.ibPYPElementId === ibPypElementId &&
                element.ibPYPElementType === "MYP_OBJECTIVES" &&
                element.creatorType === "AI" &&
                element.isDeleted === false &&
                !element.id?.includes("NEW_")
              );
            })?.id;

            if (id) {
              ibPYPElementRatingIds.push(id);
            }
          }

          // get mutation variables for score based rubric or standard based rubric
          if (
            _.includes(
              [SCORE_BASED_RUBRIC, STANDARD_BASED_RUBRIC],
              assessmentToolType
            )
          ) {
            const scoreRating = _.find(ibPYPElementRatings, {
              ibPYPElementType: "SCORE",
              creatorType: "AI",
              isDeleted: false,
            });

            ibPYPElementRatingIds.push(scoreRating?.id);
          }
        }

        // run bulk mutation
        isSuccess = await dispatch(
          updateBulkAssignmentGradeRatings({
            ratings: [
              {
                ...commonBulkAssignmentVariable,
                deleteRatingsFilter: {
                  ...deleteRatingsFilter,
                  assessmentToolResponseIds: _.compact(
                    assessmentToolResponseIds
                  ),
                  ibPypElementRatingIds: _.compact(ibPYPElementRatingIds),
                },
                assessmentToolResponse,
                ibPYPElementRatings: ibPYPElementRatingsForMutation,
              },
            ],
          })
        );

        break;
      }
      case SCORE: {
        const scoreRating = _.find(ibPYPElementRatings, {
          ibPYPElementType: "SCORE",
          creatorType: "AI",
          isDeleted: false,
        });

        const ibPYPElementRatingIds = [];
        const ibPYPElementRatingsForMutation = [
          {
            academicTermId,
            ibPYPElementType: "SCORE",
            value: scoreRating?.value,
            academicCriteriaSetId: "-9999",
            academicCriteriaValueId: "-9999",
          },
        ];

        ibPYPElementRatingIds.push(scoreRating?.id);

        updateScoreElementRatingInCache({
          assignmentDetailsVariables,
          scoreValue: scoreRating?.value,
          isDeleteAiRatings,
        });

        isSuccess = await dispatch(
          updateBulkAssignmentGradeRatings({
            ratings: [
              {
                ...commonBulkAssignmentVariable,
                deleteRatingsFilter: {
                  ...deleteRatingsFilter,
                  ibPypElementRatingIds: _.compact(ibPYPElementRatingIds),
                },
                ibPYPElementRatings: ibPYPElementRatingsForMutation,
              },
            ],
          })
        );

        break;
      }
      case ASSESSMENT_GRADE_BOUNDARY:
      case DP_ASSESSMENT_RUBRIC: {
        let ibPYPElementRatingIds = [];
        let ibPYPElementRatingsForMutation = [];

        if (isAcceptAllForTool || shouldUpdateScoreInCache) {
          const {
            ibPYPElementRatingIds: _ibPYPElementRatingIds,
            ibPYPElementRatingsForMutation: _ibPYPElementRatingsForMutation,
          } = dispatch(
            handleCacheUpdateForPYPElementRatings({
              ibPYPElementRatings,
              parentId,
              userFilter,
              academicTermId,
              source,
              academicYearId,
              learningCourseId,
              pypElementsToConsider: [
                TOOL_TYPE_TO_ELEMENT_TYPE_MAPPING[assessmentToolType],
              ],
            })
          );

          ibPYPElementRatingIds = _ibPYPElementRatingIds;
          ibPYPElementRatingsForMutation = _ibPYPElementRatingsForMutation;
        } else {
          const id = _.find(ibPYPElementRatings, element => {
            return (
              element.ibPYPElementId === ibPypElementId &&
              element.ibPYPElementType === ibPYPElementType &&
              element.creatorType === "AI" &&
              element.isDeleted === false
            );
          })?.id;

          ibPYPElementRatingIds.push(id);
        }

        // handle bulk mutation here
        isSuccess = await dispatch(
          updateBulkAssignmentGradeRatings({
            ratings: [
              {
                ...commonBulkAssignmentVariable,
                deleteRatingsFilter: {
                  ...deleteRatingsFilter,
                  ibPypElementRatingIds: _.compact(ibPYPElementRatingIds),
                },
                assessmentToolResponse,
                ibPYPElementRatings: ibPYPElementRatingsForMutation,
              },
            ],
          })
        );

        break;
      }
      default:
        break;
    }

    // show toast message
    if (isSuccess) {
      const showToastMsgOnClick = _.includes(
        [COMMENT, SCORE],
        assessmentToolType
      );

      if (showToastMsgOnClick || isAcceptAllForTool) {
        dispatch(
          addAssignmentActivity({
            assignmentId,
            activities: [
              {
                type: "STUDENT_ASSIGNMENT_ACTIVITY",
                itemType: "AI_EVALUATION_ASSESSMENT_TOOL_APPROVE_ACTIVITY",
                metadata: { messageBuild: { toolType: assessmentToolType } },
              },
            ],
            studentIds: [studentId],
          })
        );
        dispatch(showAIEvaluationApprovalToastMsg({ assessmentToolText }));
      }
    }
  };
};

export const getToddleDocAttachmentV2 = variables => {
  return async dispatch => {
    try {
      const response = await client.query({
        query: getToddleDocAttachmentQueryV2,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      if (e) dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const handleQuickApproveAIEvaluation = ({
  assignmentId,
  academicTermId,
  currentStudentData,
  assessmentTools,
  learningCourseId,
}) => {
  return async (dispatch, getState) => {
    const {
      id: parentId,
      elementRemarks,
      toolResponses,
      isEvaluated,
    } = currentStudentData;

    const studentId = _.get(currentStudentData, "student.id");

    // redux state vars
    const userInfo = getUserInfo();
    const { user_type: userType, id: userId } = userInfo || {};
    const userFilter = userType == "staff" ? "ALL" : "SELF";
    const academicYearId = getSelectedAcademicYearId(getState());

    // mutation vars
    const assessmentToolResponseIdsForMutation = [];
    const assessmentToolResponseForMutation = [];

    const commonBulkVariables = {
      assignmentId,
      isOverride: true,
      source: "CLASSROOM",
      creatorType: "STAFF",
      createdBy: userId,
      isPublished: isEvaluated,
      academicTermId,
      studentAssignmentIds: [parentId],
      deleteRatingsFilter: {
        isDeleteAllAiRatings: true,
      },
    };

    const promises = [];

    try {
      // 1. Handle element remarks
      const {
        updatedElementRemarksForCache,
        elementRemarksForMutation,
      } = processAIRemarkApproval({ elementRemarks });

      if (!_.isEmpty(elementRemarksForMutation)) {
        const commentPromise = dispatch(
          updateBulkAssignmentGradeRatings({
            ratings: [
              {
                ...commonBulkVariables,
                assessmentToolType: COMMENT,
                elementRemarks: elementRemarksForMutation,
              },
            ],
          })
        );

        promises.push(commentPromise);
      }

      // 2. Handle tool responses
      _.forEach(toolResponses, toolResponse => {
        const {
          toolId,
          toolType,
          toolResponses: toolResponseForCurrentTool,
        } = toolResponse;

        // update cache for tool response
        const {
          assessmentToolResponse: assessmentToolResponseForTool,
          assessmentToolResponseIds: assessmentToolResponseIdsForTool,
        } = dispatch(
          _handleAsessmentToolUpdateInCache({
            parentId,
            parentType: "STUDENT_ASSIGNMENT",
            studentId,
            assessmentToolType: toolType,
            creatorType: "STAFF",
            assignmentId,
            source: "CLASSROOM",
            toolResponses: toolResponseForCurrentTool,
            assessmentToolId: toolId,
            isDeleteAiRatings: true,
            isAcceptAllForTool: true,
          })
        );

        // handled comment above
        if (
          !_.isEmpty(assessmentToolResponseForTool) &&
          toolType !== "COMMENT"
        ) {
          const toolResponsePromise = dispatch(
            updateBulkAssignmentGradeRatings({
              ratings: [
                {
                  ...commonBulkVariables,
                  assessmentToolType: toolType,
                  assessmentToolResponse: assessmentToolResponseForTool,
                },
              ],
            })
          );

          promises.push(toolResponsePromise);
        }

        // mutation variables for bulk mutation
        assessmentToolResponseForMutation.push(
          ...assessmentToolResponseForTool
        );

        assessmentToolResponseIdsForMutation.push(
          ...assessmentToolResponseIdsForTool
        );
      });

      const assessmentToolEvaluationDetails = getStudentAssignmentDetailsFromCache(
        {
          id: parentId,
          showOnlySubmitted: false,
          userFilter,
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          userArchivedFilters: { academicYearId },
        }
      );

      // 3. Handle element ratings
      const { ibPYPElementRatings } = assessmentToolEvaluationDetails;

      // Get the  assessment tool item of type standard_based_rubric
      const node = _.find(
        assessmentTools?.edges,
        ({ node }) => node?.assessmentToolType === "STANDARD_BASED_RUBRIC"
      )?.node;

      const standardBasedRubricAssessmentTool = _.get(
        node,
        "assessmentToolItem"
      );

      const standardBasedRubricParams = {
        assessmentTool: standardBasedRubricAssessmentTool,
        toolResponses:
          _.find(toolResponses, { toolType: STANDARD_BASED_RUBRIC })
            ?.toolResponses || [],
      };

      const {
        updatedIBPYPElementRatingsForCache,
        ibPYPElementRatingsForMutation,
      } = dispatch(
        handleCacheUpdateForPYPElementRatings({
          ibPYPElementRatings,
          parentId,
          userFilter,
          source: "CLASSROOM",
          academicYearId,
          academicTermId,
          shouldWriteToCache: false,
          standardBasedRubricParams,
          learningCourseId,
        })
      );

      writeStudentAssignmentDetailsInCache({
        id: parentId,
        showOnlySubmitted: false,
        userFilter,
        entityEventsFilter: {
          orderBy: "EVENT_TIME",
          orderByDir: "ASC",
        },
        data: {
          ...assessmentToolEvaluationDetails,
          elementRemarks: updatedElementRemarksForCache,
          ibPYPElementRatings: updatedIBPYPElementRatingsForCache,
        },
        userArchivedFilters: { academicYearId },
      });

      // group the ibPYPElementRatingsForMutation by ibPYPElementType
      const groupedIBPYPElementRatingsForMutation = _.groupBy(
        ibPYPElementRatingsForMutation,
        "ibPYPElementType"
      );

      _.map(
        groupedIBPYPElementRatingsForMutation,
        (ibPYPElementRatingsForMutation, ibPYPElementType) => {
          if (ibPYPElementType === "MYP_OBJECTIVES") {
            const mypObjectivePromise = dispatch(
              updateBulkAssignmentGradeRatings({
                ratings: [
                  {
                    ...commonBulkVariables,
                    assessmentToolType: MYP_OBJECTIVE_RUBRIC,
                    ibPYPElementRatings: ibPYPElementRatingsForMutation,
                  },
                ],
              })
            );

            promises.push(mypObjectivePromise);
          } else if (
            ibPYPElementType === "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC"
          ) {
            const mypInterdisciplinaryPromise = dispatch(
              updateBulkAssignmentGradeRatings({
                ratings: [
                  {
                    ...commonBulkVariables,
                    assessmentToolType: MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
                    ibPYPElementRatings: ibPYPElementRatingsForMutation,
                  },
                ],
              })
            );

            promises.push(mypInterdisciplinaryPromise);
          } else {
            const isStandardBasedRubricAssessmentTool = _.some(
              assessmentTools?.edges,
              ({ node }) => {
                return (
                  node?.assessmentToolType === STANDARD_BASED_RUBRIC &&
                  _.some(
                    node?.assessmentToolItem?.standardRubricCriterias,
                    standardRubric =>
                      ibPYPElementRatingsForMutation[0]?.ibPYPElementId ===
                      (standardRubric?.standard?.id ||
                        standardRubric?.benchmark?.id)
                  )
                );
              }
            );

            const isStandardBasedRubric =
              _.includes(ibPYPElementType, "LEARNING_STANDARD") &&
              isStandardBasedRubricAssessmentTool;

            let toolType =
              ibPYPElementType === "DP_CRITERIA"
                ? DP_ASSESSMENT_RUBRIC
                : isStandardBasedRubric
                ? STANDARD_BASED_RUBRIC
                : ibPYPElementType;

            if (
              _.includes(RATED_LEARNING_GOALS_ELEMENT_TYPE, ibPYPElementType)
            ) {
              toolType = "LEARNING_GOALS";
            }

            const promise = dispatch(
              updateBulkAssignmentGradeRatings({
                ratings: [
                  {
                    ...commonBulkVariables,
                    assessmentToolType: toolType,
                    ibPYPElementRatings: ibPYPElementRatingsForMutation,
                  },
                ],
              })
            );

            promises.push(promise);
          }
        }
      );
      await Promise.all(promises);
      if (
        _.some(
          _.get(currentStudentData, "submission.attachmentGroups"),
          grp => _.get(grp, "attachments.[0].type") === "TODDLE_DOC"
        )
      ) {
        const studentAssignmentId = _.get(currentStudentData, "id");
        const params = new URLSearchParams(window.location.search);
        const attachmentId = params.get("currentMedia");

        if (!_.isEmpty(studentAssignmentId)) {
          await dispatch(
            bulkUpdateToddleDocComments({
              studentAssignmentIds: _.castArray(studentAssignmentId),
            })
          );
        }
        if (attachmentId) {
          await dispatch(
            getToddleDocAttachmentV2({
              id: attachmentId,
              filters: { mode: "EDIT" },
              state: "ALL",
            })
          );
        }
      }

      dispatch(
        addAssignmentActivity({
          assignmentId,
          activities: [
            {
              type: "STUDENT_ASSIGNMENT_ACTIVITY",
              itemType: "AI_EVALUATION_QUICK_APPROVE_ACTIVITY",
            },
          ],
          studentIds: [studentId],
        })
      );

      dispatch(
        setToastMsg({
          msg: "ai:ai_evaluation_quick_approved_for_submission",
          type: "success",
        })
      );
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const acceptAIResponseForLearningGoals = ({
  isOverride = true,
  isAcceptAllForTool = false,
  ibPypElementId,
  parentId,
  ibPYPElementType,
  academicTermId,
  academicYearId,
  source = "CLASSROOM",
  ibPYPElementRatings,
  assignmentId,
  creatorType = "STAFF",
  studentAssignmentIds,
  learningGoalLabel,
  academicCriteriaSetId,
  pypElementsToConsider,
  learningCourseId,
  isEvaluated,
}) => {
  return async dispatch => {
    const userInfo = getUserInfo();
    const createdBy = userInfo.id;
    const userType = userInfo.user_type;
    const userFilter = userType == "staff" ? "ALL" : "SELF";

    const commonBulkAssignmentVariable = {
      assignmentId,
      isOverride,
      source,
      createdBy,
      creatorType,
      isPublished: isEvaluated,
      academicTermId,
      studentAssignmentIds,
      assessmentToolType: "LEARNING_GOALS",
    };

    const deleteRatingsFilter = {
      isDeleteAllAiRatings: false,
    };

    let isSuccess = false;

    let ibPYPElementRatingIds = [];
    let ibPYPElementRatingsForMutation = [];

    if (isAcceptAllForTool) {
      const {
        ibPYPElementRatingIds: _ibPYPElementRatingIds,
        ibPYPElementRatingsForMutation: _ibPYPElementRatingsForMutation,
      } = dispatch(
        handleCacheUpdateForPYPElementRatings({
          ibPYPElementRatings,
          parentId,
          userFilter,
          academicTermId,
          academicYearId,
          source,
          pypElementsToConsider,
          learningCourseId,
        })
      );

      ibPYPElementRatingIds = _ibPYPElementRatingIds;
      ibPYPElementRatingsForMutation = _ibPYPElementRatingsForMutation;
    } else {
      switch (ibPYPElementType) {
        case "ATL":
        case "BENCHMARK":
        case "MYP_ATL":
        case "CONCEPT":
        case "DP_CRITERIA":
        case "DP_EE":
        case "DP_LEARNER_PROFILE":
        case "DP_OBJECTIVES":
        case "LEARNER_PROFILE":
        case "MYP_LEARNER_PROFILE":
        case "MYP_LEARNING_STANDARD":
        case "MYP_SUBJECT":
        case "UBD_ATL":
        case "UBD_LEARNING_STANDARD":
        case "UBD_SUBJECT":
        case "DP_SUBJECT_STANDARD":
        case "DP_SUBJECT":
        case "DP_ATL":
          {
            const id = _.find(ibPYPElementRatings, element => {
              return (
                element.ibPYPElementId === ibPypElementId &&
                element.ibPYPElementType === ibPYPElementType &&
                element.academicCriteriaSet?.id === academicCriteriaSetId &&
                element.creatorType === "AI" &&
                element.isDeleted === false
              );
            })?.id;

            ibPYPElementRatingIds.push(id);
          }
          break;
        default:
          break;
      }
    }

    // handle bulk mutation here
    isSuccess = await dispatch(
      updateBulkAssignmentGradeRatings({
        ratings: [
          {
            ...commonBulkAssignmentVariable,
            deleteRatingsFilter: {
              ...deleteRatingsFilter,
              ibPypElementRatingIds: _.compact(ibPYPElementRatingIds),
            },
            ibPYPElementRatings: ibPYPElementRatingsForMutation,
          },
        ],
      })
    );

    // show toast message
    if (isSuccess) {
      if (isAcceptAllForTool) {
        dispatch(
          showAIEvaluationApprovalToastMsg({
            assessmentToolText: learningGoalLabel,
          })
        );
      }
    }
  };
};

export const updateLockedState = ({
  assessmentId,
  assessmentType,
  isLocked,
  hasConflict,
  t,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const learningCourseId = getSelectedLearningCourseId(state);

    const variables = {
      input: {
        learningCourseId,
        lockType: "CONTENT_LEVEL_LOCK",
        lockScope: "SELF",
        entityLocks: [
          {
            entityId: assessmentId,
            entityType: "ASSESSMENT",
            isLocked,
          },
        ],
      },
    };

    const assessmentDetails = getAssessmentLinkedAssignmentsFromCache({
      id: assessmentId,
    });
    const updatedAssessmentDetails = {
      ...assessmentDetails,
      lockingInfo: {
        isLocked,
      },
    };

    writeAssessmentLinkedAssignmentsInCache({
      variables: {
        id: assessmentId,
      },
      data: { node: updatedAssessmentDetails },
    });

    const assessmentTypes = dispatch(getCurrentAssessmentTypes());
    const { localeLabel, label: nonLocalisedLabel } =
      _.get(assessmentTypes, assessmentType) || {};
    const assessmentTypeLabel = t(localeLabel) || nonLocalisedLabel;
    const lockingAction = isLocked ? t("common:locked") : t("common:unlocked");
    const dispatchLockingActionErrorToast = () =>
      dispatch(
        setToastMsg({
          msg: t("course:locking_action_error_toast", {
            entityType: assessmentTypeLabel,
            lockingAction,
          }),
          notString: true,
          type: "warning",
        })
      );

    try {
      const res = await client.mutate({
        mutation: updateLockedStateMutation,
        variables,
      });

      const isSuccess = _.get(
        res,
        "data.planner.bulkUpdateLearningCourseEntityLock.isSuccess"
      );
      if (isSuccess) {
        const useSkip =
          isLocked && getIsBlueprintSyncHistoryV2Enabled() && hasConflict;
        const toastLocale = useSkip
          ? "course:locking_action_item_toast_skip"
          : "course:locking_action_item_toast";
        dispatch(
          setToastMsg({
            msg: t(toastLocale, {
              lockingAction,
              entityType: assessmentTypeLabel,
            }),
            notString: true,
            type: "success",
            position: "toast-bottom-left",
          })
        );
      } else {
        writeAssessmentLinkedAssignmentsInCache({
          variables: {
            id: assessmentId,
          },
          data: { node: assessmentDetails },
        });
        dispatchLockingActionErrorToast();
      }
    } catch (e) {
      writeAssessmentLinkedAssignmentsInCache({
        variables: {
          id: assessmentId,
        },
        data: { node: assessmentDetails },
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatchLockingActionErrorToast();
      }
    }
  };
};

export const validateAIEvaluationEligibility = ({ t, assessmentDetails }) => {
  return async dispatch => {
    const { allFields, templateId } = assessmentDetails || {};

    const template = getPlannerTemplateFromCache(
      { ids: _.compact([templateId]) },
      true
    );

    const isAIEvaluationEnabled = _.get(
      _.find(allFields, { uid: "aiEvaluation" }),
      "value",
      false
    );

    if (!isAIEvaluationEnabled) return { isValid: true };

    // Extract field values
    const hasDescription = _.get(template, "0.body.field_list.description");

    const descriptionFieldValue = _.get(
      _.find(allFields, { uid: "description" }),
      "value",
      ""
    );

    const isLinkValid = await dispatch(
      validateAssessmentLink({
        assessmentId: _.get(assessmentDetails, "id"),
      })
    );

    const ltiTemplates = _.get(
      _.find(allFields, { uid: "ltiTemplate" }),
      "resolvedMinimalTree.attachmentGroups",
      []
    );

    const studentTemplates = _.get(
      _.find(allFields, { uid: "studentTemplate" }),
      "resolvedMinimalTree.attachmentGroups",
      []
    );

    const isEditingSameTemplate = _.some(studentTemplates, template =>
      _.some(
        template?.attachments,
        attachment => attachment?.metadata?.permission === "edit"
      )
    );

    // Validation rules
    const validationRules = [
      {
        condition: () => hasDescription && _.isEmpty(descriptionFieldValue),
        issue: "missing_description",
      },
      {
        condition: () => !isLinkValid,
        issue: "invalid_link",
      },
      {
        condition: () => _.size(ltiTemplates) > 0,
        issue: "lti_tool_not_supported",
      },
      {
        condition: () => isEditingSameTemplate,
        issue: "editing_same_template_not_supported",
      },
    ];

    const issues = _(validationRules)
      .filter(rule => rule.condition())
      .map("issue")
      .value();

    if (_.isEmpty(issues)) {
      return { isValid: true };
    }

    // Issue mapping
    const issueConfig = {
      missing_description: {
        title: "ai:missing_description_title",
        description: "ai:missing_description_message",
        listDescription: "ai:missing_description_list_msg",
      },
      invalid_link: {
        title: "ai:invalid_link_title",
        description: "ai:invalid_link_message",
        listDescription: "ai:invalid_link_list_msg",
      },
      lti_tool_not_supported: {
        title: "ai:lti_tool_not_supported_title",
        description: "ai:lti_tool_not_supported_message",
        listDescription: "ai:lti_tool_not_supported_list_msg",
      },
      editing_same_template_not_supported: {
        title: "ai:resolve_error_to_use_ai_evaluation",
        description: "ai:editing_same_template_error_description",
        listDescription: "ai:editing_same_template_error_list_msg",
      },
    };

    // Single issue response
    if (_.size(issues) === 1) {
      const issue = _.head(issues);
      const config = issueConfig[issue];

      return {
        isValid: false,
        title: t(config?.title),
        description: t(config?.description),
      };
    }

    // Multiple issues response
    const issueDescriptions = _(issues)
      .map(issue => `- ${t(issueConfig[issue].listDescription)}`)
      .join("\n");

    const multipleIssuesDescription = `${t(
      "ai:multiple_missing_field_message"
    )}\n ${issueDescriptions}`;

    return {
      isValid: false,
      title: t("ai:multiple_missing_field_title"),
      description: multipleIssuesDescription,
    };
  };
};

/**
 * Re-fetches a updated gradebook assignment and updates the cache.
 * @param {string} id - The ID of the gradebook assignment to refetch.
 * @param {function} getState - Function to get the current state.
 * @returns
 */
export const refetchGradebookAssignmentAndUpdateCache = ({ id }) => {
  return async (dispatch, getState) => {
    if (_.isEmpty(id)) return null;

    const state = getState();
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const organizationId = _.get(state, "login.userInfo.org_id");
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );
    const curriculumType = _.get(
      state,
      "platform.currentCurriculumProgram.type"
    );
    const filters = _.get(state, "gradebook.assessmentsFilters", {});
    const gradebookSelectedTermAcademicYearId = _.get(
      state,
      "gradebook.selectedAcademicYearId"
    );
    const showSameSubjectGradeTasksInGradebook = ACLStore.can(
      "FeatureFlag:ShowSameSubjectGradeTasksInGradebook"
    );
    const primaryGradeId = getCoursePrimaryGradeIdFromCache({
      courseId,
      gradebookSelectedTermAcademicYearId,
      selectedAcademicYearId: academicYearId,
    });
    const isHideTasksExcludedFromTermTotal = getSettingValue({
      name: "HideTasksExcludedFromTermTotalInGradebook",
      currentCurriculumProgramId: curriculumProgramId,
    });
    const isHideTasksFromOtherClasses = getSettingValue({
      name: "HideTasksFromOtherClassesInGradebook",
      currentCurriculumProgramId: curriculumProgramId,
    });
    const categoryIds = _.get(state, "gradebook.categoryIds", []);
    const learningCourseId = getSelectedLearningCourseId(state);
    const isAssessmentGradebookHeaderEnhancements = ACLStore.can(
      "FeatureFlag:AssessmentGradebookHeaderEnhancements"
    );
    const gradebookDisplaySettings = _.get(
      state,
      "gradebook.displaySettings",
      {}
    );
    const { viewBy } = filters;
    const isCategoriesView = isAssessmentGradebookHeaderEnhancements
      ? getIsGroupByCategoryView(gradebookDisplaySettings)
      : viewBy === "CATEGORIES";

    try {
      // * Prepare variables to get gradebook assignments from cache
      const variables = getGradebookAssignmentsVariables({
        learningCourseId,
        courseId,
        filters,
        organizationId,
        curriculumType,
        primaryGradeId,
        showSameSubjectGradeTasksInGradebook,
        isHideTasksFromOtherClasses,
        isHideTasksExcludedFromTermTotal,
        shouldGroupByCategories: isCategoriesView,
        categoryIds,
        displaySettings: gradebookDisplaySettings,
        isAssessmentGradebookHeaderEnhancements,
        curriculumProgramId,
      });

      // * Fetch the updated gradebook assignment
      const singleAssignmentResponse = await client.query({
        query: getGradebookSingleAssignmentQuery,
        variables: {
          id,
          ..._.pick(variables, [
            "assessmentToolsFilters",
            "aclControlParametersFilters",
          ]),
        },
        context: { useHttpLink: true },
      });
      const assignmentNode = _.get(singleAssignmentResponse, "data.node", null);
      if (_.isEmpty(assignmentNode)) return null; // * if no data returned

      // * Get existing gradebook assignment data from cache
      const organizationData = getGradebookAssignmentsFromCache({ variables });
      if (_.isEmpty(organizationData)) return null; // * if no data in cache

      // * Finding assignment in existing cache and updating it
      const edges = _.get(organizationData, "assignments.edges", []);
      const updatedEdges = _.map(edges, edge => {
        if (_.get(edge, "node.id") === id) {
          return { ...edge, node: { ...edge.node, ...assignmentNode } };
        }
        return edge;
      });

      // * Preparing updated organization data with modified assignment node
      const updatedOrganizationData = {
        ...organizationData,
        assignments: { ...organizationData.assignments, edges: updatedEdges },
      };

      // * Update cache with modified gradebook assignment data
      writeGradebookAssignmentsToCache({
        variables: variables,
        data: updatedOrganizationData,
      });

      return assignmentNode;
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      return null;
    }
  };
};

export const createShortUrl = ({ input }) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createShortUrlMutation,
        variables: {
          input,
        },
      });
      return _.get(response, "data.platform.createShortUrl.shortUrl", null);
    } catch (e) {
      dispatchError({ dispatch, e });
      return null;
    }
  };
};

export const bulkUpdateToddleDocComments = ({ studentAssignmentIds }) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: bulkUpdateToddleDocMessagesMutation,
        variables: {
          input: { studentAssignmentIds },
        },
      });
      return _.get(response, "data.platform", null);
    } catch (e) {
      dispatchError({ dispatch, e });
      return null;
    }
  };
};

const debouncedCreateIbPypElementRatingsWithoutValue = _.debounce(
  (dispatch, params) => {
    dispatch(createIbPypElementRatingsWithoutValue(params));
  },
  1000
);

export const getToddleDocValue = variables => {
  return async dispatch => {
    try {
      const response = await client.query({
        query: getToddleDocValueQuery,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      if (e) dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

// Auto-generated exports
export {
  updateStateForAssignmentWithRefetch,
  updateStateForAssignmentWithCacheUpdate,
  _handleAsessmentToolUpdateInCache,
  handleCacheUpdateForPYPElementRatings,
  showAIEvaluationApprovalToastMsg,
};
